webpackJsonp([1],{

/***/ "+k1v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("aAJt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "20kk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Kcd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5OsU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("EbSk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"fleetuse","version":"1.4.6","description":"Fleetuse Manager","author":"Kristian Luczycki <krisluc@gmail.com>","private":true,"scripts":{"dev":"webpack-dev-server --inline --progress --config build/webpack.dev.conf.js","start":"npm run dev","build":"node build/build.js"},"dependencies":{"ajv":"^6.3.0","apexcharts":"^1.2.3","axios":"^0.18.1","chart.js":"^2.7.3","chartjs":"^0.3.24","fuse.js":"^3.2.1","moment":"^2.20.1","pdfvuer":"^1.1.0","save":"^2.3.2","uppload-vue":"^0.5.0","vue":"^2.6.3","vue-chartjs":"^3.2.1","vue-fuse":"^1.5.2","vue-pdf":"^4.0.6","vue-pull-refresh":"^0.2.7","vue-router":"^3.0.1","vue-status-indicator":"^1.1.0","vue-underscore":"^0.1.4","vue-wysiwyg":"^1.6.0","vue2-google-maps":"^0.8.8","vuetify":"^1.5.12"},"devDependencies":{"autoprefixer":"^7.2.6","babel-core":"^6.26.3","babel-loader":"^7.1.3","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.7.0","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.3.1","copy-webpack-plugin":"^4.4.2","css-loader":"^0.28.10","eventsource-polyfill":"^0.9.6","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.9","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","node-notifier":"^5.2.1","sass":"^1.93.2","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.4.0","portfinder":"^1.0.13","postcss-import":"^11.1.0","postcss-loader":"^2.1.1","rimraf":"^2.6.0","sass-loader":"^7.3.1","semver":"^5.5.0","shelljs":"^0.7.6","style-loader":"^0.19.1","url-loader":"^0.5.8","vue-loader":"^13.7.1","vue-style-loader":"^3.1.2","vue-template-compiler":"^2.6.3","webpack":"^3.11.0","webpack-bundle-analyzer":"^2.11.0","webpack-dev-server":"^2.11.5","webpack-merge":"^4.1.2"},"engines":{"node":">=16 <17","npm":">=8 <9"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8W9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Y90":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8m7h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AG2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "As5s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CIeh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CcX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYAg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "EbSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IQUy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jbl/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jg4l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/radar.9846869.png";

/***/ }),

/***/ "K48z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mmbf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var utils_namespaceObject = {};
__webpack_require__.d(utils_namespaceObject, "getData", function() { return utils_getData; });
__webpack_require__.d(utils_namespaceObject, "fetchData", function() { return fetchData; });
__webpack_require__.d(utils_namespaceObject, "setData", function() { return setData; });
__webpack_require__.d(utils_namespaceObject, "getFormattedDate", function() { return getFormattedDate; });
__webpack_require__.d(utils_namespaceObject, "getFormattedAmount", function() { return getFormattedAmount; });
__webpack_require__.d(utils_namespaceObject, "getDayDescription", function() { return getDayDescription; });
__webpack_require__.d(utils_namespaceObject, "getUnitImage", function() { return getUnitImage; });
__webpack_require__.d(utils_namespaceObject, "getPaidOptions", function() { return getPaidOptions; });
__webpack_require__.d(utils_namespaceObject, "getPaidDescriptions", function() { return getPaidDescriptions; });
__webpack_require__.d(utils_namespaceObject, "setPlaceHolder", function() { return setPlaceHolder; });
__webpack_require__.d(utils_namespaceObject, "getMonths", function() { return getMonths; });
__webpack_require__.d(utils_namespaceObject, "getMonth", function() { return getMonth; });
__webpack_require__.d(utils_namespaceObject, "getSettings", function() { return utils_getSettings; });
__webpack_require__.d(utils_namespaceObject, "getTimestamp", function() { return getTimestamp; });
__webpack_require__.d(utils_namespaceObject, "getFullDate", function() { return getFullDate; });
__webpack_require__.d(utils_namespaceObject, "saveSettings", function() { return utils_saveSettings; });
__webpack_require__.d(utils_namespaceObject, "checkEmailAddress", function() { return checkEmailAddress; });
__webpack_require__.d(utils_namespaceObject, "capitalizeFirstLetter", function() { return capitalizeFirstLetter; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__("7YgM");
var package_default = /*#__PURE__*/__webpack_require__.n(package_0);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/utils/utils.js





function errorResponseHandler(error) {
	// check for errorHandle config
	if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
		return promise_default.a.reject(error);
	}

	// if has response show the error
	if (error.response) {
		if (error.response.statusText) {
			window.emitter.$emit('showToastMessage', {
				msg: error.response.statusText,
				type: 'error'
			});
			if (error.response.status === 401) {
				window.location.href = 'login';
			}
		}
	}
}

// apply interceptor on response
axios_default.a.interceptors.response.use(function (response) {
	return response;
}, errorResponseHandler);

function utils_getData(url) {
	var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'POST';

	var data = {};
	var token = localStorage.getItem('b');
	saveTimestamp();
	if (token) {
		data.b = token;
	}

	// Get the data
	var xhrPromise = new promise_default.a(function (resolve, reject) {
		return axios_default.a.post(url, stringify_default()(data)).then(function (response) {
			if (response.data) {
				resolve(response && response.data);
			} else {
				reject();
			}
		}).catch(function (error) {});
	});

	return xhrPromise;
}

function fetchData(url) {
	var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'POST';

	var data = {};
	var token = localStorage.getItem('b');
	saveTimestamp();
	if (token) {
		data.b = token;
	}

	var myInit = {
		method: method,
		mode: 'cors',
		cache: 'default'
	};

	if (method === 'POST') {
		myInit['body'] = stringify_default()(data);
	}

	return fetch(url, myInit).then(function (response) {
		var contentType = response.headers.get("content-type");

		if (response.status === 401) {
			window.location = '#/logout';
			return {
				data: null
			};
		}

		if (contentType && contentType.includes("application/json")) {
			return response.json();
		}
		throw new TypeError("Oops, we haven't got JSON!");
	}).then(function (json) {
		return json;
	}).catch(function (error) {
		console.log(error);
	});
}

function setData(url, data) {

	var token = localStorage.getItem('b');
	saveTimestamp();

	if (token) {
		data.b = token;
	}

	// Get the data
	var xhrPromise = new promise_default.a(function (resolve, reject) {
		axios_default.a.post(url, stringify_default()(data)).then(function (response) {
			if (response && response.data) {
				resolve(response.data);
			} else {
				reject();
			}
		});
	});
	return xhrPromise;
}

function getFormattedDate(date, showHours) {
	return date ? moment_default()(date).format('DD-MM-YYYY' + (showHours ? ' HH:mm' : '')) : '';
}

function getFormattedAmount(amount) {
	if (amount) {
		amount = parseFloat(amount).toFixed(2);
		amount = String(amount);
		return amount.replace('.', ',');
	} else {
		return '';
	}
}

function getDayDescription(date, checkIfToday) {
	var days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
	var momentDate = moment_default()(date);
	if (checkIfToday) {
		var iscurrentDate = momentDate.isSame(new Date(), "day");
		if (iscurrentDate) {
			return 'Vandaag';
		}
	}

	var day = momentDate.weekday();
	return days[day];
}

function getUnitImage(unitId) {
	return window.baseUrl + 'uploads/' + unitId + '.jpg?id=' + Date.now();
}

function getPaidOptions() {
	return [{
		text: 'Openstaand',
		value: '0'
	}, {
		text: 'iDeal',
		value: '1'
	}, {
		text: 'Overschrijving',
		value: '2'
	}, {
		text: 'Contant',
		value: '3'
	}, {
		text: 'Verrekend met borg',
		value: '4'
	}];
}

function getPaidDescriptions() {
	return [{
		text: 'Controleer',
		value: '-1'
	}, {
		text: 'Openstaand',
		value: '0'
	}, {
		text: 'iDeal',
		value: '1'
	}, {
		text: 'Overschrijving',
		value: '2'
	}, {
		text: 'Contant',
		value: '3'
	}, {
		text: 'Verrekend met borg',
		value: '4'
	}];
}

function setPlaceHolder(unit) {
	unit.img_small = "http://www.carmag.co.za/carmag/wp-content/themes/car_mag/public/img/placeholder-291x382.png";
}
function getMonths(showOnlyOccured) {
	var maandArray = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
	if (showOnlyOccured) {
		var d = new Date();
		var n = d.getMonth();
		return maandArray.slice(0, n + 1);
	} else {
		return maandArray;
	}
}
function getMonth(index) {
	var maandArray = getMonths();
	return maandArray[index];
}

function utils_getSettings(key) {
	var settingsJson = localStorage.getItem('settings');
	var settings = {};
	if (!settingsJson) {

		settings = {
			animation: 'scale-transition'
		};
	} else {
		settings = JSON.parse(settingsJson);
	}

	if (key) {
		return settings[key];
	} else {
		return settings;
	}
}

function getTimestamp() {
	return new Date().getTime();
}

function getSavedTimestamp() {
	return localStorage.getItem('ats');
}

function saveTimestamp() {
	if (getTimestamp() - getSavedTimestamp() > 60000) {
		localStorage.setItem('ats', getTimestamp());
		console.log('ts saved');
	}
}

function getFullDate(selectedDate) {
	return moment_default()(selectedDate).format("DD-MM-YYYY") + " (" + getDayDescription(selectedDate) + ")";
}

function utils_saveSettings(settings) {
	var settings = localStorage.setItem('settings', stringify_default()(settings));
}

function checkEmailAddress(email) {
	return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
	);
}

function capitalizeFirstLetter(string) {
	if (string.search(/ /) <= 0) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	} else {
		return string.charAt(0).toLowerCase() + string.slice(1);
	}
}
// EXTERNAL MODULE: ./node_modules/vue-underscore/index.js + 160 modules
var vue_underscore = __webpack_require__("rNNc");

// EXTERNAL MODULE: ./node_modules/vue-status-indicator/dist/vue-status-indicator.esm.js
var vue_status_indicator_esm = __webpack_require__("odLt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/UnitsMap.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UnitsMap = ({
	name: 'UnitsMap',
	components: { StatusIndicator: vue_status_indicator_esm["a" /* StatusIndicator */] },
	props: ['showMap'],
	data: function data() {
		return {
			showMaps: false,
			markers: [],
			infoWinOpen: false,
			drawer: false,
			utils: utils_namespaceObject,
			units: [],
			itv: null,
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoContent: '',
			currentMidx: 0,
			styles: [{ elementType: 'geometry', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] }, {
				featureType: 'administrative.locality',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [{ color: '#263c3f' }]
			}, {
				featureType: 'poi.park',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#6b9a76' }]
			}, {
				featureType: 'road',
				elementType: 'geometry',
				stylers: [{ color: '#38414e' }]
			}, {
				featureType: 'road',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#212a37' }]
			}, {
				featureType: 'road',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#9ca5b3' }]
			}, {
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [{ color: '#746855' }]
			}, {
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#1f2835' }]
			}, {
				featureType: 'road.highway',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#f3d19c' }]
			}, {
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [{ color: '#2f3948' }]
			}, {
				featureType: 'transit.station',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{ color: '#17263c' }]
			}, {
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#515c6d' }]
			}, {
				featureType: 'water',
				elementType: 'labels.text.stroke',
				stylers: [{ color: '#17263c' }]
			}],
			items: [{ title: 'Home', icon: 'dashboard' }, { title: 'About', icon: 'question_answer' }],
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			themeLight: true,
			selectedReservation: {},
			mapCenter: { lat: 53.177388, lng: 5.417791 }
		};
	},
	created: function created() {
		if (this.showMap) {
			this.setMarkers();
		}
	},

	methods: {
		closeMap: function closeMap() {
			window.emitter.$emit('closeMap');
		},
		setMarkers: function setMarkers() {
			var self = this;
			//if (!self.units.length && !self.markers.length) {
			utils_getData(basePath + 'api/rentunits/getUnits/0').then(function (response) {
				if (!self.units.length && !self.markers.length) {
					self.units = response.data;
					for (var i = 0; i < self.units.length; i++) {
						var unit = self.units[i];
						if (unit.pos) {
							var unitPos = { lat: unit.pos.y, lng: unit.pos.x };
							var text = unit.name + ' ' + unit.license + '(' + unit.pos.s + ' km/u)';
							var content = text;
							if (unit.inRent) {
								var rentData = unit.rentData[0];
								content += '<br/>' + rentData.startDate + ' t/m ' + rentData.endDate + '. door: ' + rentData.lastname;
							}

							self.markers.push({
								position: unitPos,
								title: text,
								rentData: rentData,
								id: unit.unitId,
								speed: parseInt(unit.pos.s),
								inRent: unit.inRent,
								class: 'labelClass'
							});
						}
					}
				} else {
					self.updateMarkers(response.data);
				}
			});
			//}
		},

		updateMarkers: function updateMarkers(updatedUnits) {
			var self = this;
			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.pos) {
					var unitPos = { lat: unit.pos.y, lng: unit.pos.x };
					var marker = vue_underscore["a" /* _ */].findWhere(self.markers, { id: unit.unitId });
					marker.position = unitPos;
					marker.speed = String(unit.pos.s);
				}
			}
		},
		updateMarkersFromEvents: function updateMarkersFromEvents(updatedUnits) {
			var self = this;
			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					var unitPos = { lat: unit.d.pos.y, lng: unit.d.pos.x };
					var marker = vue_underscore["a" /* _ */].findWhere(self.markers, { id: String(unit.i) });
					if (marker) {
						marker.position = unitPos;
						marker.speed = String(unit.d.pos.s);
					}
				}
			}
		},
		toggleInfoWindow: function toggleInfoWindow(marker, idx, event) {
			this.infoWindowPos = marker.position;
			this.mapCenter = marker.position;
			this.infoContent = marker.content;
			this.selectedReservation.title = marker.title;
			if (marker.inRent) {
				this.selectedReservation.startDate = marker.rentData.startDate;
				this.selectedReservation.endDate = marker.rentData.endDate;
				this.selectedReservation.inRent = marker.inRent;
				this.selectedReservation.user = marker.rentData.firstname + ' ' + marker.rentData.lastname;
				this.selectedReservation.action = '';
			} else {
				this.selectedReservation.action = marker.speed == 0 ? ' - Geparkeerd' : '';
			}

			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
					this.infoWinOpen = true;
					this.currentMidx = idx;
				}

			return true;
		},
		getPos: function getPos(val) {
			//console.log(val.latLng.lat())
		},
		getEvents: function getEvents() {
			this.setMarkers();
		},
		setPlaceHolder: function setPlaceHolder(item) {
			item.avatar = true;
		}
	},
	watch: {
		showMap: function showMap(newValue) {
			var self = this;
			this.themeLight = localStorage.getItem('theme') === 'light' || !localStorage.getItem('theme') ? true : false;
			if (newValue) {
				var self = this;
				setTimeout(function () {
					self.showMaps = true;
					self.setMarkers();
					window.emitter.$on('newEvents', function (data) {
						self.updateMarkersFromEvents(data);
					});
				}, 500);

				/*   self.itv = setInterval(function() {
          self.setMarkers();
        }, 20000); */
			} else {
				if (self.itv) {
					clearInterval(self.itv);
				}
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-774afc53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/UnitsMap.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","display":"flex","height":"100%"}},[(_vm.units)?_c('v-navigation-drawer',{staticClass:"light-blue lighten-5 elevation-5",staticStyle:{"position":"fixed"},attrs:{"floating":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.units),function(item,index){return _c('v-list-tile',{key:item.unitId,on:{"click":function($event){}}},[_c('v-list-tile-avatar',[(item.inRent)?_c('status-indicator',{staticClass:"left",staticStyle:{"transform":"translate(20px,5px)","position":"absolute"},attrs:{"positive":"","pulse":""}}):_vm._e(),_vm._v(" "),(!item.avatar)?_c('img',{attrs:{"src":item.img_small},on:{"error":function($event){return _vm.setPlaceHolder(item)}}}):_vm._e(),_vm._v(" "),(item.avatar)?_c('v-icon',[_vm._v("directions_car")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.toggleInfoWindow(_vm.markers[index], index, $event);
						_vm.drawer = false;}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name)+" "+_vm._s(item.license)+" ("+_vm._s(item.pos.s)+"\n\t\t\t\t\t\tkm/u)")])],1)],1)}),1),_vm._v(" "),_c('v-btn',{attrs:{"color":"info","flat":""},on:{"click":function($event){_vm.drawer = false}}},[_vm._v("Sluiten")])],1):_vm._e(),_vm._v(" "),(true)?_c('gmap-map',{staticStyle:{"width":"100%","flex":"1"},attrs:{"center":_vm.mapCenter,"zoom":7,"map-type-id":"terrain","options":{
			gestureHandling: 'greedy',
			styles: !_vm.themeLight ? _vm.styles : []
		}},on:{"click":_vm.getPos}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen,"content":_vm.infoContent},on:{"closeclick":function($event){_vm.infoWinOpen = false}}},[_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v("directions_car")]),_vm._v("\n\t\t\t"+_vm._s(_vm.selectedReservation.title)+" "+_vm._s(_vm.selectedReservation.action)+"\n\t\t\t"),_c('br'),_vm._v(" "),(_vm.selectedReservation.inRent)?_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedReservation.startDate)+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedReservation.endDate)+"\n\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedReservation.user)+"\n\t\t\t")]):_vm._e()],1),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,staticClass:"labelClass",attrs:{"position":m.position,"clickable":true,"label":m.label},on:{"click":function($event){return _vm.toggleInfoWindow(m, index, $event)}}})})],2):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"bottom":"20px"},attrs:{"color":"blue","dark":"","absolute":"","bottom":"","left":"","fab":""},on:{"click":function($event){_vm.drawer = !_vm.drawer}}},[_c('v-icon',[_vm._v("directions_car")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Units_UnitsMap = (esExports);
// CONCATENATED MODULE: ./src/components/Units/UnitsMap.vue
function injectStyle (ssrContext) {
  __webpack_require__("CcX9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UnitsMap,
  Units_UnitsMap,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_Units_UnitsMap = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MapModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MapModal = ({
  name: 'MapModal',
  components: { UnitsMap: components_Units_UnitsMap },
  props: ['mapDialog'],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    closeModal: function closeModal() {
      window.emitter.$emit('closeMap');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a52630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapModal.vue
var MapModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false,"scrollable":""},model:{value:(_vm.mapDialog),callback:function ($$v) {_vm.mapDialog=$$v},expression:"mapDialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeModal.apply(null, arguments)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Kaart")])],1),_vm._v(" "),_c('units-map',{attrs:{"showMap":_vm.mapDialog}})],1)],1)}
var MapModal_staticRenderFns = []
var MapModal_esExports = { render: MapModal_render, staticRenderFns: MapModal_staticRenderFns }
/* harmony default export */ var components_MapModal = (MapModal_esExports);
// CONCATENATED MODULE: ./src/components/MapModal.vue
var MapModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MapModal___vue_template_functional__ = false
/* styles */
var MapModal___vue_styles__ = null
/* scopeId */
var MapModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MapModal___vue_module_identifier__ = null
var MapModal_Component = MapModal_normalizeComponent(
  MapModal,
  components_MapModal,
  MapModal___vue_template_functional__,
  MapModal___vue_styles__,
  MapModal___vue_scopeId__,
  MapModal___vue_module_identifier__
)

/* harmony default export */ var src_components_MapModal = (MapModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EventTracker/EventTracker.vue

//
//
//
//


/* harmony default export */ var EventTracker = ({
	name: 'EventTracker',
	data: function data() {
		return {
			utils: utils_namespaceObject,
			intervaller: null,
			eid: '',
			cachedEvents: {}
		};
	},
	created: function created() {
		var _this = this;

		this.trackEvents();
		window.emitter.$on('hidden', function () {
			_this.stopTracker();
		});
		window.emitter.$on('windowVisible', function () {
			_this.getEvents();
			_this.getEventData();
		});
	},

	watch: {
		$route: function $route(to, from) {
			var name = to.name;
			if (name === 'Reservations' || name === 'Home') {
				window.emitter.$emit('newEvents', values_default()(this.cachedEvents));
			}
		}
	},
	destroyed: function destroyed() {
		this.stopTracker();
	},

	computed: {
		isLoggedIn: function isLoggedIn() {
			return this.$route.name.indexOf('Login') < 0 && this.$route.name != 'Logout';
		}
	},
	methods: {
		trackEvents: function trackEvents() {
			var _this2 = this;

			utils_getData(basePath + 'api/rentunits/setFlags').then(function (response) {
				_this2.eid = response.eid;
				_this2.getEvents();
			});
		},
		getEvents: function getEvents() {
			var _this3 = this;

			this.intervaller = setInterval(function () {
				_this3.getEventData();
			}, 10000);
		},
		getEventData: function getEventData() {
			var _this4 = this;

			if (this.isLoggedIn && this.eid) {
				utils_getData(basePath + 'api/rentunits/getEvents/' + this.eid).then(function (response) {
					if (response.events) {
						window.emitter.$emit('newEvents', response.events);
						_this4.updateElements(response.events);
					} else {
						// If session invalid - reset flags
						_this4.stopTracker();
						_this4.trackEvents();
					}
				});
			}
		},
		stopTracker: function stopTracker() {
			console.log('stop tracker');
			clearInterval(this.intervaller);
		},
		updateElements: function updateElements(events) {
			var self = this;
			for (var i = 0; i < events.length; i++) {
				var unit = events[i];
				if (unit.d.pos) {
					this.cachedEvents[unit.i] = unit;
					var el = document.getElementsByClassName('unit_' + String(unit.i));
					if (el && el.length) {
						var speed = unit.d.pos.s;
						for (var _i = 0; _i < el.length; _i++) {
							if (speed > 0) {
								el[_i].innerHTML = speed + ' km/u';
							} else {
								el[_i].innerHTML = '';
							}
						}
					}
				}
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2751aa4f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventTracker/EventTracker.vue
var EventTracker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var EventTracker_staticRenderFns = []
var EventTracker_esExports = { render: EventTracker_render, staticRenderFns: EventTracker_staticRenderFns }
/* harmony default export */ var EventTracker_EventTracker = (EventTracker_esExports);
// CONCATENATED MODULE: ./src/components/EventTracker/EventTracker.vue
function EventTracker_injectStyle (ssrContext) {
  __webpack_require__("Mmbf")
}
var EventTracker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventTracker___vue_template_functional__ = false
/* styles */
var EventTracker___vue_styles__ = EventTracker_injectStyle
/* scopeId */
var EventTracker___vue_scopeId__ = "data-v-2751aa4f"
/* moduleIdentifier (server only) */
var EventTracker___vue_module_identifier__ = null
var EventTracker_Component = EventTracker_normalizeComponent(
  EventTracker,
  EventTracker_EventTracker,
  EventTracker___vue_template_functional__,
  EventTracker___vue_styles__,
  EventTracker___vue_scopeId__,
  EventTracker___vue_module_identifier__
)

/* harmony default export */ var components_EventTracker_EventTracker = (EventTracker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FleetuseLogo.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var FleetuseLogo = ({
	name: 'FleetuseLogo'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5d2504","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FleetuseLogo.vue
var FleetuseLogo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var FleetuseLogo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fleetuse-logo",attrs:{"aria-label":"Fleetuse logo"}},[_c('img',{attrs:{"src":__webpack_require__("EYAg"),"alt":"Fleetuse logo"}}),_vm._v(" "),_c('img',{staticClass:"rotating",attrs:{"src":__webpack_require__("Jg4l"),"alt":"Fleetuse radar"}}),_vm._v(" "),_c('span',{staticClass:"d-inline"},[_vm._v("Fleetuse")])])}]
var FleetuseLogo_esExports = { render: FleetuseLogo_render, staticRenderFns: FleetuseLogo_staticRenderFns }
/* harmony default export */ var components_FleetuseLogo = (FleetuseLogo_esExports);
// CONCATENATED MODULE: ./src/components/FleetuseLogo.vue
function FleetuseLogo_injectStyle (ssrContext) {
  __webpack_require__("V558")
}
var FleetuseLogo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FleetuseLogo___vue_template_functional__ = false
/* styles */
var FleetuseLogo___vue_styles__ = FleetuseLogo_injectStyle
/* scopeId */
var FleetuseLogo___vue_scopeId__ = "data-v-2c5d2504"
/* moduleIdentifier (server only) */
var FleetuseLogo___vue_module_identifier__ = null
var FleetuseLogo_Component = FleetuseLogo_normalizeComponent(
  FleetuseLogo,
  components_FleetuseLogo,
  FleetuseLogo___vue_template_functional__,
  FleetuseLogo___vue_styles__,
  FleetuseLogo___vue_scopeId__,
  FleetuseLogo___vue_module_identifier__
)

/* harmony default export */ var src_components_FleetuseLogo = (FleetuseLogo_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/utils/thunderpush.js

var isMSIE = /*@cc_on!@*/0;
window.Thunder = new function () {
    this.channels = [];
    this.handlers = [];

    this.reconnect_delays = [1000, 2500, 5000, 10000, 30000, 60000];

    this.options = {
        // verbose?
        log: false,
        retry: true,
        protocol: 'http'
    };

    /** Underscore Functions **/
    var ArrayProto = Array.prototype,
        ObjProto = Object.prototype,
        FuncProto = Function.prototype;

    var push = ArrayProto.push,
        slice = ArrayProto.slice,
        concat = ArrayProto.concat,
        toString = ObjProto.toString,
        hasOwnProperty = ObjProto.hasOwnProperty;

    var nativeForEach = ArrayProto.forEach,
        nativeMap = ArrayProto.map,
        nativeReduce = ArrayProto.reduce,
        nativeReduceRight = ArrayProto.reduceRight,
        nativeFilter = ArrayProto.filter,
        nativeEvery = ArrayProto.every,
        nativeSome = ArrayProto.some,
        nativeIndexOf = ArrayProto.indexOf,
        nativeLastIndexOf = ArrayProto.lastIndexOf,
        nativeIsArray = Array.isArray,
        nativeKeys = keys_default.a,
        nativeBind = FuncProto.bind;

    var _ = function _(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
    };

    if (true) {
        _.isFunction = function (obj) {
            return typeof obj === 'function';
        };
    }
    _.identity = function (value) {
        return value;
    };
    _.lookupIterator = function (value) {
        return _.isFunction(value) ? value : function (obj) {
            return obj[value];
        };
    };
    _.sortedIndex = function (array, obj, iterator, context) {
        iterator = iterator == null ? _.identity : _.lookupIterator(iterator);
        var value = iterator.call(context, obj);
        var low = 0,
            high = array.length;
        while (low < high) {
            var mid = low + high >>> 1;
            iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
        }
        return low;
    };
    _.indexOf = function (array, item, isSorted) {
        if (array == null) return -1;
        var i = 0,
            l = array.length;
        if (isSorted) {
            if (typeof isSorted == 'number') {
                i = isSorted < 0 ? Math.max(0, l + isSorted) : isSorted;
            } else {
                i = _.sortedIndex(array, item);
                return array[i] === item ? i : -1;
            }
        }
        if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
        for (; i < l; i++) {
            if (array[i] === item) return i;
        }return -1;
    };
    /** UnderscoreJS Functions **/

    this.onSockOpen = function (cb) {
        if (typeof cb === 'function') this.onopen = cb;
    };

    this.onSockError = function (cb) {
        if (typeof cb === 'function') this.onerror = cb;
    };

    this.onSockClose = function (cb) {
        if (typeof cb === 'function') this.onclose = cb;
    };

    this.onSockMessage = function (cb) {
        if (typeof cb === 'function') this.onmessage = cb;
    };

    this.connect = function (server, apikey, channels, options) {
        this.apikey = apikey;
        this.channels = channels;
        this.reconnect_tries = 0;

        // merge options
        for (var attr in options) {
            this.options[attr] = options[attr];
        }

        this.server = this.options.protocol + "://" + server + "/connect";
        this.user = this.options.user;
        this.makeConnection();

        var that = this;
    };

    this.disconnect = function () {
        var thunder = this;

        this.socket.onclose = function (e) {
            if (this.onclose) this.onclose.call(thunder, e);
        };

        if (this.socket.readyState === SockJS.OPEN) return this.socket.close();
        return false;
    };

    /**
     * Subscribe to channel
     */
    this.subscribe = function (channel, success, error) {
        if (typeof channel !== 'string' || channel.length <= 0) throw {
            name: 'channel.invalid',
            message: 'Channel is not a string'
        };

        if (this.socket.readyState === SockJS.OPEN) {
            if (_.indexOf(this.channels, channel) !== -1) {
                typeof success === 'function' && success(this, 'Channel already subscribed');
                return true;
            }

            this.socket.send("SUBSCRIBE " + channel);
            this.channels.push(channel);
            typeof success === 'function' && success(this, 'Channel subscribed');
            return true;
        }

        typeof error === 'function' && error(this, 'Socket not open');
        throw {
            name: 'socket.status',
            message: 'Socket not OPEN: '.this.socket.readyState
        };
    };

    /**
     * Subscribe to channel
     */
    this.unsubscribe = function (channel, success, error) {
        if (this.socket.readyState === SockJS.OPEN) {
            this.socket.send("UNSUBSCRIBE " + channel);

            var pos = _.indexOf(this.channels, channel);

            if (pos !== -1) {
                channels = this.channels.splice(pos, 1);
            }

            typeof success === 'function' && success(this, 'Channel unsubscribed');
            return true;
        } else {
            var error = '';
            typeof error === 'function' && error(this, 'Socket not open');
            throw {
                name: 'socket.status',
                message: 'Socket not OPEN: '.this.socket.readyState
            };
        }
    };

    this.listen = function (handler) {
        this.log("New handler has been registered.");
        this.handlers.push(handler);
    };

    this.makeConnection = function () {
        var that = this;

        // make a connection
        this.socket = new SockJS(this.server, undefined, { 'debug': this.options.log });

        this.socket.onopen = function (e) {
            that.log("Connection has been established.");

            if (that.onopen) that.onopen.call(that, e);

            // reset retries counter
            that.reconnect_tries = 0;

            // connect and subscribe to channels
            that.socket.send("CONNECT " + that.user + ":" + that.apikey);

            if (that.channels.length) that.socket.send("SUBSCRIBE " + that.channels.join(":"));
        };

        this.socket.onmessage = function (e) {
            that.log("Message has been received", e.data);

            if (that.onmessage) that.onmessage.call(that, e);

            try {
                // try to parse the message as json
                var json_data = JSON.parse(e.data.payload);
                e.data = json_data;
            } catch (e) {
                // not json, leave it as is
            }

            for (var i = 0; i < that.handlers.length; i++) {
                that.handlers[i](e.data);
            }
        };

        this.socket.onerror = function (e) {
            if (that.onerror) that.onerror.call(that, e);
        };

        this.socket.onclose = function (e) {
            that.log("Connection has been lost.");

            if (that.onclose) that.onclose.call(that, e);

            if (that.options.retry === false) {
                that.log("Reconnect supressed because of retry option false");
                return;
            }

            if (e.code == 9000 || e.code == 9001 || e.code == 9002) {
                // received "key not good" close message
                that.log("Reconnect supressed because of:", e);
                return;
            }

            var delay = that.reconnect_delays[that.reconnect_tries] || that.reconnect_delays[that.reconnect_delays.length - 1];

            that.log("Reconnecting in", delay, "ms...");
            that.reconnect_tries++;

            setTimeout(function () {
                that.makeConnection();
            }, delay);
        };
    };

    this.log = function (msg) {
        if (this.options.log && "console" in window && "log" in window.console) {

            if (arguments.length == 1) {
                console.log(arguments[0]);
            } else {
                if (isMSIE) {
                    var log = Function.prototype.bind.call(console.log, console);
                    log.apply(console, Array.prototype.slice.call(arguments));
                } else {
                    console.log.apply(console, Array.prototype.slice.call(arguments));
                }
            }
        }
    };
}();
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var serverUrl = 'https://www.auto2use.nl/manager/';
var isLocal = window.location.port.includes('80');
window.baseUrl = isLocal && !localStorage.getItem('live') ? serverUrl : 'https://www.auto2use.nl/manager/';
window.basePath = window.baseUrl + 'index.php/';
window.dataLoading = false;









/* harmony default export */ var App = ({
	name: 'app',
	components: { MapModal: src_components_MapModal, EventTracker: components_EventTracker_EventTracker, FleetuseLogo: src_components_FleetuseLogo },
	data: function data() {
		return {
			themeLight: true,
			drawer: null,
			mapDialog: false,
			versionDialog: false,
			showMessage: false,
			showPushNotification: false,
			pushMsg: '',
			pushId: 0,
			msg_type: '',
			navColor: 'blue darken-3',
			loadingMsg: '',
			showLoading: false,
			loaderTimeout: 0,
			updateFeatures: [],
			newVersion: '',
			msg: '',
			items: [{ title: 'Instellingen' }, { title: 'Uitloggen' }],
			pageNames: {
				Home: 'Reserveringen',
				Reservations: 'Reserveringen',
				History: 'Historie',
				Users: 'Gebruikers',
				Units: 'Units',
				Planner: 'Planner',
				TestDrive: 'Tracker',
				Dashboard: 'Dashboard',
				settings: 'Instellingen',
				Prices: 'Prijsbeheer'
			},
			username: ''
		};
	},
	props: {
		sidebar: true
	},
	watch: {
		themeLight: function themeLight(val) {},
		$route: function $route(to, from) {
			if (from.name === 'Login') {
				this.username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
			}
		}
	},
	mounted: function mounted() {
		var self = this;
		if (this.$route.name && this.$route.name.indexOf('Login') < 0 && this.$route.name.indexOf('Logout') < 0) {
			this.checkVersion();
		}

		window.emitter.$on('checkVersion', function () {
			self.checkVersion();
		});

		if (localStorage.getItem('theme')) {
			self.themeLight = localStorage.getItem('theme') === 'light';
		}

		if (!this.isAuthorized && this.$route.name !== 'Login') {
			window.location.href = '#/login';
		}

		window.emitter.$on('closeMap', function () {
			self.mapDialog = false;
		});
		window.emitter.$on('showToastMessage', function (data) {
			self.msg = data.msg;
			self.msg_type = data.type ? data.type : 'success';
			self.showMessage = true;
		});
		window.emitter.$on('showPushNotification', function (data) {
			self.pushMsg = data.msg;
			self.pushId = data.id;
			self.showPushNotification = true;
		});
		window.emitter.$on('showLoading', function (data) {
			self.loadingMsg = data.msg;

			if (!data.enable) {
				setTimeout(function () {
					self.showLoading = data.enable;
				}, 100);
			} else {
				self.showLoading = data.enable;
			}
		});
	},

	methods: {
		goto: function goto(url) {
			window.location.href = url;
		},
		showMap: function showMap() {
			this.mapDialog = true;
		},
		viewPushNotification: function viewPushNotification() {
			this.showPushNotification = false;
			this.$router.push('/reservations/' + this.pushId);
		},
		showUsers: function showUsers() {
			this.$router.push('/users/new');
		},
		checkVersion: function checkVersion() {
			var self = this;
			var currentVersion = localStorage.getItem('version');
			if (currentVersion) {
				self.updateFeatures = '';
				fetchData((isLocal ? './src' : '.') + '/assets/json/versionInfo.json?ts=' + moment_default()().unix(), 'GET').then(function (json) {
					var newVersion = json.number;
					if (newVersion !== currentVersion) {
						self.versionDialog = true;
						self.newVersion = newVersion;
						self.updateFeatures = json.features;
					}
				});
			}
		},
		reload: function reload() {
			localStorage.setItem('version', this.newVersion);
			window.location.reload(true);
		}
	},
	computed: {
		isAuthorized: function isAuthorized() {
			return localStorage.getItem('b') || this.$route.name === 'Login';
		},
		isLoggedIn: function isLoggedIn() {
			return this.$route.name.indexOf('Login') < 0 && this.$route.name != 'Logout';
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781df00a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthorized)?_c('v-app',{attrs:{"light":_vm.themeLight,"dark":!_vm.themeLight,"id":"app"}},[(_vm.$route.name.indexOf('Login') < 0 && _vm.$route.name != 'Logout')?_c('v-navigation-drawer',{staticClass:"elevation-0",class:_vm.themeLight ? 'blue darken-3' : 'blue-grey darken-4',attrs:{"app":"","fixed":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{class:_vm.navColor,staticStyle:{"height":"64px"},attrs:{"flat":"","dark":""}},[_c('v-list',[_c('v-list-tile',{attrs:{"id":"logo"}},[_c('span',[_c('fleetuse-logo')],1)])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Dashboard' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/dashboard')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("pie_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/dashboard"}},[_vm._v("Dashboard")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Reservations' || _vm.$route.name === 'Home'
							? 'active'
							: 'white--text',on:{"click":function($event){return _vm.goto('#/reservations')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("card_travel")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/reservations"}},[_vm._v("Reserveringen")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'TestDrive' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/testdrive')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("person_pin")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/testdrive"}},[_vm._v("Track & trace")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Planner' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/planner')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("date_range")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/planner"}},[_vm._v("Planner")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Users' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/users')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("contact_mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/users"}},[_vm._v("Klanten")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'History' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/history')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/history"}},[_vm._v("Facturen")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Units' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/units')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("directions_car")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/units"}},[_vm._v("Units")])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.$route.name === 'Prices' ? 'active' : 'white--text',on:{"click":function($event){return _vm.goto('#/prices')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("euro_symbol")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":"#/prices"}},[_vm._v("Prijsbeheer")])])],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 blue--text text--lighten-1",attrs:{"absolute":"","color":"transparent"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.username)+"\n\t\t\t\t"),_c('v-spacer'),_vm._v(" "),_c('div',[_c('v-icon',{staticClass:"blue--text text--lighten-1",on:{"click":function($event){_vm.themeLight = !_vm.themeLight}}},[_vm._v("tonality")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$route.name.indexOf('Login') < 0 && _vm.$route.name != 'Logout')?_c('v-toolbar',{staticClass:"elevation-0",class:_vm.themeLight ? 'grey lighten-5' : 'black',attrs:{"fixed":"","app":"","light":""}},[_c('span',{staticClass:"text-xs-center hidden-sm-and-up mobileHeader"},[_vm._v(_vm._s(_vm.pageNames[_vm.$route.name]))]),_vm._v(" "),_c('v-toolbar-side-icon',{staticClass:"grey--text text--darken-2 ml-0",attrs:{"dark":!_vm.themeLight},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"navButtonRight"},[_c('v-btn',{staticClass:"grey--text text--darken-2",attrs:{"icon":"","right":"","dark":!_vm.themeLight},on:{"click":function($event){return _vm.showMap()}}},[_c('v-icon',[_vm._v("map")])],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","left":""}},[_c('v-btn',{staticClass:"grey--text text--darken-2",attrs:{"slot":"activator","icon":"","dark":!_vm.themeLight},slot:"activator"},[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.goto('#/settings')}}},[_c('v-list-tile-title',[_vm._v("Instellingen")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.goto('#/logout')}}},[_c('v-list-tile-title',[_vm._v("Uitloggen")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),(_vm.isLoggedIn)?_c('event-tracker'):_vm._e(),_vm._v(" "),_c('map-modal',{attrs:{"mapDialog":_vm.mapDialog}}),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":true,"timeout":_vm.loaderTimeout},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"3"}})],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":true,"timeout":2000,"color":_vm.msg_type === 'success' ? 'black' : 'orange lighten-1'},model:{value:(_vm.showMessage),callback:function ($$v) {_vm.showMessage=$$v},expression:"showMessage"}},[(_vm.msg_type === 'success')?_c('v-icon',{attrs:{"color":"green lighten-1"}},[_vm._v("check_circle")]):_vm._e(),_vm._v(" "),(_vm.msg_type !== 'success')?_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("info")]):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(_vm.msg)+"\n\t\t\t"),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showMessage = false}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","right":"","color":'gray lighten-1',"multi-line":"","timeout":6000},model:{value:(_vm.showPushNotification),callback:function ($$v) {_vm.showPushNotification=$$v},expression:"showPushNotification"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.pushMsg)+"\n\t\t\t"),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showPushNotification = false}}},[_vm._v("Sluiten")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","dark":"","flat":""},nativeOn:{"click":function($event){return _vm.viewPushNotification()}}},[_vm._v("Bekijken")])],1),_vm._v(" "),_c('div',{attrs:{"id":"unitContainer"}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.versionDialog),callback:function ($$v) {_vm.versionDialog=$$v},expression:"versionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Update")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n\t\t\t\t\tEr is een nieuwe versie ("+_vm._s(_vm.newVersion)+") beschikbaar\n\t\t\t\t\t"),(_vm.updateFeatures.length)?_c('ul',_vm._l((_vm.updateFeatures),function(feature,index){return _c('li',{key:index},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(feature)+"\n\t\t\t\t\t\t")])}),0):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.versionDialog = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.reload()}}},[_vm._v("Updaten")])],1)],1)],1)],1):_vm._e()}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("AG2/")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
	name: 'Login',
	components: { FleetuseLogo: src_components_FleetuseLogo },
	data: function data() {
		return {
			valid: false,
			name: '',
			pwRules: [function (v) {
				return !!v || 'Wachtwoord is verplicht';
			}],
			email: '',
			password: '',
			utils: utils_namespaceObject,
			showForm: false,
			loading: false,
			emailRules: [function (v) {
				return !!v || 'Gebruikersnaam is verplicht';
			}, function (v) {
				return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Ongeldige gebruikersnaam'
				);
			}]
		};
	},
	created: function created() {
		if (this.$route.params && this.$route.params.action === '-') {
			this.showForm = true;
			localStorage.removeItem('b');
		} else {
			this.checkToken();
		}
	},

	methods: {
		submit: function submit() {
			var self = this;
			if (this.$refs.form.validate()) {
				var data = {
					email: this.email,
					password: this.password
				};

				if (data && data.email.indexOf('.dev') >= 0) {
					data.email = data.email.replace('.dev', '');
					localStorage.setItem('live', 1);
				}
				this.loading = true;
				this.utils.setData(basePath + 'api/auth/login', data).then(function (response) {
					self.loading = false;
					if (response && response.b) {
						localStorage.setItem('b', response.b);
						localStorage.setItem('t', response.t);
						localStorage.setItem('username', response.u);

						if (response.t !== 'default') {
							self.initOneSignal();
						}

						self.redirect();
					} else {
						window.emitter.$emit('showToastMessage', {
							msg: response.error,
							type: 'error'
						});
					}
				});
			}
		},
		redirect: function redirect() {
			window.location.href = '#/reservations';
		},
		checkToken: function checkToken() {
			var self = this;
			if (localStorage.getItem('b')) {
				this.utils.getData(basePath + 'api/auth/checkToken').then(function (response) {
					if (response.data == '1') {
						self.showForm = false;
						self.redirect();
					} else {
						self.showForm = true;
					}
				});
			} else {
				this.showForm = true;
			}
		},
		initOneSignal: function initOneSignal() {
			var OneSignal = window.OneSignal || [];
			OneSignal.push(function () {
				OneSignal.init({
					appId: '4ebad7de-87fb-4fdb-9382-c8c747fd453d'
				});
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99f61988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"start",class:!_vm.showForm ? 'loading' : ''},[(_vm.showForm)?_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"blue darken-3 pa-3 elevation-1 login-box"},[_c('div',{staticClass:"d-block text-md-center white--text mb-3"},[_c('fleetuse-logo')],1),_vm._v(" "),_c('label',[_vm._v("Gebruikersnaam")]),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.emailRules,"prepend-icon":"account_circle","id":"username","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('label',[_vm._v("Wachtwoord")]),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","prepend-icon":"star","id":"password","rules":_vm.pwRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(!_vm.loading)?_c('v-btn',{staticClass:"mx-0",attrs:{"block":"","color":"black","dark":""},on:{"click":_vm.submit}},[_vm._v("Inloggen")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}}):_vm._e()],1)]):_vm._e()],1)])}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("uii8")
  __webpack_require__("UaRU")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-99f61988"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/models/user.js



var user_UserModel = function () {
  function UserModel(data) {
    classCallCheck_default()(this, UserModel);

    this.data = data;
  }

  createClass_default()(UserModel, [{
    key: 'name',
    value: function name() {
      return this.data.firstname + ' ' + this.data.lastname;
    }
  }]);

  return UserModel;
}();

/* harmony default export */ var user = (user_UserModel);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TableLoader.vue
//
//
//

/* harmony default export */ var TableLoader = ({
  name: "TableLoader"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7f6868","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableLoader.vue
var TableLoader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"3"}})}
var TableLoader_staticRenderFns = []
var TableLoader_esExports = { render: TableLoader_render, staticRenderFns: TableLoader_staticRenderFns }
/* harmony default export */ var components_TableLoader = (TableLoader_esExports);
// CONCATENATED MODULE: ./src/components/TableLoader.vue
var TableLoader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TableLoader___vue_template_functional__ = false
/* styles */
var TableLoader___vue_styles__ = null
/* scopeId */
var TableLoader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TableLoader___vue_module_identifier__ = null
var TableLoader_Component = TableLoader_normalizeComponent(
  TableLoader,
  components_TableLoader,
  TableLoader___vue_template_functional__,
  TableLoader___vue_styles__,
  TableLoader___vue_scopeId__,
  TableLoader___vue_module_identifier__
)

/* harmony default export */ var src_components_TableLoader = (TableLoader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/subcomponents/TempCustomer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TempCustomer = ({
	name: 'TempCustomer',
	components: {},
	mounted: function mounted() {
		this.useTempCustomer = this.user && this.user.t_name;
	},
	updated: function updated() {
		this.user.useTempCustomer = this.useTempCustomer;
	},
	data: function data() {
		return {
			basicRules: [function (v) {
				return !!v || 'Verplicht veld';
			}],
			useTempCustomer: false
		};
	},

	props: ['user', 'editable', 'optional', 'showInvoiceOption', 'useTempForInvoice'],
	computed: {
		useForInvoice: {
			get: function get() {
				return this.useTempForInvoice === '1';
			},
			set: function set(value) {
				this.$emit('setUseTempForInvoice', value);
			}
		},
		showForm: {
			get: function get() {
				return this.user.t_name || this.useTempCustomer ? true : false;
			},
			set: function set(value) {
				this.showForm = value;
			}
		}
	},
	watch: {
		user: function user(value) {
			this.useTempCustomer = value && value.t_name ? true : false;
		},
		useTempCustomer: function useTempCustomer(value) {
			this.user.useTempCustomer = value;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f53f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponents/TempCustomer.vue
var TempCustomer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","px-1":"","pb-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v("Gekoppelde klant")]),_vm._v(" "),(_vm.optional)?_c('v-checkbox',{attrs:{"label":"Gebruiken"},model:{value:(_vm.useTempCustomer),callback:function ($$v) {_vm.useTempCustomer=$$v},expression:"useTempCustomer"}}):_vm._e()],1),_vm._v(" "),(_vm.showForm || !_vm.optional)?[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Naam","required":_vm.editable,"rules":_vm.basicRules},model:{value:(_vm.user.t_name),callback:function ($$v) {_vm.$set(_vm.user, "t_name", $$v)},expression:"user.t_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Geboortedatum","required":_vm.editable,"autocomplete":"false","rules":_vm.basicRules},model:{value:(_vm.user.t_birthDate),callback:function ($$v) {_vm.$set(_vm.user, "t_birthDate", $$v)},expression:"user.t_birthDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Rijbewijsnummer","required":_vm.editable,"autocomplete":"false","rules":_vm.basicRules},model:{value:(_vm.user.t_licenseId),callback:function ($$v) {_vm.$set(_vm.user, "t_licenseId", $$v)},expression:"user.t_licenseId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Telefoonnummer","required":_vm.editable,"autocomplete":"false","rules":_vm.basicRules},model:{value:(_vm.user.t_phoneno),callback:function ($$v) {_vm.$set(_vm.user, "t_phoneno", $$v)},expression:"user.t_phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"E-mailadres","required":_vm.editable,"autocomplete":"false","rules":_vm.basicRules},model:{value:(_vm.user.t_emailAddress),callback:function ($$v) {_vm.$set(_vm.user, "t_emailAddress", $$v)},expression:"user.t_emailAddress"}})],1),_vm._v(" "),(_vm.showInvoiceOption)?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""},model:{value:(_vm.useForInvoice),callback:function ($$v) {_vm.useForInvoice=$$v},expression:"useForInvoice"}},[_c('v-checkbox',{attrs:{"label":"Toon op factuur"},model:{value:(_vm.useForInvoice),callback:function ($$v) {_vm.useForInvoice=$$v},expression:"useForInvoice"}})],1):_vm._e()]:_vm._e()],2)],1)}
var TempCustomer_staticRenderFns = []
var TempCustomer_esExports = { render: TempCustomer_render, staticRenderFns: TempCustomer_staticRenderFns }
/* harmony default export */ var subcomponents_TempCustomer = (TempCustomer_esExports);
// CONCATENATED MODULE: ./src/components/subcomponents/TempCustomer.vue
function TempCustomer_injectStyle (ssrContext) {
  __webpack_require__("noQt")
}
var TempCustomer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TempCustomer___vue_template_functional__ = false
/* styles */
var TempCustomer___vue_styles__ = TempCustomer_injectStyle
/* scopeId */
var TempCustomer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TempCustomer___vue_module_identifier__ = null
var TempCustomer_Component = TempCustomer_normalizeComponent(
  TempCustomer,
  subcomponents_TempCustomer,
  TempCustomer___vue_template_functional__,
  TempCustomer___vue_styles__,
  TempCustomer___vue_scopeId__,
  TempCustomer___vue_module_identifier__
)

/* harmony default export */ var components_subcomponents_TempCustomer = (TempCustomer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/UserModal.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var UserModal_UserModel = function () {
	function UserModel() {
		classCallCheck_default()(this, UserModel);
	}

	createClass_default()(UserModel, [{
		key: 'construct',
		value: function construct(data) {
			this.data = data;
		}
	}, {
		key: 'name',
		value: function name() {
			return this.data.firstname + ' ' + this.data.lastname;
		}

		// and so on, put other methods here

	}]);

	return UserModel;
}();








/* harmony default export */ var UserModal = ({
	name: 'UserModal',
	components: { TempCustomer: components_subcomponents_TempCustomer, TableLoader: src_components_TableLoader },
	created: function created() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
		this.userType = localStorage.getItem('t');
	},
	data: function data() {
		return {
			tabs: ['Gegevens', 'Historie', 'Opties', 'Informatie', 'Gebruiker controleren'],
			selectItems: [{
				text: 'Ja',
				value: '1'
			}, {
				text: 'Nee',
				value: '0'
			}],
			active: 0,
			confirmDeleteDialog: false,
			dialog: false,
			dialog2: false,
			dialog3: false,
			utils: utils_namespaceObject,
			sound: true,
			widgets: false,
			unitDate: {},
			selectedUser: {},
			tempCustomer: {},
			test: {},
			customerType: 'new',
			emailRules: [function (v) {
				return !!v || 'E-mail is verplicht';
			}, function (v) {
				return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mailadres is niet correct'
				);
			}],
			basicRules: [function (v) {
				return !!v || 'Verplicht veld';
			}],
			valid: false,
			fullscreen: false,
			userType: 'default',
			rentalCheckResult: null,
			rentalCheckPhotos: [],
			rentalCheckUserStatusResponse: null,
			rentalCheckStatusInterval: null
		};
	},

	computed: {
		totalKm: function totalKm() {
			var sum = this.selectedUser.history.reduce(function (s, f) {
				return parseFloat(f.mileage) + s; // return the sum of the accumulator and the current time. (as the the new accumulator)
			}, 0);
			return this.utils.getFormattedAmount(sum.toFixed(2));
		},
		rentalCheckExecutions: function rentalCheckExecutions() {
			var response = this.rentalCheckUserStatusResponse;
			if (response && response.registration && Array.isArray(response.registration.check_executions)) {
				return response.registration.check_executions;
			}
			return [];
		}
	},
	props: ['user', 'edit', 'id', 'showSelector'],
	watch: {
		active: function active(newVal) {
			if (newVal === 'Gebruiker controleren' && this.id > 0) {
				this.getRentalCheckPhotos();
				if (this.selectedUser && typeof this.selectedUser.rentalCheck_status === 'string' && this.selectedUser.rentalCheck_status.toLowerCase() !== '') {
					this.getRentalCheckUserStatus();
				}
			}
		},
		'edit.showModal': function editShowModal(newVal) {
			if (newVal) {
				this.active = 'Gegevens';
			} else if (this.rentalCheckStatusInterval) {
				clearInterval(this.rentalCheckStatusInterval);
				this.rentalCheckStatusInterval = null;
			}
		},
		id: function id(newVal) {
			var self = this;
			self.active = 'Gegevens';
			self.rentalCheckResult = null;
			self.rentalCheckPhotos = [];
			self.rentalCheckUserStatusResponse = null;
			// Clear polling interval when user changes
			if (self.rentalCheckStatusInterval) {
				clearInterval(self.rentalCheckStatusInterval);
				self.rentalCheckStatusInterval = null;
			}

			if (this.id > 0) {
				utils_getData(basePath + 'api/users/getUser/' + this.id).then(function (json) {
					//self.test = new userModel(json.data[0]);
					self.selectedUser = json.data[0];
					self.selectedUser.birthdate = self.selectedUser.birthdate ? moment_default()(self.selectedUser.birthdate, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
					if (self.selectedUser.birthdate === 'Invalid date') {
						self.selectedUser.birthdate = '';
					}
					self.selectedUser.license_expiration_date = self.selectedUser.license_expiration_date ? moment_default()(self.selectedUser.license_expiration_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
					if (self.selectedUser.license_expiration_date === 'Invalid date') {
						self.selectedUser.license_expiration_date = '';
					}
					self.selectedUser.history = json.history;
				});
			} else {
				if (self.$refs.form) {
					self.$refs.form.reset();
				}
				self.selectedUser = this.user;
				self.firstname = '';
				self.lastname = '';
			}
		},
		'selectedUser.rentalCheck_status': function selectedUserRentalCheck_status(newVal) {
			var _this = this;

			if (newVal !== '' && newVal.toLowerCase() === 'pending') {
				// Start polling interval if not already running
				if (!this.rentalCheckStatusInterval) {
					this.rentalCheckStatusInterval = setInterval(function () {
						_this.getRentalCheckUserStatus();
					}, 5000);
				}
			} else {
				// Clear interval if status is no longer pending
				if (this.rentalCheckStatusInterval) {
					clearInterval(this.rentalCheckStatusInterval);
					this.rentalCheckStatusInterval = null;
				}
			}
		}
	},

	methods: {
		newUser: function newUser() {
			this.selectedUser = {
				discount: '0',
				active: '1',
				canRent: '1',
				paid: '1'
			};
			this.tempCustomer = {};
			this.edit.showModal = true;
		},
		closeModal: function closeModal() {
			this.edit.showModal = false;
		},
		updateModel: function updateModel() {
			window.emitter.$emit('showToastMessage', { msg: 'Gegevens opgeslagen' });
		},
		updateUser: function updateUser() {
			var self = this;
			if (this.customerType === 'new') {
				var data = {
					user: {
						paid: this.selectedUser.paid,
						active: this.selectedUser.active,
						canRent: this.selectedUser.canRent,
						remark: this.selectedUser.remark,
						username: this.selectedUser.username,
						credit: this.selectedUser.credit
					},
					userDetails: {
						firstname: this.selectedUser.firstname,
						lastname: this.selectedUser.lastname,
						companyname: this.selectedUser.companyname,
						street: this.selectedUser.street,
						streetno: this.selectedUser.streetno,
						licenseid: this.selectedUser.licenseid,
						zip: this.selectedUser.zip,
						city: this.selectedUser.city,
						phoneno: this.selectedUser.phoneno,
						remarks: this.selectedUser.remarks,
						license_expiration_date: moment_default()(self.selectedUser.license_expiration_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
						birthdate: moment_default()(self.selectedUser.birthdate, 'DD-MM-YYYY').format('YYYY-MM-DD')
					}
				};
			} else {
				var data = this.selectedUser;
			}
			// Existing user
			if (this.id > 0) {
				data.newPassword = this.selectedUser.newPassword;
			} else {
				data.password = this.selectedUser.password;
			}

			if (this.$refs.form.validate()) {
				var apiType = this.customerType === 'new' ? 'User' : 'TempUser';

				// Update
				if (this.id > 0) {
					setData(basePath + 'api/users/update' + apiType + '/' + this.id, data).then(function (json) {
						self.updateModel();
						self.$emit('userUpdated');
						self.edit.showModal = false;
					});
				} else {
					// New user
					setData(basePath + 'api/users/create' + apiType + '/', data).then(function (json) {
						self.updateModel();
						self.edit.showModal = false;
						self.$emit('userUpdated');

						if (json.data && json.data[0]) {
							window.emitter.$emit('userCreated', {
								type: self.customerType,
								tempCustomer: self.tempCustomer,
								user: json.data
							});
						}
					});
				}
			}
		},
		showHistory: function showHistory(id) {
			window.location.href = '#/history/' + id;
		},
		deleteUser: function deleteUser() {
			var _this2 = this;

			utils_getData(basePath + 'api/users/delete/' + this.id).then(function (json) {
				_this2.confirmDeleteDialog = false;
				_this2.edit.showModal = false;
				_this2.updateModel();
				_this2.$emit('userUpdated');
			});
		},
		downloadRentalCheckPhotos: function downloadRentalCheckPhotos() {
			var _this3 = this;

			var token = localStorage.getItem('b');
			var payload = {};

			if (token) {
				payload.b = token;
			}

			axios_default.a.post(basePath + 'api/rentalcheck/downloadphotos/' + this.id, stringify_default()(payload), {
				responseType: 'blob'
			}).then(function (response) {
				var downloadUrl = window.URL.createObjectURL(response.data);
				var link = document.createElement('a');
				link.href = downloadUrl;
				link.download = 'rentalcheck-photos-' + _this3.id + '.zip';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(downloadUrl);
			});
		},
		deleteRentalCheckPhotos: function deleteRentalCheckPhotos() {
			var self = this;
			setData(basePath + 'api/rentalcheck/deletephotos/' + this.id, {}).then(function () {
				self.rentalCheckPhotos = [];
				window.emitter.$emit('showToastMessage', {
					msg: "Foto's verwijderd"
				});
			});
		},
		openRentalCheckReport: function openRentalCheckReport(url, fileType) {
			if (!url) {
				return;
			}

			var token = localStorage.getItem('b');
			var payload = {
				url: url,
				fileType: fileType
			};

			if (token) {
				payload.b = token;
			}

			axios_default.a.post(basePath + 'api/rentalcheck/proxydocument', stringify_default()(payload), {
				responseType: 'blob'
			}).then(function (response) {
				var mimeType = fileType === 'pdf' ? 'application/pdf' : 'text/html';
				var blob = new Blob([response.data], { type: mimeType });
				var documentUrl = window.URL.createObjectURL(blob);
				window.open(documentUrl, '_blank');
				setTimeout(function () {
					window.URL.revokeObjectURL(documentUrl);
				}, 1000);
			}).catch(function () {
				window.emitter.$emit('showToastMessage', {
					msg: 'Kon rapport niet openen'
				});
			});
		},
		checkUser: function checkUser() {
			var self = this;
			self.selectedUser.rentalCheck_status = 'queued';
			setData(basePath + 'api/rentalcheck/register/', { user_id: this.id }).then(function (json) {
				if (json) {
					self.rentalCheckResult = json;

					if (json && json.status !== 500) {
						self.selectedUser.rentalCheck_status = 'pending';
					}
				}
			});
		},
		getRentalCheckPhotos: function getRentalCheckPhotos() {
			var self = this;
			utils_getData(basePath + 'api/rentalcheck/photos/' + this.id).then(function (json) {
				var responseData = json && json.data && typeof_default()(json.data) === 'object' ? json.data : json;
				if (responseData && (typeof responseData === 'undefined' ? 'undefined' : typeof_default()(responseData)) === 'object') {
					// Transform response { front: {...}, back: {...} } to array for UI
					var photos = [];

					keys_default()(responseData).forEach(function (key) {
						var photo = responseData[key];
						if (photo && photo.found && photo.filename) {
							photos.push({
								id: key,
								label: key.charAt(0).toUpperCase() + key.slice(1),
								filename: photo.filename,
								mime: photo.mime,
								url: photo.url
							});
						}
					});
					self.rentalCheckPhotos = photos;
				}
			});
		},
		getRentalCheckUserStatus: function getRentalCheckUserStatus() {
			var self = this;
			utils_getData(basePath + 'api/rentalcheck/userstatus/' + this.id).then(function (json) {
				self.rentalCheckUserStatusResponse = json && json.data !== undefined ? json.data : json;
				if (self.rentalCheckUserStatusResponse && self.rentalCheckUserStatusResponse.registration && self.rentalCheckUserStatusResponse.registration.status !== 'unknown' && self.rentalCheckStatusInterval) {
					clearInterval(self.rentalCheckStatusInterval);
					self.rentalCheckStatusInterval = null;
				}
			});
		},
		formatExecutionDate: function formatExecutionDate(value) {
			if (!value) {
				return '';
			}
			var formatted = moment_default()(value).format('DD-MM-YYYY HH:mm:ss');
			return formatted === 'Invalid date' ? value : formatted;
		}
	},
	beforeDestroy: function beforeDestroy() {
		// Clean up polling interval
		if (this.rentalCheckStatusInterval) {
			clearInterval(this.rentalCheckStatusInterval);
			this.rentalCheckStatusInterval = null;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef25df7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserModal.vue
var UserModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":_vm.fullscreen,"lazy":"","max-width":"700px","transition":_vm.utils.getSettings('animation')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.edit.showModal = false}},model:{value:(_vm.edit.showModal),callback:function ($$v) {_vm.$set(_vm.edit, "showModal", $$v)},expression:"edit.showModal"}},[_c('v-card',[_c('v-tabs',{attrs:{"color":"blue darken-3","dark":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.tabs),function(tab){return (tab === 'Gegevens' || _vm.selectedUser.id > 0)?_c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v(_vm._s(tab)+"\n\t\t\t\t\t"+_vm._s(tab === 'Historie' &&
						_vm.selectedUser.history &&
						_vm.selectedUser.history.length
							? '(' + _vm.selectedUser.history.length + ')'
							: ''))]):_vm._e()}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{key:'Gegevens',attrs:{"value":'Gegevens'}},[_c('v-card',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card-title',[_c('h2',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.selectedUser.id > 0
												? 'Wijzig gebruiker'
												: 'Nieuwe gebruiker')+"\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.selectedUser.id > 0
												? ' #' + _vm.selectedUser.memberNumber
												: '')+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","px-0":"","py-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.showSelector)?_c('v-radio-group',{model:{value:(_vm.customerType),callback:function ($$v) {_vm.customerType=$$v},expression:"customerType"}},[_c('v-radio',{attrs:{"label":"Nieuwe klant","value":"new"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Gekoppelde klant","value":"temp"}})],1):_vm._e()],1),_vm._v(" "),(_vm.customerType === 'new')?_c('v-layout',{attrs:{"wrap":"","xs12":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"label":"Aanhef","items":['Dhr.', 'Mevr.']},model:{value:(_vm.selectedUser.sex),callback:function ($$v) {_vm.$set(_vm.selectedUser, "sex", $$v)},expression:"selectedUser.sex"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Voornaam","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.firstname),callback:function ($$v) {_vm.$set(_vm.selectedUser, "firstname", $$v)},expression:"selectedUser.firstname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Achternaam","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.lastname),callback:function ($$v) {_vm.$set(_vm.selectedUser, "lastname", $$v)},expression:"selectedUser.lastname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Bedrijfsnaam"},model:{value:(_vm.selectedUser.companyname),callback:function ($$v) {_vm.$set(_vm.selectedUser, "companyname", $$v)},expression:"selectedUser.companyname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Email","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.username),callback:function ($$v) {_vm.$set(_vm.selectedUser, "username", $$v)},expression:"selectedUser.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Rijbewijsnummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.licenseid),callback:function ($$v) {_vm.$set(_vm.selectedUser, "licenseid", $$v)},expression:"selectedUser.licenseid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Geboortedatum","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.birthdate),callback:function ($$v) {_vm.$set(_vm.selectedUser, "birthdate", $$v)},expression:"selectedUser.birthdate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Vervaldatum rijbewijs","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.license_expiration_date),callback:function ($$v) {_vm.$set(_vm.selectedUser, "license_expiration_date", $$v)},expression:"selectedUser.license_expiration_date"}})],1),_vm._v(" "),(
														_vm.selectedUser.id <= 0 && _vm.userType !== 'default'
													)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Wachtwoord","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.password),callback:function ($$v) {_vm.$set(_vm.selectedUser, "password", $$v)},expression:"selectedUser.password"}})],1):_vm._e(),_vm._v(" "),(_vm.selectedUser.id > 0 && _vm.userType !== 'default')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Wachtwoord veranderen"},model:{value:(_vm.selectedUser.newPassword),callback:function ($$v) {_vm.$set(_vm.selectedUser, "newPassword", $$v)},expression:"selectedUser.newPassword"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"label":"Woonplaats","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.city),callback:function ($$v) {_vm.$set(_vm.selectedUser, "city", $$v)},expression:"selectedUser.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Postcode","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.zip),callback:function ($$v) {_vm.$set(_vm.selectedUser, "zip", $$v)},expression:"selectedUser.zip"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Adres","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.street),callback:function ($$v) {_vm.$set(_vm.selectedUser, "street", $$v)},expression:"selectedUser.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Huisnr","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.streetno),callback:function ($$v) {_vm.$set(_vm.selectedUser, "streetno", $$v)},expression:"selectedUser.streetno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedUser.phoneno),callback:function ($$v) {_vm.$set(_vm.selectedUser, "phoneno", $$v)},expression:"selectedUser.phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-select',{attrs:{"label":"Borg betaald","items":_vm.selectItems,"item-text":"text","item-value":"value"},model:{value:(_vm.selectedUser.paid),callback:function ($$v) {_vm.$set(_vm.selectedUser, "paid", $$v)},expression:"selectedUser.paid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-select',{attrs:{"label":"Mag huren","items":_vm.selectItems,"item-text":"text","item-value":"value"},model:{value:(_vm.selectedUser.canRent),callback:function ($$v) {_vm.$set(_vm.selectedUser, "canRent", $$v)},expression:"selectedUser.canRent"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.selectItems,"label":"Gebruiker actief","item-text":"text","item-value":"value"},model:{value:(_vm.selectedUser.active),callback:function ($$v) {_vm.$set(_vm.selectedUser, "active", $$v)},expression:"selectedUser.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Tegoed","type":"number","min":"0","step":"0.01"},model:{value:(_vm.selectedUser.credit),callback:function ($$v) {_vm.$set(_vm.selectedUser, "credit", $$v)},expression:"selectedUser.credit"}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.customerType === 'temp')?_c('v-layout',[_c('temp-customer',{attrs:{"user":_vm.tempCustomer,"optional":false}})],1):_vm._e()],1),_vm._v(" "),_c('small',[_vm._v("* Verplichte velden")])],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Historie',attrs:{"value":'Historie'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Historie")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.selectedUser.history)?_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('ul',{staticClass:"historyList"},_vm._l((_vm.selectedUser.history),function(item,index){return _c('li',{key:item.rentId,staticClass:"item",on:{"click":function($event){return _vm.showHistory(item.rentId)}}},[_c('i',{staticClass:"right triangle icon"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('b',{staticClass:"header"},[_vm._v("Fact. nr: "+_vm._s(item.reservationNumber)+".\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.startDate)+" t/m "+_vm._s(item.endDate))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t€ "+_vm._s(_vm._f("toCurrency")(item.totalCosts))+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+" - "+_vm._s(item.mileage)+" km.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.remark)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])}),0),_vm._v("\n\t\t\t\t\t\t\t\t\t\tTotaal km: "+_vm._s(_vm.totalKm)+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.selectedUser.history)?_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Geen historie")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Opties',attrs:{"value":'Opties'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Opties")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.confirmDeleteDialog = true}}},[_vm._v("Verwijder gebruiker")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Informatie',attrs:{"value":'Informatie'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Informatie")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-textarea',{attrs:{"name":"remarks","label":"Opmerkingen","value":""},model:{value:(_vm.selectedUser.remarks),callback:function ($$v) {_vm.$set(_vm.selectedUser, "remarks", $$v)},expression:"selectedUser.remarks"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Gebruiker controleren',attrs:{"value":'Gebruiker controleren'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Gebruiker controleren")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{staticClass:"px-0",attrs:{"grid-list-md":""}},[(_vm.selectedUser.rentalCheck_status === 'pending')?_c('table-loader'):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[(_vm.selectedUser.rentalCheck_status === '')?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.checkUser()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tDoe externe controle\n\t\t\t\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),(_vm.rentalCheckResult && !_vm.rentalCheckResult.registration)?_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"type":"error","value":true}},[_vm._v(_vm._s(_vm.rentalCheckResult))])],1)],1):_vm._e(),_vm._v(" "),(_vm.rentalCheckPhotos.length > 0)?_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.downloadRentalCheckPhotos()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDownload foto's\n\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){return _vm.deleteRentalCheckPhotos()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tVerwijder foto's\n\t\t\t\t\t\t\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Rijbewijsfoto's")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.rentalCheckPhotos),function(photo){return _c('v-flex',{key:photo.id,attrs:{"xs6":"","sm4":"","md4":""}},[_c('v-card',[_c('img',{staticStyle:{"width":"164px"},attrs:{"src":photo.url,"contain":""}}),_vm._v(" "),(photo.filename)?_c('v-card-text',[_c('small',[_vm._v(_vm._s(photo.filename))])]):_vm._e()],1)],1)}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.rentalCheckExecutions.length > 0)?_c('v-layout',{staticClass:"hidden-sm-and-up",attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Checks")])]),_vm._v(" "),_vm._l((_vm.rentalCheckExecutions),function(execution){return _c('v-flex',{key:execution.id,attrs:{"xs12":""}},[_c('v-card',{staticClass:"check-card"},[_c('v-card-text',[_c('div',{staticClass:"check-item"},[_c('span',{staticClass:"check-label"},[_vm._v("Type:")]),_vm._v(" "),_c('span',{staticClass:"check-value"},[_vm._v(_vm._s(execution.type))])]),_vm._v(" "),_c('div',{staticClass:"check-item"},[_c('span',{staticClass:"check-label"},[_vm._v("Uitgevoerd op:")]),_vm._v(" "),_c('span',{staticClass:"check-value"},[_vm._v(_vm._s(_vm.formatExecutionDate(execution.performed_at)))])]),_vm._v(" "),_c('div',{staticClass:"check-item"},[_c('span',{staticClass:"check-label"},[_vm._v("Status:")]),_vm._v(" "),_c('span',{staticClass:"check-value",class:'status-' + execution.status},[_vm._v(_vm._s(execution.status))])]),_vm._v(" "),_c('div',{staticClass:"check-item"},[_c('span',{staticClass:"check-label"},[_vm._v("Bericht:")]),_vm._v(" "),_c('span',{staticClass:"check-value"},[_vm._v(_vm._s(execution.message))])]),_vm._v(" "),(execution.pdf_report_url || execution.html_report_url)?_c('div',{staticClass:"check-item"},[_c('span',{staticClass:"check-label"},[_vm._v("Rapporten:")]),_vm._v(" "),_c('span',{staticClass:"check-value"},[(execution.pdf_report_url)?_c('a',{attrs:{"href":"#","rel":"noopener noreferrer"},on:{"click":function($event){$event.preventDefault();return _vm.openRentalCheckReport(execution.pdf_report_url, 'pdf')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPDF\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(execution.pdf_report_url && execution.html_report_url)?_c('span',[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(execution.html_report_url)?_c('a',{attrs:{"href":"#","rel":"noopener noreferrer"},on:{"click":function($event){$event.preventDefault();return _vm.openRentalCheckReport(execution.html_report_url, 'html')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tHTML\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()])]):_vm._e()])],1)],1)})],2):_vm._e(),_vm._v(" "),(_vm.rentalCheckExecutions.length > 0)?_c('v-layout',{staticClass:"hidden-xs-only",attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Checks")]),_vm._v(" "),_c('table',{staticClass:"checks-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Uitgevoerd op")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Bericht")]),_vm._v(" "),_c('th',[_vm._v("Rapporten")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rentalCheckExecutions),function(execution){return _c('tr',{key:execution.id},[_c('td',[_vm._v(_vm._s(execution.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatExecutionDate(execution.performed_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(execution.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(execution.message))]),_vm._v(" "),_c('td',[(execution.pdf_report_url)?_c('a',{attrs:{"href":"#","rel":"noopener noreferrer"},on:{"click":function($event){$event.preventDefault();return _vm.openRentalCheckReport(execution.pdf_report_url, 'pdf')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPDF\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(execution.pdf_report_url && execution.html_report_url)?_c('span',[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(execution.html_report_url)?_c('a',{attrs:{"href":"#","rel":"noopener noreferrer"},on:{"click":function($event){$event.preventDefault();return _vm.openRentalCheckReport(execution.html_report_url, 'html')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tHTML\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()])])}),0)])])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary darken-1"},nativeOn:{"click":function($event){return _vm.updateUser()}}},[_vm._v("Opslaan")])],1)],1)],1)],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.confirmDeleteDialog),callback:function ($$v) {_vm.confirmDeleteDialog=$$v},expression:"confirmDeleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Weet u het zeker?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Klik op bevestigen om de gebruiker te verwijderen.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.confirmDeleteDialog = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.deleteUser()}}},[_vm._v("Bevestigen")])],1)],1)],1)],1)}
var UserModal_staticRenderFns = []
var UserModal_esExports = { render: UserModal_render, staticRenderFns: UserModal_staticRenderFns }
/* harmony default export */ var Users_UserModal = (UserModal_esExports);
// CONCATENATED MODULE: ./src/components/Users/UserModal.vue
function UserModal_injectStyle (ssrContext) {
  __webpack_require__("sUTh")
}
var UserModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserModal___vue_template_functional__ = false
/* styles */
var UserModal___vue_styles__ = UserModal_injectStyle
/* scopeId */
var UserModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserModal___vue_module_identifier__ = null
var UserModal_Component = UserModal_normalizeComponent(
  UserModal,
  Users_UserModal,
  UserModal___vue_template_functional__,
  UserModal___vue_styles__,
  UserModal___vue_scopeId__,
  UserModal___vue_module_identifier__
)

/* harmony default export */ var components_Users_UserModal = (UserModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/DeviceBattery.vue
//
//
//
//
//
//
//

/* harmony default export */ var DeviceBattery = ({
  name: "DeviceBattery",
  props: ["percentage"],
  data: function data() {
    return {};
  },

  computed: {
    fill: function fill() {
      if (this.percentage === 0) {
        return 0;
      } else {
        return this.percentage / 100 * 14;
      }
    },
    fillColor: function fillColor() {
      if (this.percentage > 75) return "green";
      if (this.percentage > 50) return "orange";
      if (this.percentage > 0) return "red";
    },
    convertedPercentage: function convertedPercentage() {
      return this.percentage.toFixed(0);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126e200c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/DeviceBattery.vue
var DeviceBattery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"battery",style:({'box-shadow': ' inset 0 -' + _vm.fill + 'px 0px '+_vm.fillColor, 'border-color':_vm.fillColor}),attrs:{"data-percentage":_vm.convertedPercentage + '%'}})}
var DeviceBattery_staticRenderFns = []
var DeviceBattery_esExports = { render: DeviceBattery_render, staticRenderFns: DeviceBattery_staticRenderFns }
/* harmony default export */ var Units_DeviceBattery = (DeviceBattery_esExports);
// CONCATENATED MODULE: ./src/components/Units/DeviceBattery.vue
function DeviceBattery_injectStyle (ssrContext) {
  __webpack_require__("kRMa")
}
var DeviceBattery_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DeviceBattery___vue_template_functional__ = false
/* styles */
var DeviceBattery___vue_styles__ = DeviceBattery_injectStyle
/* scopeId */
var DeviceBattery___vue_scopeId__ = "data-v-126e200c"
/* moduleIdentifier (server only) */
var DeviceBattery___vue_module_identifier__ = null
var DeviceBattery_Component = DeviceBattery_normalizeComponent(
  DeviceBattery,
  Units_DeviceBattery,
  DeviceBattery___vue_template_functional__,
  DeviceBattery___vue_styles__,
  DeviceBattery___vue_scopeId__,
  DeviceBattery___vue_module_identifier__
)

/* harmony default export */ var components_Units_DeviceBattery = (DeviceBattery_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/UnitControl.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UnitControl = ({
	name: 'UnitControl',
	components: { DeviceBattery: components_Units_DeviceBattery },
	data: function data() {
		return {
			utils: utils_namespaceObject,
			successMsg: false,
			loading: false,
			items: [{
				title: 'Openen'
			}, {
				title: 'Sluiten'
			}, {
				title: 'Onderbreking aan'
			}, {
				title: 'Onderbreking uit'
			}]
		};
	},

	props: ['unitId', 'sensors', 'status', 'showRefresh'],
	created: function created() {},

	computed: {
		showSensors: function showSensors() {
			return this.sensors ? keys_default()(this.sensors).length > 0 : false;
		}
	},
	methods: {
		sendCommand: function sendCommand(index) {
			var self = this;
			self.loading = true;
			self.successMsg = false;
			utils_getData(basePath + 'api/rentunits/sendCommand/' + this.unitId + '/' + index).then(function (response) {
				self.loading = false;
				if (response && response.data && response.data.success) {
					self.successMsg = true;
					window.emitter.$emit('showToastMessage', {
						msg: 'Commando verzonden'
					});
				}
				if (!self.successMsg) {
					window.emitter.$emit('showToastMessage', {
						msg: 'ERROR: Commando verzonden: ' + (response && response.data ? response.data.msg : ''),
						type: 'error'
					});
				}
			});
		},
		refresh: function refresh() {
			this.$emit('refreshSensors');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c09b5fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/UnitControl.vue
var UnitControl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"sensorContainer",style:({ visibility: _vm.showSensors ? 'visible' : '' }),attrs:{"disabled":""}},[(_vm.sensors && _vm.sensors.fuelcardIn >= 0 && _vm.unitId)?_c('v-badge',[_c('v-icon',{attrs:{"color":_vm.sensors.fuelcardIn ? 'green' : 'red'}},[_vm._v("local_gas_station")])],1):_vm._e(),_vm._v(" "),(_vm.sensors && _vm.sensors.keyIn >= 0 && _vm.unitId)?_c('v-badge',[_c('v-icon',{attrs:{"color":_vm.sensors.keyIn ? 'green' : 'red'}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v(" "),(_vm.sensors && _vm.sensors.battery >= 0)?_c('v-badge',[(_vm.sensors && _vm.sensors.battery)?_c('device-battery',{staticClass:"right",staticStyle:{"transform":"translate(50%, 0)"},attrs:{"percentage":_vm.sensors.battery}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"refresher"},[(_vm.showRefresh)?_c('v-icon',{on:{"click":function($event){return _vm.refresh()}}},[_vm._v("refresh")]):_vm._e(),_vm._v(" "),(!_vm.showRefresh)?_c('v-progress-circular',{staticStyle:{"transform":"translate(0,5px)"},attrs:{"size":20,"indeterminate":""}}):_vm._e()],1)],1)]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"elevation-0",attrs:{"flat":"","disabled":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_vm._v(" "),(_vm.unitId)?_c('v-menu',{staticClass:"dialogDropdown",attrs:{"bottom":"","left":"","offset-y":""}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("phonelink_lock")])],1),_vm._v(" "),_c('v-list',{staticClass:"dialogDropdown",attrs:{"menu-props":"{'contentClass':'dialogDropdown','bottom':true}"}},_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.sendCommand(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1):_vm._e()],1)],1)}
var UnitControl_staticRenderFns = []
var UnitControl_esExports = { render: UnitControl_render, staticRenderFns: UnitControl_staticRenderFns }
/* harmony default export */ var Units_UnitControl = (UnitControl_esExports);
// CONCATENATED MODULE: ./src/components/Units/UnitControl.vue
function UnitControl_injectStyle (ssrContext) {
  __webpack_require__("As5s")
}
var UnitControl_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnitControl___vue_template_functional__ = false
/* styles */
var UnitControl___vue_styles__ = UnitControl_injectStyle
/* scopeId */
var UnitControl___vue_scopeId__ = "data-v-5c09b5fc"
/* moduleIdentifier (server only) */
var UnitControl___vue_module_identifier__ = null
var UnitControl_Component = UnitControl_normalizeComponent(
  UnitControl,
  Units_UnitControl,
  UnitControl___vue_template_functional__,
  UnitControl___vue_styles__,
  UnitControl___vue_scopeId__,
  UnitControl___vue_module_identifier__
)

/* harmony default export */ var components_Units_UnitControl = (UnitControl_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/subcomponents/CoordinatePicker.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CoordinatePicker = ({
	name: 'CoordinatePicker',
	props: {
		lat: {
			type: Number,
			default: 52.1326
		},
		lng: {
			type: Number,
			default: 5.2913
		}
	},
	data: function data() {
		return {
			coordinates: {
				lat: this.lat || 52.1326,
				lng: this.lng || 5.2913
			},
			mapCenter: {
				lat: this.lat || 52.1326,
				lng: this.lng || 5.2913
			},
			mapZoom: 7,
			mapInitialized: false,
			showFullMap: false,
			infoWindowOpen: false,
			markerIcon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
			mapOptions: {
				gestureHandling: 'greedy',
				styles: this.getDarkMapStyles()
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		console.log('[CoordinatePicker] Component mounted');
		// Use nextTick to ensure Vue and Google Maps API are ready
		this.$nextTick(function () {
			if (typeof window.google !== 'undefined' && window.google.maps) {
				console.log('[CoordinatePicker] Google Maps API available immediately');
				_this.mapInitialized = true;
			} else {
				// Wait for Google Maps to load
				var checkInterval = setInterval(function () {
					if (typeof window.google !== 'undefined' && window.google.maps) {
						console.log('[CoordinatePicker] Google Maps API loaded');
						_this.mapInitialized = true;
						clearInterval(checkInterval);
					}
				}, 100);

				// Timeout after 10 seconds
				setTimeout(function () {
					if (!_this.mapInitialized) {
						console.error('[CoordinatePicker] Failed to load Google Maps API after 10 seconds');
						clearInterval(checkInterval);
						_this.mapInitialized = true; // Force show the map anyway
					}
				}, 10000);
			}
		});
	},

	methods: {
		handleMapClick: function handleMapClick(event) {
			console.log('[CoordinatePicker] Map clicked:', event.latLng);
			var lat = event.latLng.lat();
			var lng = event.latLng.lng();
			this.coordinates.lat = lat;
			this.coordinates.lng = lng;
			this.mapCenter = { lat: lat, lng: lng };
			this.infoWindowOpen = true;
		},
		handleMarkerDrag: function handleMarkerDrag(event) {
			this.coordinates.lat = event.latLng.lat();
			this.coordinates.lng = event.latLng.lng();
		},
		handleMarkerDragEnd: function handleMarkerDragEnd(event) {
			this.coordinates.lat = event.latLng.lat();
			this.coordinates.lng = event.latLng.lng();
		},
		onZoomChanged: function onZoomChanged(zoom) {
			this.mapZoom = zoom;
		},
		setDefaultCenter: function setDefaultCenter() {
			this.coordinates = {
				lat: 52.1326,
				lng: 5.2913
			};
			this.mapCenter = {
				lat: 52.1326,
				lng: 5.2913
			};
			this.mapZoom = 7;
		},
		toggleMapView: function toggleMapView() {
			this.showFullMap = !this.showFullMap;
		},
		applyCoordinates: function applyCoordinates() {
			this.$emit('coordinates-selected', {
				lat: this.coordinates.lat,
				lng: this.coordinates.lng
			});
		},
		copyToClipboard: function copyToClipboard(field) {
			var _this2 = this;

			var value = this.coordinates[field];
			navigator.clipboard.writeText(value.toString()).then(function () {
				_this2.$emit('show-message', {
					msg: field.toUpperCase() + ' gecopieerd: ' + value,
					type: 'success'
				});
			});
		},
		getDarkMapStyles: function getDarkMapStyles() {
			return [{ elementType: 'geometry', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] }, {
				featureType: 'administrative.locality',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [{ color: '#263c3f' }]
			}, {
				featureType: 'poi.park',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#6b9a76' }]
			}, {
				featureType: 'road',
				elementType: 'geometry',
				stylers: [{ color: '#38414e' }]
			}, {
				featureType: 'road',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#212a37' }]
			}, {
				featureType: 'road',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#9ca5b3' }]
			}, {
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [{ color: '#746855' }]
			}, {
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#1f2835' }]
			}, {
				featureType: 'road.highway',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#f3d19c' }]
			}, {
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [{ color: '#2f3948' }]
			}, {
				featureType: 'transit.station',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#d59563' }]
			}, {
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{ color: '#17263c' }]
			}, {
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [{ color: '#515c6d' }]
			}, {
				featureType: 'water',
				elementType: 'labels.text.stroke',
				stylers: [{ color: '#17263c' }]
			}];
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d283dd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponents/CoordinatePicker.vue
var CoordinatePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coordinate-picker"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Locatie selecteren")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.toggleMapView}},[_c('v-icon',[_vm._v(_vm._s(_vm.showFullMap ? 'unfold_less' : 'unfold_more'))])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Latitude","type":"number","step":"0.000001","required":"","readonly":"","hint":"Klik om te copieren"},on:{"click":function($event){return _vm.copyToClipboard('lat')}},model:{value:(_vm.coordinates.lat),callback:function ($$v) {_vm.$set(_vm.coordinates, "lat", _vm._n($$v))},expression:"coordinates.lat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Longitude","type":"number","step":"0.000001","required":"","readonly":"","hint":"Klik om te copieren"},on:{"click":function($event){return _vm.copyToClipboard('lng')}},model:{value:(_vm.coordinates.lng),callback:function ($$v) {_vm.$set(_vm.coordinates, "lng", _vm._n($$v))},expression:"coordinates.lng"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"color":"success","small":"","disabled":!_vm.coordinates.lat || !_vm.coordinates.lng},on:{"click":_vm.applyCoordinates}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check")]),_vm._v("\n\t\t\t\t\t\t\t\tPas toe\n\t\t\t\t\t\t\t")],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('p',{staticClass:"caption grey--text"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("info")]),_vm._v("\n\t\t\t\t\t\tKlik op de kaart om coördinaten te selecteren\n\t\t\t\t\t")],1),_vm._v(" "),_c('div',{staticClass:"map-container",style:({ height: _vm.showFullMap ? '600px' : '400px' })},[_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.mapCenter,"zoom":_vm.mapZoom,"map-type-id":"terrain","options":_vm.mapOptions},on:{"click":_vm.handleMapClick,"zoom_changed":_vm.onZoomChanged}},[(_vm.coordinates.lat && _vm.coordinates.lng)?_c('gmap-marker',{attrs:{"position":{ lat: _vm.coordinates.lat, lng: _vm.coordinates.lng },"icon":_vm.markerIcon,"draggable":true},on:{"drag":_vm.handleMarkerDrag,"dragend":_vm.handleMarkerDragEnd}},[_c('gmap-info-window',{attrs:{"opened":_vm.infoWindowOpen}},[_c('div',[_c('p',[_c('strong',[_vm._v("Geselecteerde locatie")])]),_vm._v(" "),_c('p',[_vm._v("Lat: "+_vm._s(_vm.coordinates.lat.toFixed(6)))]),_vm._v(" "),_c('p',[_vm._v("Lng: "+_vm._s(_vm.coordinates.lng.toFixed(6)))]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.applyCoordinates}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tBevestigen\n\t\t\t\t\t\t\t\t\t")])],1)])],1):_vm._e()],1),_vm._v(" "),(!_vm.mapInitialized)?_c('div',{staticClass:"loading-overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1),_vm._v(" "),(!_vm.mapInitialized)?_c('v-alert',{attrs:{"type":"warning"}},[_vm._v("\n\t\t\t\t\tMap is aan het laden...\n\t\t\t\t")]):_vm._e()],1)],1)],1)],1)],1)}
var CoordinatePicker_staticRenderFns = []
var CoordinatePicker_esExports = { render: CoordinatePicker_render, staticRenderFns: CoordinatePicker_staticRenderFns }
/* harmony default export */ var subcomponents_CoordinatePicker = (CoordinatePicker_esExports);
// CONCATENATED MODULE: ./src/components/subcomponents/CoordinatePicker.vue
function CoordinatePicker_injectStyle (ssrContext) {
  __webpack_require__("8m7h")
}
var CoordinatePicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CoordinatePicker___vue_template_functional__ = false
/* styles */
var CoordinatePicker___vue_styles__ = CoordinatePicker_injectStyle
/* scopeId */
var CoordinatePicker___vue_scopeId__ = "data-v-9d283dd8"
/* moduleIdentifier (server only) */
var CoordinatePicker___vue_module_identifier__ = null
var CoordinatePicker_Component = CoordinatePicker_normalizeComponent(
  CoordinatePicker,
  subcomponents_CoordinatePicker,
  CoordinatePicker___vue_template_functional__,
  CoordinatePicker___vue_styles__,
  CoordinatePicker___vue_scopeId__,
  CoordinatePicker___vue_module_identifier__
)

/* harmony default export */ var components_subcomponents_CoordinatePicker = (CoordinatePicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/UnitModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import Planner from '@/components/Planner'
/* harmony default export */ var UnitModal = ({
	name: 'UnitModal',
	components: { UnitControl: components_Units_UnitControl, CoordinatePicker: components_subcomponents_CoordinatePicker },
	created: function created() {},
	mounted: function mounted() {
		this.getAvailableDevices();
		this.userType = localStorage.getItem('t');
	},
	data: function data() {
		return {
			active: 'Gegevens',
			unitData: {
				sensors: {}
			},
			markers: [],
			valid: false,
			showMap: false,
			image: '',
			colors: ['Wit', 'Zwart', 'Grijs', 'Zilver', 'Rood', 'Blauw', 'Geel', 'Groen', 'Oranje', 'Bruin', 'Paars'],
			lat: '',
			phoneNo: '',
			lng: '',
			new: false,
			utils: utils_namespaceObject,
			sensors: {},
			basicRules: [function (v) {
				return !!v || 'Verplicht veld';
			}],
			prices: [],
			showModal: false,
			selectedUnit: {},
			availableDevices: [],
			userType: 'default'
		};
	},

	props: ['edit', 'id'],
	computed: {
		tabs: function tabs() {
			if (this.unitData.id > 0) {
				return ['Gegevens', 'Instellingen', 'Kaart', 'Opties'];
			} else {
				return ['Gegevens', 'Instellingen'];
			}
		},
		deviceId: function deviceId() {
			return this.unitData.wialonUnitId ? this.unitData.wialonUnitId : this.unitData.i;
		},

		testDriveUnit: {
			get: function get() {
				return this.unitData.testDriveUnit === '1';
			},
			set: function set(value) {
				this.unitData.testDriveUnit = value ? '1' : '0';
			}
		},
		callUnit: {
			get: function get() {
				return this.unitData.callUnit === '1';
			},
			set: function set(value) {
				this.unitData.callUnit = value ? '1' : '0';
			}
		},
		lockDuoSensor: {
			get: function get() {
				return this.unitData.lock_duo_sensor === '1';
			},
			set: function set(value) {
				this.unitData.lock_duo_sensor = value ? '1' : '0';
			}
		}
	},
	watch: {
		unitData: function unitData(newValue) {
			this.setUnit();
		},
		active: function active(val) {
			var self = this;
			if (val === 'Kaart' && !self.showMap) {
				setTimeout(function () {
					self.showMap = true;
				}, 100);
			}
		},
		showModal: function showModal(val) {
			if (val) {
				this.getPrices();
			}
		}
	},
	methods: {
		closeModal: function closeModal() {
			this.showModal = false;
		},
		updateModel: function updateModel() {
			// Todo maybe better solution
			this.$emit('updateUnits');
		},
		getDeviceData: function getDeviceData(value) {
			var unit = vue_underscore["a" /* _ */].findWhere(this.wialonUnits, { i: parseInt(value) });
			if (unit) {
				var selectedUnit = {
					name: this.unitData.name,
					wialonUnitId: String(unit.d.id),
					sensors: unit.d.sens,
					license: this.unitData.license,
					new: true
				};
				this.unitData = selectedUnit;
			} else {
				this.unitData.wialonUnitId = String(value);
				this.unitData.new = true;
				this.unitData.sensors = {};
			}
		},
		getAvailableDevices: function getAvailableDevices() {
			var self = this;
			utils_getData(basePath + 'api/rentunits/getWialonUnits').then(function (json) {
				if (json.wialonUnits && json.wialonUnits.length) {
					var wialonUnits = json.wialonUnits;
					var availableDevices = [];
					for (var i = 0; i < wialonUnits.length; i++) {
						availableDevices.push({
							description: wialonUnits[i].d.nm,
							id: String(wialonUnits[i].d.id)
						});
					}

					availableDevices.unshift({
						description: 'Zonder tracker',
						id: '0'
					});
					self.availableDevices = availableDevices;
					self.wialonUnits = wialonUnits;
				}
			});
		},
		setUnit: function setUnit() {
			var self = this;
			self.phoneNo = '';
			if (!self.unitData.new) {
				this.new = false;
				if (self.unitData.pos) {
					this.markers[0] = {
						position: {
							lat: self.unitData.pos.y,
							lng: self.unitData.pos.x
						}
					};
					self.unitData.active = self.unitData.active === '1';
				} else {
					self.unitData.active = self.unitData.active === '1';
					self.getUnit();
				}

				self.getUnitSensorData();
			} else {
				this.new = true;
				self.unitData = self.unitData;
				var sensors = self.unitData.sensors;
				if (sensors) {
					var sensorKey = vue_underscore["a" /* _ */].findWhere(sensors, { n: 'Sleutel_in_dash' });
					self.unitData.sensor_id_key = sensorKey ? sensorKey.id : '0';

					var sensorFuelCard = vue_underscore["a" /* _ */].findWhere(sensors, { n: 'Tankpas_in_dash' });
					self.unitData.sensor_id_fuelcard = sensorFuelCard ? sensorFuelCard.id : '0';

					var sensorVoltage = vue_underscore["a" /* _ */].findWhere(sensors, { n: 'Accu voltage' });
					self.unitData.sensor_id_volt = sensorVoltage ? sensorVoltage.id : '0';

					var sensorLock = vue_underscore["a" /* _ */].findWhere(sensors, { n: 'Auto_op_slot' });
					self.unitData.sensor_id_closed = sensorLock ? sensorLock.id : '0';
				} else {
					self.unitData.sensor_id_key = '0';
					self.unitData.sensor_id_fuelcard = '0';
					self.unitData.sensor_id_volt = '0';
					self.unitData.sensor_id_closed = '0';
				}
			}
		},
		getUnit: function getUnit() {
			var self = this;
			utils_getData(basePath + 'api/rentunits/getUnit/' + this.unitData.unitId).then(function (json) {
				if (json && json.data && json.data.length) {
					self.unitData = json.data[0];
				}
			});
		},
		getUnitSensorData: function getUnitSensorData() {
			var self = this;
			utils_getData(basePath + 'api/rentunits/getUnitData/' + this.unitData.unitId).then(function (json) {
				if (json.data && json.data.item) {
					self.phoneNo = json.data.item.ph;
					self.sensors = json.data.sensors;
					self.unitData.sens = json.data.sens;
				}
			});
		},
		updateUnit: function updateUnit() {
			var self = this;
			if (this.$refs.unitForm.validate()) {
				this.unitData.new = this.new;
				this.unitData.image = this.image;
				this.unitData.wialonUnitId = this.deviceId;
				this.unitData.callUnit = this.callUnit;
				this.unitData.testDriveUnit = this.testDriveUnit;

				setData(basePath + 'api/rentunits/updateUnit/', this.unitData).then(function (json) {
					self.updateModel();
				});

				this.showModal = false;
			}
		},
		movePos: function movePos(val) {
			this.lat = val.latLng.lat();
			this.lng = val.latLng.lng();
			if (this.markers[1]) {
				this.markers[1].position.lat = val.latLng.lat();
				this.markers[1].position.lng = val.latLng.lng();
			}
		},
		getPos: function getPos(val) {
			this.lat = val.latLng.lat();
			this.lng = val.latLng.lng();
			var marker = {
				position: {
					lat: this.lat,
					lng: this.lng
				},
				animation: google.maps.Animation.DROP
			};

			if (this.markers[1]) {
				this.markers[1] = marker;
			} else {
				this.markers.push(marker);
			}
		},
		usePos: function usePos() {
			this.unitData.parkingLat = this.lat;
			this.unitData.parkingLng = this.lng;
		},
		setImage: function setImage(e) {
			var self = this;
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;

			var file = files[0];
			var image = new Image();
			var reader = new FileReader();
			var vm = this;

			reader.onload = function (e) {
				self.image = e.target.result;
			};

			reader.readAsDataURL(file);
		},
		getPrices: function getPrices() {
			var self = this;
			utils_getData(basePath + 'api/prices/getPriceGroups/').then(function (json) {
				self.prices = json.data;
			});
		},
		onCoordinatesSelected: function onCoordinatesSelected(coordinates) {
			this.unitData.parkingLat = coordinates.lat;
			this.unitData.parkingLng = coordinates.lng;
			window.emitter.$emit('showToastMessage', {
				msg: 'Co\xF6rdinaten bijgewerkt: Lat ' + coordinates.lat.toFixed(6) + ', Lng ' + coordinates.lng.toFixed(6),
				type: 'success'
			});
		},
		showMessage: function showMessage(message) {
			window.emitter.$emit('showToastMessage', message);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269a048c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/UnitModal.vue
var UnitModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"lazy":"","persistent":"","max-width":"700px","transition":_vm.utils.getSettings('animation')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.showModal = false}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"compact"},[_c('v-form',{ref:"unitForm",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-tabs',{attrs:{"color":"blue darken-3","dark":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v(_vm._s(tab))])}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tabs-items',{attrs:{"touchless":_vm.active === 'Kaart'}},[_c('v-tab-item',{key:'Gegevens',attrs:{"value":'Gegevens'}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(parseInt(_vm.unitData.id) > 0
												? 'Wijzig unit'
												: 'Nieuwe unit')+"\n\t\t\t\t\t\t\t\t\t\t#"+_vm._s(_vm.unitData.unitId))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Naam","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.name),callback:function ($$v) {_vm.$set(_vm.unitData, "name", $$v)},expression:"unitData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Kenteken","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.license),callback:function ($$v) {_vm.$set(_vm.unitData, "license", $$v)},expression:"unitData.license"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"label":"Kleur","items":_vm.colors,"required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.color),callback:function ($$v) {_vm.$set(_vm.unitData, "color", $$v)},expression:"unitData.color"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"label":"Omschrijving","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.description),callback:function ($$v) {_vm.$set(_vm.unitData, "description", $$v)},expression:"unitData.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Parkeerlokatie Lat","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.parkingLat),callback:function ($$v) {_vm.$set(_vm.unitData, "parkingLat", $$v)},expression:"unitData.parkingLat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Parkeerlokatie Lng","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.parkingLng),callback:function ($$v) {_vm.$set(_vm.unitData, "parkingLng", $$v)},expression:"unitData.parkingLng"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Parkeerlokatie omschrijving","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.standplaats),callback:function ($$v) {_vm.$set(_vm.unitData, "standplaats", $$v)},expression:"unitData.standplaats"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"label":"Brandstof","required":"","rules":_vm.basicRules,"items":['Benzine', 'Diesel', 'Elektrisch']},model:{value:(_vm.unitData.fuel),callback:function ($$v) {_vm.$set(_vm.unitData, "fuel", $$v)},expression:"unitData.fuel"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.availableDevices,"label":"Unit","item-text":"description","item-value":"id","required":"","rules":_vm.basicRules},on:{"change":function($event){return _vm.getDeviceData($event)}},model:{value:(_vm.unitData.wialonUnitId),callback:function ($$v) {_vm.$set(_vm.unitData, "wialonUnitId", $$v)},expression:"unitData.wialonUnitId"}})],1),_vm._v(" "),(_vm.unitData.unitId > 0)?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"UnitId","type":"text","readonly":"","rules":_vm.basicRules},model:{value:(_vm.unitData.unitId),callback:function ($$v) {_vm.$set(_vm.unitData, "unitId", $$v)},expression:"unitData.unitId"}})],1):_vm._e(),_vm._v(" "),(_vm.userType === 'with-site')?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-checkbox',{attrs:{"label":"Toon op website"},model:{value:(_vm.unitData.active),callback:function ($$v) {_vm.$set(_vm.unitData, "active", $$v)},expression:"unitData.active"}})],1):_vm._e()],1),_vm._v(" "),_c('small',[_vm._v("* Verplichte velden")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Instellingen',attrs:{"value":'Instellingen'}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.unitData.id > 0 ? 'Wijzig unit' : 'Nieuwe unit')+" #"+_vm._s(_vm.unitData.unitId))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.userType === 'with-site')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-checkbox',{attrs:{"label":"Bel unit"},model:{value:(_vm.callUnit),callback:function ($$v) {_vm.callUnit=$$v},expression:"callUnit"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-checkbox',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"label":"Proefrit unit"},model:{value:(_vm.testDriveUnit),callback:function ($$v) {_vm.testDriveUnit=$$v},expression:"testDriveUnit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.prices,"label":"Prijscategorie","item-value":"priceCat","item-text":"groupDescription","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.priceCat),callback:function ($$v) {_vm.$set(_vm.unitData, "priceCat", $$v)},expression:"unitData.priceCat"}})],1),_vm._v(" "),_c('v-flex',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Sensor sleutel","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.sensor_id_key),callback:function ($$v) {_vm.$set(_vm.unitData, "sensor_id_key", $$v)},expression:"unitData.sensor_id_key"}})],1),_vm._v(" "),_c('v-flex',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Sensor tankpas","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.sensor_id_fuelcard),callback:function ($$v) {_vm.$set(_vm.unitData, "sensor_id_fuelcard", $$v)},expression:"unitData.sensor_id_fuelcard"}})],1),_vm._v(" "),_c('v-flex',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Sensor voltage","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.sensor_id_volt),callback:function ($$v) {_vm.$set(_vm.unitData, "sensor_id_volt", $$v)},expression:"unitData.sensor_id_volt"}})],1),_vm._v(" "),_c('v-flex',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Sensor slot","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.sensor_id_closed),callback:function ($$v) {_vm.$set(_vm.unitData, "sensor_id_closed", $$v)},expression:"unitData.sensor_id_closed"}})],1),_vm._v(" "),_c('v-flex',{style:(_vm.unitData.wialonUnitId === '0' ? 'display: none' : ''),attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-checkbox',{attrs:{"label":"2 commando's voor auto openen/sluiten"},model:{value:(_vm.lockDuoSensor),callback:function ($$v) {_vm.lockDuoSensor=$$v},expression:"lockDuoSensor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Pincode pas","required":"","rules":_vm.basicRules},model:{value:(_vm.unitData.fuelCardPin),callback:function ($$v) {_vm.$set(_vm.unitData, "fuelCardPin", $$v)},expression:"unitData.fuelCardPin"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Kilometerprijs","required":"","rules":_vm.basicRules,"min":"0","step":"0.01"},model:{value:(_vm.unitData.kmPrice),callback:function ($$v) {_vm.$set(_vm.unitData, "kmPrice", $$v)},expression:"unitData.kmPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Kilometervrij","required":"","rules":_vm.basicRules,"min":"0","step":"1"},model:{value:(_vm.unitData.freeMileage),callback:function ($$v) {_vm.$set(_vm.unitData, "freeMileage", $$v)},expression:"unitData.freeMileage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":"","mt-4":""}},[_c('input',{attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.setImage}}),_vm._v(" "),(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_vm._e()])],1),_vm._v(" "),_c('small',[_vm._v("* Verplichte velden")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Kaart',attrs:{"value":'Kaart'}},[_c('v-card',[_c('v-card-text',[(this.deviceId !== '0')?_c('coordinate-picker',{attrs:{"lat":_vm.unitData.parkingLat ? parseFloat(_vm.unitData.parkingLat) : 52.1326,"lng":_vm.unitData.parkingLng ? parseFloat(_vm.unitData.parkingLng) : 5.2913},on:{"coordinates-selected":_vm.onCoordinatesSelected,"show-message":_vm.showMessage}}):_vm._e(),_vm._v(" "),(this.deviceId === '0')?_c('p',{staticClass:"mt-4"},[_c('v-alert',{attrs:{"type":"info"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSelecteer eerst een tracker in het tabblad \"Gegevens\" om de kaart te gebruiken.\n\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Opties',attrs:{"value":'Opties'}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Opties")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.sensors)?_c('unit-control',{attrs:{"unitId":this.unitData.unitId,"sensors":_vm.sensors,"status":_vm.unitData.status}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary darken-1"},nativeOn:{"click":function($event){return _vm.updateUnit()}}},[_vm._v("Opslaan")])],1)],1)],1)],2)],1)],1)],1)],1)}
var UnitModal_staticRenderFns = []
var UnitModal_esExports = { render: UnitModal_render, staticRenderFns: UnitModal_staticRenderFns }
/* harmony default export */ var Units_UnitModal = (UnitModal_esExports);
// CONCATENATED MODULE: ./src/components/Units/UnitModal.vue
var UnitModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnitModal___vue_template_functional__ = false
/* styles */
var UnitModal___vue_styles__ = null
/* scopeId */
var UnitModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnitModal___vue_module_identifier__ = null
var UnitModal_Component = UnitModal_normalizeComponent(
  UnitModal,
  Units_UnitModal,
  UnitModal___vue_template_functional__,
  UnitModal___vue_styles__,
  UnitModal___vue_scopeId__,
  UnitModal___vue_module_identifier__
)

/* harmony default export */ var components_Units_UnitModal = (UnitModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/ReservationPrices.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ReservationPrices = ({
  name: "ReservationPrices",
  props: ["reservation", "editable", "edit"],
  utils: utils_namespaceObject,
  data: function data() {
    return {
      items: [],
      headers: [{ text: "Aantal", value: "hours", class: "" }, { text: "Eenheid", value: "timeUnit", class: "" }, { text: "Bedrag", value: "price", class: "" }, { text: "Km vrij", value: "kmFree", class: "" }, { text: "Opties", value: "hours", class: "", sortable: false }],
      timeOptions: [{
        value: "hour",
        text: "uur"
      }, {
        value: "day",
        text: "dag"
      }, {
        value: "week",
        text: "week"
      }, {
        value: "month",
        text: "maand"
      }],
      addPriceDialog: false,
      newPrice: {
        hours: 0,
        timeUnit: "hour",
        price: 0,
        kmFree: 0
      },
      editedIndex: 0,
      editedItem: {},
      editPriceDialog: false
    };
  },

  methods: {
    deletePrice: function deletePrice(priceItem, index) {
      var self = this;
      priceItem.reservationId = this.reservation.id;
      if (priceItem.rentPriceId) {
        setData(basePath + "api/reservations/deleteReservationPrice/", priceItem).then(function (json) {
          self.reservation.costData.prices = vue_underscore["a" /* _ */].without(self.reservation.costData.prices, vue_underscore["a" /* _ */].findWhere(self.reservation.costData.prices, {
            rentPriceId: priceItem.rentPriceId
          }));
        });
      } else {
        self.reservation.costData.prices.splice(self.reservation.costData.prices.length - 1, 1);
      }
    },
    addPrice: function addPrice() {
      this.newPrice = {
        hours: 0,
        timeUnit: "hour",
        price: 0,
        kmFree: 0
      };
      this.addPriceDialog = true;
    },
    editPrice: function editPrice(item) {
      this.editedIndex = this.reservation.costData.prices.indexOf(item);
      this.editedItem = assign_default()({}, item);
      this.editPriceDialog = true;
    },
    saveNewPrice: function saveNewPrice() {
      this.reservation.costData.prices.push(this.newPrice);
      this.addPriceDialog = false;
    },
    updateTimeUnit: function updateTimeUnit(item, value) {
      item.timeUnit = value;
    },
    getTimeUnitDescription: function getTimeUnitDescription(timeUnit) {
      var data = vue_underscore["a" /* _ */].where(this.timeOptions, { value: timeUnit });
      if (data && data.length) {
        return data[0]["text"];
      } else {
        return "";
      }
    },
    saveEdit: function saveEdit() {
      if (this.editedIndex > -1) {
        assign_default()(this.reservation.costData.prices[this.editedIndex], this.editedItem);
      } else {
        this.reservation.costData.prices.push(this.editedItem);
      }
      this.closeEditPrice();
    },
    closeEditPrice: function closeEditPrice() {
      this.editPriceDialog = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4f9682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/ReservationPrices.vue
var ReservationPrices_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-dialog',{attrs:{"max-width":"600px"},model:{value:(_vm.edit.showModal),callback:function ($$v) {_vm.$set(_vm.edit, "showModal", $$v)},expression:"edit.showModal"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v("Tarieven")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"green darken-1"},nativeOn:{"click":function($event){return _vm.addPrice()}}},[_vm._v("Toevoegen")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.reservation.costData.prices,"hide-actions":"","rows-per-page-items":[25,50],"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n                                    "+_vm._s(header.text)+"\n                                    ")],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.editPrice(props.item, props.index)}}},[_vm._v("\n                                       "+_vm._s(props.item.hours)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.editPrice(props.item, props.index)}}},[_vm._v("\n                                       "+_vm._s(_vm.getTimeUnitDescription(props.item.timeUnit))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.editPrice(props.item, props.index)}}},[_vm._v("\n                                        "+_vm._s(props.item.price)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.editPrice(props.item, props.index)}}},[_vm._v("\n                                       "+_vm._s(props.item.kmFree)+"\n                                    ")]),_vm._v(" "),(_vm.reservation.costData.customPrices)?_c('td',{staticClass:"justify-center text-xs-left"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"gray","small":""},on:{"click":function($event){return _vm.editPrice(props.item, props.index)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"pink","small":""},on:{"click":function($event){return _vm.deletePrice(props.item, props.index)}}},[_vm._v("delete")])],1):_vm._e()])]}}])})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.edit.showModal = false;}}},[_vm._v("Sluiten")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.addPriceDialog),callback:function ($$v) {_vm.addPriceDialog=$$v},expression:"addPriceDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Tarief toevoegen")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Aantal","required":""},model:{value:(_vm.newPrice.hours),callback:function ($$v) {_vm.$set(_vm.newPrice, "hours", $$v)},expression:"newPrice.hours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Prijs","required":""},model:{value:(_vm.newPrice.price),callback:function ($$v) {_vm.$set(_vm.newPrice, "price", $$v)},expression:"newPrice.price"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getTimeUnitDescription(_vm.newPrice.timeUnit)))]),_vm._v(" "),_c('v-list',_vm._l((_vm.timeOptions),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){_vm.newPrice.timeUnit = item.value}},model:{value:(_vm.newPrice.timeUnit),callback:function ($$v) {_vm.$set(_vm.newPrice, "timeUnit", $$v)},expression:"newPrice.timeUnit"}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.getTimeUnitDescription(item.value)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Km vrij","required":""},model:{value:(_vm.newPrice.kmFree),callback:function ($$v) {_vm.$set(_vm.newPrice, "kmFree", $$v)},expression:"newPrice.kmFree"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.addPriceDialog = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.saveNewPrice()}}},[_vm._v("Opslaan")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.editPriceDialog),callback:function ($$v) {_vm.editPriceDialog=$$v},expression:"editPriceDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Bewerk prijs")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","step":"1","label":"Aantal"},model:{value:(_vm.editedItem.hours),callback:function ($$v) {_vm.$set(_vm.editedItem, "hours", $$v)},expression:"editedItem.hours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","step":"0.01","label":"Prijs"},model:{value:(_vm.editedItem.price),callback:function ($$v) {_vm.$set(_vm.editedItem, "price", $$v)},expression:"editedItem.price"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getTimeUnitDescription(_vm.editedItem.timeUnit)))]),_vm._v(" "),_c('v-list',_vm._l((_vm.timeOptions),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.updateTimeUnit(_vm.editedItem, item.value)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","step":"1","label":"Km vrij"},model:{value:(_vm.editedItem.kmFree),callback:function ($$v) {_vm.$set(_vm.editedItem, "kmFree", $$v)},expression:"editedItem.kmFree"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.closeEditPrice}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.saveEdit}},[_vm._v("Opslaan")])],1)],1)],1)],1)}
var ReservationPrices_staticRenderFns = []
var ReservationPrices_esExports = { render: ReservationPrices_render, staticRenderFns: ReservationPrices_staticRenderFns }
/* harmony default export */ var Reservations_ReservationPrices = (ReservationPrices_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/ReservationPrices.vue
var ReservationPrices_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReservationPrices___vue_template_functional__ = false
/* styles */
var ReservationPrices___vue_styles__ = null
/* scopeId */
var ReservationPrices___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReservationPrices___vue_module_identifier__ = null
var ReservationPrices_Component = ReservationPrices_normalizeComponent(
  ReservationPrices,
  Reservations_ReservationPrices,
  ReservationPrices___vue_template_functional__,
  ReservationPrices___vue_styles__,
  ReservationPrices___vue_scopeId__,
  ReservationPrices___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_ReservationPrices = (ReservationPrices_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/AdditionalItems.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AdditionalItems = ({
  name: "AdditionalItems",
  props: ["reservation", "editable", "edit"],
  utils: utils_namespaceObject,
  created: function created() {
    if (typeof this.reservation.costData.additionalItems === "undefined") {
      this.reservation.costData.additionalItems = [];
    }

    this.initAdditionalItems = this.reservation.costData.additionalItems.slice();
  },
  data: function data() {
    return {
      items: [],
      selectAvailable: null,
      initAdditionalItems: [],
      availableAdditionalItems: [],
      headers: [{ text: "Aantal", value: "quantity", class: "" }, { text: "Bedrag", value: "price", class: "" }, { text: "BTW", value: "vat", class: "" }, { text: "Omschrijving", value: "description", class: "" }, { text: "/", value: "", class: "", sortable: false }]
    };
  },

  watch: {
    "edit.showModal": function editShowModal(value) {
      if (value) {
        if (typeof this.reservation.costData.additionalItems === "undefined") {
          this.reservation.costData.additionalItems = [];
        }

        this.initAdditionalItems = this.reservation.costData.additionalItems.slice();
        this.getItems();
      }
    },
    selectAvailable: function selectAvailable(value) {
      // Add item
      this.reservation.costData.additionalItems.push({
        quantity: 1,
        description: value.description,
        price: value.price,
        vat: value.vat,
        id: value.value,
        itemId: value.id,
        new: false
      });
    }
  },
  methods: {
    getItems: function getItems() {
      var self = this;
      utils_getData(basePath + "api/reservations/getAdditionalItems/").then(function (json) {
        if (json && json.data) {
          self.availableAdditionalItems = json.data;
        }
      });
    },
    deleteAdditionalItem: function deleteAdditionalItem(item) {
      var self = this;

      // Check if already in DB
      if (this.reservation.id && !item.new) {
        item.reservationId = this.reservation.id;
        setData(basePath + "api/reservations/deleteAdditionalItem/", item).then(function (json) {
          if (json && json.data === 1) {
            self.reservation.costData.additionalItems = vue_underscore["a" /* _ */].without(self.reservation.costData.additionalItems, vue_underscore["a" /* _ */].findWhere(self.reservation.costData.additionalItems, {
              itemId: item.itemId
            }));
          }
        });
      } else {
        self.reservation.costData.additionalItems = vue_underscore["a" /* _ */].without(self.reservation.costData.additionalItems, vue_underscore["a" /* _ */].findWhere(self.reservation.costData.additionalItems, {
          id: item.id
        }));
      }
    },
    addItem: function addItem() {
      this.reservation.costData.additionalItems.push({
        quantity: 1,
        description: "Nieuw artikel",
        price: 0,
        new: true,
        vat: 21,
        id: this.reservation.costData.additionalItems.length
      });
    },
    setVAT: function setVAT(item) {
      if (parseInt(item.vatFree) !== 0) {
        item.vat = 21;
      } else {
        item.vat = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1db30f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/AdditionalItems.vue
var AdditionalItems_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-dialog',{attrs:{"max-width":"550px"},model:{value:(_vm.edit.showModal),callback:function ($$v) {_vm.$set(_vm.edit, "showModal", $$v)},expression:"edit.showModal"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v("Extra artikelen")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(_vm.editable)?_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.addItem()}}},[_vm._v("Nieuw")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-select',{attrs:{"items":_vm.availableAdditionalItems,"label":"Kies bestaande","item-text":"description","item-value":"id","return-object":"","single-line":"","menu-props":"{'bottom':true}"},model:{value:(_vm.selectAvailable),callback:function ($$v) {_vm.selectAvailable=$$v},expression:"selectAvailable"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.reservation.costData.additionalItems,"hide-actions":"","rows-per-page-items":[25,50],"no-data-text":"Geen gegevens","item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n                    "+_vm._s(header.text)+"\n                  ")],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n                      "+_vm._s(props.item.quantity)+"\n                      "),_c('v-text-field',{attrs:{"slot":"input","type":"number","min":"0","step":"1","label":"Edit","readonly":!_vm.editable,"single-line":""},slot:"input",model:{value:(props.item.quantity),callback:function ($$v) {_vm.$set(props.item, "quantity", $$v)},expression:"props.item.quantity"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n                      "+_vm._s(props.item.price)+"\n                      "),_c('v-text-field',{attrs:{"slot":"input","type":"number","min":"0","step":"0.01","label":"Edit","readonly":!_vm.editable,"single-line":""},slot:"input",model:{value:(props.item.price),callback:function ($$v) {_vm.$set(props.item, "price", $$v)},expression:"props.item.price"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n                      "+_vm._s(props.item.vat)+"\n                      "),_c('v-checkbox',{attrs:{"slot":"input","label":"BTW vrij","value":"0","readonly":!_vm.editable},on:{"change":function($event){return _vm.setVAT(props.item)}},slot:"input",model:{value:(props.item.vatFree),callback:function ($$v) {_vm.$set(props.item, "vatFree", $$v)},expression:"props.item.vatFree"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n                      "+_vm._s(props.item.description)+"\n                      "),_c('v-text-field',{attrs:{"slot":"input","type":"text","label":"Edit","single-line":""},slot:"input",model:{value:(props.item.description),callback:function ($$v) {_vm.$set(props.item, "description", $$v)},expression:"props.item.description"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[(_vm.editable)?_c('v-btn',{attrs:{"flat":"","icon":"","color":"pink"},on:{"click":function($event){return _vm.deleteAdditionalItem(props.item)}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()],1)])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs9":"","md8":""}},[_c('v-btn',{attrs:{"color":"gray darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.reservation.costData.additionalItems = _vm.initAdditionalItems; _vm.edit.showModal = false;}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md4":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.edit.showModal = false;}}},[_vm._v("Opslaan")])],1)],1)],1)],1)],1)}
var AdditionalItems_staticRenderFns = []
var AdditionalItems_esExports = { render: AdditionalItems_render, staticRenderFns: AdditionalItems_staticRenderFns }
/* harmony default export */ var Reservations_AdditionalItems = (AdditionalItems_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/AdditionalItems.vue
var AdditionalItems_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AdditionalItems___vue_template_functional__ = false
/* styles */
var AdditionalItems___vue_styles__ = null
/* scopeId */
var AdditionalItems___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdditionalItems___vue_module_identifier__ = null
var AdditionalItems_Component = AdditionalItems_normalizeComponent(
  AdditionalItems,
  Reservations_AdditionalItems,
  AdditionalItems___vue_template_functional__,
  AdditionalItems___vue_styles__,
  AdditionalItems___vue_scopeId__,
  AdditionalItems___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_AdditionalItems = (AdditionalItems_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/ReservationCostDetails.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ReservationCostDetails = ({
	name: 'ReservationCostDetails',
	props: ['reservation', 'editable'],
	data: function data() {
		return {
			edit: {
				showModal: false
			},
			editAdditionalItems: {
				showModal: false
			}
		};
	},

	components: { ReservationPrices: components_Reservations_ReservationPrices, AdditionalItems: components_Reservations_AdditionalItems },
	computed: {
		mileageCost: function mileageCost() {
			var total = parseFloat(this.reservation.kmPrice) * (parseFloat(this.reservation.costData.mileage) - parseFloat(this.reservation.freeMileage));
			return total >= 0 ? total : 0;
		},
		total: function total() {
			return (parseFloat(this.reservation.totalWithoutMileageCost) + parseFloat(this.mileageCost)).toFixed(2);
		},

		setCustomDistance: {
			get: function get() {
				return this.reservation.setCustomDistance !== '0';
			},
			set: function set(value) {
				this.reservation.setCustomDistance = value;
			}
		},
		totalCustomer: function totalCustomer() {
			var totalPrice = this.total - parseFloat(this.reservation.discount);
			return totalPrice >= 0 ? totalPrice.toFixed(2) : 0;
		},
		additionalItems: function additionalItems() {
			var additionalItems = this.reservation.costData.additionalItems;
			var itemList = '';
			if (additionalItems && additionalItems.length) {
				for (var i = 0; i < additionalItems.length; i++) {
					itemList += ' ' + additionalItems[i]['description'] + (additionalItems.length > 1 ? ', ' : '');
				}

				return additionalItems.length + ' (' + itemList + ')';
			} else {
				return '0';
			}
		}
	},
	methods: {
		showPrices: function showPrices() {
			this.edit.showModal = true;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38acd8da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/ReservationCostDetails.vue
var ReservationCostDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","px-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Minuten","type":"number","readonly":""},model:{value:(_vm.reservation.costData.minutes),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "minutes", $$v)},expression:"reservation.costData.minutes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Uren","type":"number","readonly":""},model:{value:(_vm.reservation.costData.hours),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "hours", $$v)},expression:"reservation.costData.hours"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Dagen","type":"number","readonly":""},model:{value:(_vm.reservation.costData.days),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "days", $$v)},expression:"reservation.costData.days"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Weken","type":"number","readonly":""},model:{value:(_vm.reservation.costData.weeks),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "weeks", $$v)},expression:"reservation.costData.weeks"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Maanden","type":"number","readonly":""},model:{value:(_vm.reservation.costData.months),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "months", $$v)},expression:"reservation.costData.months"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Afgelegde afstand","type":"number"},on:{"focus":function($event){_vm.reservation.setCustomDistance = true}},model:{value:(_vm.reservation.costData.mileage),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "mileage", $$v)},expression:"reservation.costData.mileage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"readonly":_vm.reservation.wialonUnitId === '0',"label":"Handmatig"},model:{value:(_vm.setCustomDistance),callback:function ($$v) {_vm.setCustomDistance=$$v},expression:"setCustomDistance"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Korting","type":"number","min":"0","step":"0.01"},model:{value:(_vm.reservation.discount),callback:function ($$v) {_vm.$set(_vm.reservation, "discount", $$v)},expression:"reservation.discount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Km vrij","type":"number","readonly":""},model:{value:(_vm.reservation.costData.totalKmFree),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "totalKmFree", $$v)},expression:"reservation.costData.totalKmFree"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","md2":"","px-0":""}},[_c('v-text-field',{attrs:{"label":"Extra artikelen","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.editAdditionalItems.showModal = true}},model:{value:(_vm.additionalItems),callback:function ($$v) {_vm.additionalItems=$$v},expression:"additionalItems"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":"","xs3":"","px-0":""}},[(_vm.editable)?_c('v-btn',{attrs:{"flat":"","icon":"","color":"pink"},nativeOn:{"click":function($event){_vm.editAdditionalItems.showModal = true}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(!_vm.editable)?_c('v-btn',{attrs:{"flat":"","icon":"","color":"pink"},nativeOn:{"click":function($event){_vm.editAdditionalItems.showModal = true}}},[_c('v-icon',[_vm._v("pageview")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Km prijs","type":"number","min":"0","step":"0.01"},model:{value:(_vm.reservation.kmPrice),callback:function ($$v) {_vm.$set(_vm.reservation, "kmPrice", $$v)},expression:"reservation.kmPrice"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"none"},attrs:{"xs6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"BTW tarief","type":"number","min":"0","step":"0.01"},model:{value:(_vm.reservation.vat),callback:function ($$v) {_vm.$set(_vm.reservation, "vat", $$v)},expression:"reservation.vat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Totaalbedrag","type":"text","readonly":""},model:{value:(_vm.reservation.costData.total),callback:function ($$v) {_vm.$set(_vm.reservation.costData, "total", $$v)},expression:"reservation.costData.total"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Betaald","type":"text","readonly":""},model:{value:(_vm.reservation.amountPaid),callback:function ($$v) {_vm.$set(_vm.reservation, "amountPaid", $$v)},expression:"reservation.amountPaid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.showPrices()}}},[_vm._v("Toon tarieven")])],1),_vm._v(" "),(_vm.reservation.costData.dayPriceReached)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"black--text",attrs:{"type":"info","value":"true","color":"grey lighten-3"}},[_vm._v("\n\t\t\t\tLet op: dagtarief wordt gebruikt voor het aantal uren ("+_vm._s(_vm.reservation.costData.hours)+").\n\t\t\t")])],1):_vm._e()],1),_vm._v(" "),_c('reservation-prices',{attrs:{"reservation":_vm.reservation,"edit":_vm.edit}}),_vm._v(" "),_c('additional-items',{attrs:{"reservation":_vm.reservation,"edit":_vm.editAdditionalItems,"editable":_vm.editable}})],1)}
var ReservationCostDetails_staticRenderFns = []
var ReservationCostDetails_esExports = { render: ReservationCostDetails_render, staticRenderFns: ReservationCostDetails_staticRenderFns }
/* harmony default export */ var Reservations_ReservationCostDetails = (ReservationCostDetails_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/ReservationCostDetails.vue
var ReservationCostDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReservationCostDetails___vue_template_functional__ = false
/* styles */
var ReservationCostDetails___vue_styles__ = null
/* scopeId */
var ReservationCostDetails___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReservationCostDetails___vue_module_identifier__ = null
var ReservationCostDetails_Component = ReservationCostDetails_normalizeComponent(
  ReservationCostDetails,
  Reservations_ReservationCostDetails,
  ReservationCostDetails___vue_template_functional__,
  ReservationCostDetails___vue_styles__,
  ReservationCostDetails___vue_scopeId__,
  ReservationCostDetails___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_ReservationCostDetails = (ReservationCostDetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/subcomponents/CustomerCard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CustomerCard = ({
	name: 'CustomerCard',
	components: {},
	created: function created() {},
	data: function data() {
		return {};
	},

	computed: {
		formattedBirthdate: function formattedBirthdate() {
			return moment_default()(this.user.birthdate).format('DD-MM-YYYY');
		}
	},
	props: ['user']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9bd2f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponents/CustomerCard.vue
var CustomerCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","px-1":"","pb-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',[_vm._v("Klantgegevens")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Klantnummer","readonly":""},model:{value:(_vm.user.user_id),callback:function ($$v) {_vm.$set(_vm.user, "user_id", $$v)},expression:"user.user_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Voornaam","readonly":""},model:{value:(_vm.user.firstname),callback:function ($$v) {_vm.$set(_vm.user, "firstname", $$v)},expression:"user.firstname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Achternaam","readonly":""},model:{value:(_vm.user.lastname),callback:function ($$v) {_vm.$set(_vm.user, "lastname", $$v)},expression:"user.lastname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Bedrijfsnaam","readonly":""},model:{value:(_vm.user.companyname),callback:function ($$v) {_vm.$set(_vm.user, "companyname", $$v)},expression:"user.companyname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Email","readonly":""},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Rijbewijsnummer","type":"text","readonly":""},model:{value:(_vm.user.licenseid),callback:function ($$v) {_vm.$set(_vm.user, "licenseid", $$v)},expression:"user.licenseid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Geboortedatum","type":"text","readonly":""},model:{value:(_vm.formattedBirthdate),callback:function ($$v) {_vm.formattedBirthdate=$$v},expression:"formattedBirthdate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Woonplaats","type":"text","readonly":""},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Postcode","type":"text","readonly":""},model:{value:(_vm.user.zip),callback:function ($$v) {_vm.$set(_vm.user, "zip", $$v)},expression:"user.zip"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Adres","type":"text","readonly":""},model:{value:(_vm.user.street),callback:function ($$v) {_vm.$set(_vm.user, "street", $$v)},expression:"user.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Huisnr","type":"text","readonly":""},model:{value:(_vm.user.streetno),callback:function ($$v) {_vm.$set(_vm.user, "streetno", $$v)},expression:"user.streetno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","readonly":""},model:{value:(_vm.user.phoneno),callback:function ($$v) {_vm.$set(_vm.user, "phoneno", $$v)},expression:"user.phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('a',{attrs:{"href":'#/users/' + _vm.user.user_id}},[_vm._v("Meer informatie")])])],1)],1)}
var CustomerCard_staticRenderFns = []
var CustomerCard_esExports = { render: CustomerCard_render, staticRenderFns: CustomerCard_staticRenderFns }
/* harmony default export */ var subcomponents_CustomerCard = (CustomerCard_esExports);
// CONCATENATED MODULE: ./src/components/subcomponents/CustomerCard.vue
var CustomerCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CustomerCard___vue_template_functional__ = false
/* styles */
var CustomerCard___vue_styles__ = null
/* scopeId */
var CustomerCard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CustomerCard___vue_module_identifier__ = null
var CustomerCard_Component = CustomerCard_normalizeComponent(
  CustomerCard,
  subcomponents_CustomerCard,
  CustomerCard___vue_template_functional__,
  CustomerCard___vue_styles__,
  CustomerCard___vue_scopeId__,
  CustomerCard___vue_module_identifier__
)

/* harmony default export */ var components_subcomponents_CustomerCard = (CustomerCard_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-pdf/src/componentFactory.js
var componentFactory = __webpack_require__("iwQb");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pdf/src/vuePdfNoSss.vue
//




if (Object({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__("ytml").default;
	var PDFJS = __webpack_require__("QzLT");

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__("yQBj");
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = Object(componentFactory["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = Object(componentFactory["a" /* default */])({});
}

/* harmony default export */ var vuePdfNoSss = (component);
// CONCATENATED MODULE: ./node_modules/vue-pdf/src/vuePdfNoSss.vue
function vuePdfNoSss_injectStyle (ssrContext) {
  __webpack_require__("xxT8")
}
var vuePdfNoSss_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var vuePdfNoSss___vue_template_functional__ = false
/* styles */
var vuePdfNoSss___vue_styles__ = vuePdfNoSss_injectStyle
/* scopeId */
var vuePdfNoSss___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vuePdfNoSss___vue_module_identifier__ = null
var vuePdfNoSss_Component = vuePdfNoSss_normalizeComponent(
  vuePdfNoSss,
  __vue_template__,
  vuePdfNoSss___vue_template_functional__,
  vuePdfNoSss___vue_styles__,
  vuePdfNoSss___vue_scopeId__,
  vuePdfNoSss___vue_module_identifier__
)

/* harmony default export */ var src_vuePdfNoSss = (vuePdfNoSss_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/subcomponents/InvoiceViewer.vue
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var InvoiceViewer = ({
	name: 'InvoiceViewer',
	components: { pdf: src_vuePdfNoSss },
	created: function created() {},
	data: function data() {
		return {
			src: '',
			loading: false
		};
	},

	methods: {
		showPdf: function showPdf(reservationId, invoiceDate, isActive) {
			var self = this;
			this.loading = true;
			setData(basePath + 'api/reservations/' + (isActive ? 'getPreInvoice/' : 'getInvoice/') + reservationId, { invoiceDate: invoiceDate }).then(function (json) {
				self.loading = false;
				self.src = basePath + 'api/downloader/downloadInvoice/' + json.data + '/' + reservationId;
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82eaadb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponents/InvoiceViewer.vue
var InvoiceViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","px-1":"","pb-0":""}},[(!_vm.loading)?_c('pdf',{attrs:{"src":_vm.src}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"black"}}):_vm._e()],1)}
var InvoiceViewer_staticRenderFns = []
var InvoiceViewer_esExports = { render: InvoiceViewer_render, staticRenderFns: InvoiceViewer_staticRenderFns }
/* harmony default export */ var subcomponents_InvoiceViewer = (InvoiceViewer_esExports);
// CONCATENATED MODULE: ./src/components/subcomponents/InvoiceViewer.vue
var InvoiceViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InvoiceViewer___vue_template_functional__ = false
/* styles */
var InvoiceViewer___vue_styles__ = null
/* scopeId */
var InvoiceViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InvoiceViewer___vue_module_identifier__ = null
var InvoiceViewer_Component = InvoiceViewer_normalizeComponent(
  InvoiceViewer,
  subcomponents_InvoiceViewer,
  InvoiceViewer___vue_template_functional__,
  InvoiceViewer___vue_styles__,
  InvoiceViewer___vue_scopeId__,
  InvoiceViewer___vue_module_identifier__
)

/* harmony default export */ var components_subcomponents_InvoiceViewer = (InvoiceViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/ViewInvoice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ViewInvoice = ({
	name: 'ViewInvoice',
	components: {
		InvoiceViewer: components_subcomponents_InvoiceViewer
	},
	data: function data() {
		return {
			dialog: false,
			email: '',
			reservationId: 0,
			reservationNumber: 0,
			invoiceDate: '',
			isActive: true,
			menu: false,
			type: '',
			utils: utils_namespaceObject
		};
	},

	props: ['customDate'],
	computed: {
		invoiceDateFormatted: function invoiceDateFormatted() {
			return moment_default()(this.invoiceDate).format('DD-MM-YYYY');
		}
	},
	mounted: function mounted() {
		this.invoiceDate = moment_default()().format('YYYY-MM-DD');
	},

	watch: {
		dialog: function dialog(value) {
			if (value) {
				this.$refs.invoiceViewer.showPdf(this.reservationId, this.customDate ? this.invoiceDateFormatted : '', this.isActive);
			}
		}
	},
	methods: {
		showDialog: function showDialog(reservation, type, isActiveReservation) {
			this.type = type;
			this.isActive = isActiveReservation;
			this.reservationId = reservation.id;
			this.reservationNumber = reservation.reservationNumber;
			this.email = reservation.username;
			this.dialog = true;
		},
		sendPreInvoice: function sendPreInvoice() {
			var self = this;
			this.priceLoading = true;
			setData(basePath + 'api/reservations/sendPreInvoice/' + this.reservationId, { email: this.email, invoiceDate: this.invoiceDateFormatted }).then(function (json) {
				if (json && json.data) {
					window.emitter.$emit('showToastMessage', {
						msg: 'Factuur verzonden.'
					});
				}
				self.dialog = false;
			});
		},
		viewPreInvoice: function viewPreInvoice() {
			var self = this;
			setData(basePath + 'api/reservations/' + (this.isActive ? 'getPreInvoice/' : 'getInvoice/') + self.reservationId, { invoiceDate: this.customDate ? this.invoiceDateFormatted : '' }).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadInvoice/' + json.data + '/' + self.reservationNumber + '/' + (self.isActive ? 'Proforma' : 'Factuur');
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee0b0e28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/ViewInvoice.vue
var ViewInvoice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Factuur "+_vm._s(_vm.type === 'view' ? 'bekijken' : 'versturen'))]),_vm._v(" "),_c('v-card-text',[(_vm.isActive)?_c('v-flex',{attrs:{"xs8":"","sm5":""}},[_c('v-dialog',{ref:"menu",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","width":"290px","return-value":_vm.invoiceDate},on:{"update:returnValue":function($event){_vm.invoiceDate=$event},"update:return-value":function($event){_vm.invoiceDate=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('div',{staticClass:"blue darken-2 dark pl-3 pt-2"},[_c('h3',[_vm._v("Factuur datum")])]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Factuurdatum","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.invoiceDateFormatted),callback:function ($$v) {_vm.invoiceDateFormatted=$$v},expression:"invoiceDateFormatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"nl","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.invoiceDate);
							_vm.$refs.invoiceViewer.showPdf(
								_vm.reservationId,
								_vm.customDate ? _vm.invoiceDateFormatted : '',
								_vm.isActive
							);}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Annuleren")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 'send')?_c('v-text-field',{attrs:{"label":"E-mailadres","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}):_vm._e(),_vm._v(" "),_c('invoice-viewer',{ref:"invoiceViewer",attrs:{"reservationId":_vm.reservationId}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Sluiten")]),_vm._v(" "),(_vm.type === 'view')?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.viewPreInvoice()}}},[_vm._v("Downloaden")]):_vm._e(),_vm._v(" "),(_vm.type === 'send')?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.sendPreInvoice()}}},[_vm._v("Verzenden")]):_vm._e()],1)],1)],1)}
var ViewInvoice_staticRenderFns = []
var ViewInvoice_esExports = { render: ViewInvoice_render, staticRenderFns: ViewInvoice_staticRenderFns }
/* harmony default export */ var Reservations_ViewInvoice = (ViewInvoice_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/ViewInvoice.vue
function ViewInvoice_injectStyle (ssrContext) {
  __webpack_require__("K48z")
}
var ViewInvoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ViewInvoice___vue_template_functional__ = false
/* styles */
var ViewInvoice___vue_styles__ = ViewInvoice_injectStyle
/* scopeId */
var ViewInvoice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ViewInvoice___vue_module_identifier__ = null
var ViewInvoice_Component = ViewInvoice_normalizeComponent(
  ViewInvoice,
  Reservations_ViewInvoice,
  ViewInvoice___vue_template_functional__,
  ViewInvoice___vue_styles__,
  ViewInvoice___vue_scopeId__,
  ViewInvoice___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_ViewInvoice = (ViewInvoice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/History/HistoryModal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var HistoryModal = ({
	name: 'HistoryModal',
	components: {
		ReservationCostDetails: components_Reservations_ReservationCostDetails,
		CustomerCard: components_subcomponents_CustomerCard,
		TempCustomer: components_subcomponents_TempCustomer,
		ViewInvoice: components_Reservations_ViewInvoice
	},
	mounted: function mounted() {
		var self = this;
		window.emitter.$on('showHistory', function (data) {
			self.getHistoryData(data.id, data.showMail);
		});
	},
	created: function created() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
	},
	data: function data() {
		var _this = this,
		    _ref;

		return _ref = {
			tabs: ['Gegevens', 'Klantgegevens', 'Kostenoverzicht', 'Facturatie', 'Opties'],
			active: 'Gegevens',
			paidOptions: getPaidOptions(),
			menu: false,
			menu2: false,
			dialog: false,
			loading: false,
			editUser: false,
			confirm: {
				delete: false
			},
			costData: {
				hours: 1,
				days: 1,
				weeks: 1
			},
			selectedReservation: {
				costData: {
					additionalItems: []
				},
				tempCustomer: {}
			},
			search: null,
			searchUsers: []
		}, defineProperty_default()(_ref, 'editUser', false), defineProperty_default()(_ref, 'select', []), defineProperty_default()(_ref, 'items', []), defineProperty_default()(_ref, 'mailText', ''), defineProperty_default()(_ref, 'sendingMail', false), defineProperty_default()(_ref, 'sendInvoice', true), defineProperty_default()(_ref, 'subject', 'Openstaande factuur'), defineProperty_default()(_ref, 'sentReminders', []), defineProperty_default()(_ref, 'utils', utils_namespaceObject), defineProperty_default()(_ref, 'showModal', false), defineProperty_default()(_ref, 'fullscreen', false), defineProperty_default()(_ref, 'emailaddress', ''), defineProperty_default()(_ref, 'mailTemplates', []), defineProperty_default()(_ref, 'selectedTemplate', ''), defineProperty_default()(_ref, 'emailRules', [function (v) {
			return !!v || 'Gebruikersnaam is verplicht';
		}, function (v) {
			return _this.utils.checkEmailAddress(v) || 'Ongeldig email-adres';
		}]), defineProperty_default()(_ref, 'dateChanged', false), _ref;
	},

	props: ['user', 'edit', 'id', 'units'],
	computed: {
		amountOpen: function amountOpen() {
			return (this.selectedReservation.totalCosts - this.selectedReservation.amountPaid).toFixed(2);
		},
		selectUnits: function selectUnits() {
			return [];
		},
		fullStartDate: function fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate: function fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		},

		mailDefaultText: {
			get: function get() {
				return 'Geachte [firstname] [lastname],\n          <br/><br/>\n          Uit onze administratie is gebleken dat u nog een factuur heeft openstaan. Wellicht is het aan uw aandacht ontschoten. Wij verzoeken u vriendelijk om deze aan ons te voldoen. <br/>\n          Als u deze net heeft betaald dan kunt u dit bericht als niet verzonden beschouwen.</br>\n          Bedankt voor uw medewerking!\n          <br/><br/>\n          [Dit bericht is een automatisch verzonden bericht]';
			}
		}
	},
	watch: {
		search: function search(val) {
			val && this.querySelections(val);
		},
		select: function select(newVal) {
			var selectedUser = vue_underscore["a" /* _ */].findWhere(this.items, { user_id: newVal });
			this.selectedReservation.user_id = selectedUser.user_id;
			this.selectedReservation.username = selectedUser.username;
			this.selectedReservation.phoneno = selectedUser.phoneno;
			this.selectedReservation.city = selectedUser.city;
		},
		active: function active(newVal) {
			if (newVal === 'Facturatie' && this.selectedReservation.user_id && !self.sentReminders) {
				this.getSentReminders();
				this.getMailTemplates();
			}
		},
		selectedTemplate: function selectedTemplate(templateId) {
			var selectedTemplate = vue_underscore["a" /* _ */].findWhere(this.mailTemplates, {
				id: templateId
			});
			if (templateId) {
				var mailText = selectedTemplate.text;
				this.mailText = mailText;
			} else {
				this.mailText = this.mailDefaultText;
			}
		}
	},
	methods: {
		getHistoryData: function getHistoryData(id, showMail) {
			var self = this;
			this.showModal = true;
			this.dateChanged = false;
			utils_getData(basePath + 'api/reservations/historyDetails/' + id).then(function (json) {
				self.selectedReservation = json.data;
				self.emailaddress = self.selectedReservation.username;
				self.selectedReservation.costData = {};
				self.selectedReservation.startTime = moment_default()(self.selectedReservation.startDate).format('HH:mm');
				self.selectedReservation.startDate = moment_default()(self.selectedReservation.startDate).format('YYYY-MM-DD');
				self.selectedReservation.endTime = moment_default()(self.selectedReservation.endDate).format('HH:mm');
				self.selectedReservation.endDate = moment_default()(self.selectedReservation.endDate).format('YYYY-MM-DD');
				self.selectedReservation.costData = JSON.parse(self.selectedReservation.totalCostsData);
				self.selectedReservation.totalWithoutDiscount = self.selectedReservation.costData.totalDecimal + parseFloat(self.selectedReservation.discount);
				self.selectedReservation.totalWithoutMileageCost = self.selectedReservation.totalWithoutDiscount - parseFloat(self.selectedReservation.costData.mileageCost);
				self.mailText = self.mailDefaultText;
				self.selectedReservation.id = self.selectedReservation.rentId;
				if (!self.selectedReservation.tempCustomer) {
					self.selectedReservation.tempCustomer = {};
				}
				if (showMail) {
					self.getSentReminders();
					self.active = 'Facturatie';
				}
			});
		},
		closeModal: function closeModal() {
			this.showModal = false;
		},
		querySelections: function querySelections(v) {
			var self = this;
			this.userLoading = true;
			var data = {
				query: v
			};
			setData(basePath + 'api/users/searchUsers/', data).then(function (response) {
				if (response && response.data) {
					self.items = response.data;
					self.searchUsersData = response.data;
				}
				self.userLoading = false;
			});
		},
		updateReservation: function updateReservation() {
			var _data;

			var self = this;

			var data = (_data = {
				startDate: moment_default()(self.selectedReservation.startDate + ':' + self.selectedReservation.startTime, 'YYYY-MM-DD HH:mm').format(),
				endDate: moment_default()(self.selectedReservation.endDate + ':' + self.selectedReservation.endTime, 'YYYY-MM-DD HH:mm').format(),
				paid: self.selectedReservation.paid,
				discount: self.selectedReservation.discount,
				id: self.selectedReservation.rentId,
				rentId: self.selectedReservation.rentId,
				kmPrice: self.selectedReservation.kmPrice,
				mileage: self.selectedReservation.mileage,
				unitId: self.selectedReservation.unitId,
				prices: self.selectedReservation.costData.prices,
				user_id: self.selectedReservation.user_id,
				freeMileage: self.selectedReservation.freeMileage
			}, defineProperty_default()(_data, 'mileage', self.selectedReservation.costData.mileage), defineProperty_default()(_data, 'remark', self.selectedReservation.remark), defineProperty_default()(_data, 'dateChanged', self.dateChanged), defineProperty_default()(_data, 'additionalItems', self.selectedReservation.costData.additionalItems), defineProperty_default()(_data, 'useTempForInvoice', self.selectedReservation.useTempForInvoice), defineProperty_default()(_data, 'setCustomDistance', self.selectedReservation.setCustomDistance), defineProperty_default()(_data, 'amountPaid', self.selectedReservation.amountPaid), defineProperty_default()(_data, 'tempCustomer', self.selectedReservation.tempCustomer), defineProperty_default()(_data, 'tempCustomerId', self.selectedReservation.tempCustomerId), defineProperty_default()(_data, 'useTempCustomer', self.selectedReservation.tempCustomer.useTempCustomer ? self.selectedReservation.tempCustomer.useTempCustomer : false), _data);

			setData(basePath + 'api/reservations/updateHistoryDetails/', data).then(function (json) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Beëindigde reserving opgeslagen'
				});
				self.getHistoryData(self.selectedReservation.rentId, false);
				self.updateModel();
			});
		},
		searchUser: function searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		showInvoice: function showInvoice() {
			var self = this;
			utils_getData(basePath + 'api/reservations/getInvoice/' + this.selectedReservation.rentId).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadInvoice/' + json.data + '/' + self.selectedReservation.rentId;
			});
		},
		updateModel: function updateModel() {
			window.emitter.$emit('updateHistory');
			this.$emit('update');
		},
		deleteReservation: function deleteReservation() {
			var self = this;
			utils_getData(basePath + 'api/reservations/deleteHistory/' + this.selectedReservation.rentId).then(function (json) {
				self.updateModel();
			});
			this.showModal = false;
			this.confirm.delete = false;
		},
		formatMailText: function formatMailText() {
			var mailText = this.mailText;
			mailText = mailText.replace('[firstname]', this.selectedReservation.firstname);
			mailText = mailText.replace('[lastname]', this.selectedReservation.lastname);
			mailText = mailText.replace('[linka2u]', '<a href="https://www.auto2use.nl/account/pay/' + this.selectedReservation.rentId + '">Klik op deze link om te kunnen betalen (iDeal)</a>');
			return mailText;
		},
		sendReminder: function sendReminder() {
			var self = this;

			if (this.$refs.reminderForm.validate()) {
				var data = {
					body: this.formatMailText(),
					subject: this.subject,
					emailaddress: this.emailaddress,
					historyId: this.selectedReservation.rentId,
					sendInvoice: this.sendInvoice
				};

				this.sendingMail = true;
				setData(basePath + 'api/reservations/sendReminder', data).then(function (json) {
					self.sendingMail = false;
					self.getSentReminders();
					window.emitter.$emit('showToastMessage', {
						msg: 'E-mail verzonden'
					});
				});
			}
		},
		getSentReminders: function getSentReminders() {
			var self = this;
			utils_getData(basePath + 'api/reservations/getSentReminders/' + this.selectedReservation.rentId).then(function (json) {
				self.sentReminders = json.data;
			});
		},
		setReservationChanged: function setReservationChanged() {
			this.dateChanged = true;
		},
		showAgreement: function showAgreement() {
			var self = this;
			utils_getData(basePath + 'api/users/getAgreement/' + this.selectedReservation.user_id + '/' + this.selectedReservation.rentId).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadAgreement/' + json.data + '/' + self.selectedReservation.rentId;
			});
		},
		copyReservation: function copyReservation() {
			this.$emit('copyReservation', this.selectedReservation);
			this.showModal = false;
		},
		getMailTemplates: function getMailTemplates() {
			var self = this;
			utils_getData(basePath + 'api/dealers/getMailTemplates/history').then(function (response) {
				if (response && response.data) {
					self.mailTemplates = response.data;
				} else {
					self.mailTemplates = [];
				}
				self.mailTemplates.unshift({
					subject: '',
					text: ''
				});
			});
		},
		saveTemplate: function saveTemplate() {
			var templateData = {
				subject: this.subject,
				text: this.mailText,
				type: 'history'
			};

			var self = this;
			setData(basePath + 'api/dealers/createMailTemplate/', templateData).then(function (response) {});
		},
		deleteTemplate: function deleteTemplate() {
			var _this2 = this;

			var self = this;
			utils_getData(basePath + 'api/dealers/deleteMailTemplate/' + this.selectedTemplate).then(function (response) {
				_this2.selectedTemplate = '';
				_this2.getMailTemplates();
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d80b1f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/History/HistoryModal.vue
var HistoryModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":_vm.fullscreen,"lazy":"","max-width":"800px","transition":_vm.utils.getSettings('animation')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.showModal = false}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',[_c('v-tabs',{attrs:{"color":"blue darken-3","dark":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v(_vm._s(tab))])}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{key:'Gegevens',attrs:{"value":'Gegevens'}},[_c('v-card',[_c('v-card-title',{staticClass:"pb-0"},[_c('h2',[_vm._v("\n\t\t\t\t\t\t\t\t\tBeeindigde reservering #"+_vm._s(_vm.selectedReservation.reservationNumber)+"\n\t\t\t\t\t\t\t\t\t("+_vm._s(_vm.selectedReservation.name)+")\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","px-0":"","pt-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":"","xs12":""}},[_c('v-select',{attrs:{"items":_vm.units,"label":"Selecteer auto","item-text":"fullDescription","item-value":"unitId","single-line":"","menu-props":"bottom"},model:{value:(_vm.selectedReservation.unitId),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "unitId", $$v)},expression:"selectedReservation.unitId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","sm5":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"330px","min-width":"330px","return-value":_vm.selectedReservation.startDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Startdatum","prepend-icon":"event","readonly":""},on:{"change":function($event){return _vm.setReservationChanged()}},slot:"activator",model:{value:(_vm.fullStartDate),callback:function ($$v) {_vm.fullStartDate=$$v},expression:"fullStartDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.selectedReservation.startDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startDate", $$v)},expression:"selectedReservation.startDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.menu.save(_vm.selectedReservation.startDate)}}},[_vm._v("Bevestigen")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time"},on:{"change":function($event){return _vm.setReservationChanged()}},model:{value:(_vm.selectedReservation.startTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startTime", $$v)},expression:"selectedReservation.startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","sm5":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"330px","min-width":"330px","return-value":_vm.selectedReservation.endDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Einddatum","prepend-icon":"event","readonly":""},on:{"change":function($event){return _vm.setReservationChanged()}},slot:"activator",model:{value:(_vm.fullEndDate),callback:function ($$v) {_vm.fullEndDate=$$v},expression:"fullEndDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.selectedReservation.endDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endDate", $$v)},expression:"selectedReservation.endDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.menu2.save(_vm.selectedReservation.endDate)}}},[_vm._v("Bevestigen")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time"},on:{"change":function($event){return _vm.setReservationChanged()}},model:{value:(_vm.selectedReservation.endTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endTime", $$v)},expression:"selectedReservation.endTime"}})],1),_vm._v(" "),(!_vm.selectedReservation.setCustomDistance)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.dateChanged)?_c('v-checkbox',{attrs:{"label":"Afstand opnieuw berekenen?"},model:{value:(_vm.selectedReservation.dateChanged),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "dateChanged", $$v)},expression:"selectedReservation.dateChanged"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"label":"Gebruiker","readonly":""},model:{value:(_vm.selectedReservation.username),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "username", $$v)},expression:"selectedReservation.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.editUser = true}}},[_vm._v("Wijzig")])],1),_vm._v(" "),(_vm.editUser)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Zoek gebruiker","autocomplete":"false","loading":_vm.loading,"item-text":"Name","item-value":"user_id","chips":"","items":_vm.items,"search-input":_vm.search},on:{"keyup":_vm.searchUser,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","readonly":""},model:{value:(_vm.selectedReservation.phoneno),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "phoneno", $$v)},expression:"selectedReservation.phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.paidOptions,"label":"Select","single-line":"","menu-props":"bottom"},on:{"change":function($event){_vm.selectedReservation.amountPaid =
														_vm.selectedReservation.totalCosts}},model:{value:(_vm.selectedReservation.paid),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "paid", $$v)},expression:"selectedReservation.paid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Totaalbedrag","type":"number","readonly":""},model:{value:(_vm.selectedReservation.totalCosts),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "totalCosts", $$v)},expression:"selectedReservation.totalCosts"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Betaald","type":"number","min":"0","step":"1"},model:{value:(_vm.selectedReservation.amountPaid),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "amountPaid", $$v)},expression:"selectedReservation.amountPaid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Openstaand","type":"number","readonly":""},model:{value:(_vm.amountOpen),callback:function ($$v) {_vm.amountOpen=$$v},expression:"amountOpen"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v(_vm._s(_vm.selectedReservation.remark))])],1)],1),_vm._v(" "),_c('small',[_vm._v("* verplichte velden")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Klantgegevens',attrs:{"value":'Klantgegevens'}},[_c('v-container',{attrs:{"grid-list-md":"","pa-2":""}},[_c('customer-card',{attrs:{"user":_vm.selectedReservation}}),_vm._v(" "),_c('temp-customer',{attrs:{"optional":true,"user":_vm.selectedReservation.tempCustomer,"useTempForInvoice":_vm.selectedReservation.useTempForInvoice,"showInvoiceOption":true},on:{"setUseTempForInvoice":function($event){_vm.selectedReservation.useTempForInvoice = $event}}})],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Kostenoverzicht',attrs:{"value":'Kostenoverzicht'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Kostenoverzicht")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('reservation-cost-details',{attrs:{"reservation":_vm.selectedReservation,"editable":true}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.$refs.viewInvoice.showDialog(
														_vm.selectedReservation,
														'view',
														false
													)}}},[_c('v-icon',[_vm._v("picture_as_pdf")]),_vm._v("Toon factuur\n\t\t\t\t\t\t\t\t\t\t\t")],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Facturatie',attrs:{"value":'Facturatie'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Facturatie")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-1":""}},[(_vm.sendingMail)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(!_vm.sendingMail)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-form',{ref:"reminderForm"},[(_vm.selectedReservation.paid !== '0')?_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tLet op factuur is al betaald!\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md8":""}},[_c('v-text-field',{attrs:{"label":"Onderwerp","required":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-btn',{on:{"click":function($event){return _vm.saveTemplate()}}},[_vm._v("Template opslaan")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('v-select',{attrs:{"items":_vm.mailTemplates,"label":"Opgeslagen templates","item-text":"subject","item-value":"id","required":""},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[(_vm.selectedTemplate)?_c('v-btn',{attrs:{"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.deleteTemplate()}}},[_vm._v("Template verwijderen")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-text-field',{attrs:{"label":"E-mailadres","rules":_vm.emailRules,"required":""},model:{value:(_vm.emailaddress),callback:function ($$v) {_vm.emailaddress=$$v},expression:"emailaddress"}})],1),_vm._v(" "),_c('wysiwyg',{model:{value:(_vm.mailText),callback:function ($$v) {_vm.mailText=$$v},expression:"mailText"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Factuur meesturen?"},model:{value:(_vm.sendInvoice),callback:function ($$v) {_vm.sendInvoice=$$v},expression:"sendInvoice"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){return _vm.sendReminder()}}},[_vm._v("Verzenden")]),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-expansion-panel',_vm._l((_vm.sentReminders),function(item,i){return _c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',[_vm._v("mail_outline")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.sentDateTime)+" | "+_vm._s(item.subject)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(item.content)}})],1)],1)}),1)],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Opties',attrs:{"value":'Opties'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Opties")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){_vm.confirm['delete'] = true}}},[_vm._v("Verwijderen")])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":"","ml-2":""}},[_c('v-textarea',{attrs:{"name":"remark","label":"Opmerkingen","value":""},model:{value:(_vm.selectedReservation.remark),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "remark", $$v)},expression:"selectedReservation.remark"}}),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.showAgreement()}}},[_vm._v("Download overeenkomst")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.copyReservation()}}},[_vm._v("Kopieer naar nieuwe reservering")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary darken-1"},nativeOn:{"click":function($event){return _vm.updateReservation()}}},[_vm._v("Opslaan")])],1)],1)],1)],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.confirm['delete'] || _vm.confirm['end']),callback:function ($$v) {_vm.$set(_vm.confirm['delete'] || _vm.confirm, 'end', $$v)},expression:"confirm['delete'] || confirm['end']"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Weet u het zeker?")]),_vm._v(" "),(_vm.confirm['delete'])?_c('v-card-text',[_vm._v("Klik op bevestigen om te verwijderen.")]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.confirm['delete'] = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.deleteReservation()}}},[_vm._v("Bevestigen")])],1)],1)],1),_vm._v(" "),_c('view-invoice',{ref:"viewInvoice",attrs:{"customDate":false}})],1)}
var HistoryModal_staticRenderFns = []
var HistoryModal_esExports = { render: HistoryModal_render, staticRenderFns: HistoryModal_staticRenderFns }
/* harmony default export */ var History_HistoryModal = (HistoryModal_esExports);
// CONCATENATED MODULE: ./src/components/History/HistoryModal.vue
var HistoryModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HistoryModal___vue_template_functional__ = false
/* styles */
var HistoryModal___vue_styles__ = null
/* scopeId */
var HistoryModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HistoryModal___vue_module_identifier__ = null
var HistoryModal_Component = HistoryModal_normalizeComponent(
  HistoryModal,
  History_HistoryModal,
  HistoryModal___vue_template_functional__,
  HistoryModal___vue_styles__,
  HistoryModal___vue_scopeId__,
  HistoryModal___vue_module_identifier__
)

/* harmony default export */ var components_History_HistoryModal = (HistoryModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/SelectPeriod.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SelectPeriod = ({
	name: 'selectPeriod',
	data: function data() {
		return {
			periods: [{
				value: '1 hours',
				text: '+ 1 uur'
			}, {
				value: '4 hours',
				text: '+ 1 dagdeel (4 uur)'
			}, {
				value: '1 days',
				text: '+ 1 dag'
			}, {
				value: '7 days',
				text: '+ 1 week'
			}, {
				value: '1 months',
				text: '+ 1 maand'
			}, {
				value: '1 end',
				text: 'Eind v/d dag'
			}],
			showModal: false,
			selectedPeriod: '',
			utils: utils_namespaceObject,
			endTime: '',
			endDate: ''
		};
	},

	props: ['time', 'day'],
	computed: {},
	mounted: function mounted() {},

	methods: {
		setPeriod: function setPeriod(period) {
			var data = {};
			var addData = period.split(' ');
			var formatTime = 'HH:mm';
			var format = 'YYYY-MM-DD HH:mm';
			var formatDays = 'YYYY-MM-DD';
			var startTime = moment_default()(this.time, formatTime);
			var startDate = moment_default()(this.day, format);

			switch (addData[1]) {
				case 'hours':
					var startHours = parseInt(startTime.format('HH'));
					data['endTime'] = startTime.add(parseInt(addData[0]), addData[1]).format(formatTime);

					var endHours = parseInt(moment_default()(data['endTime'], formatTime).format('HH'));

					if (endHours < startHours) {
						data['endDate'] = startDate.add(1, 'days').format(formatDays) + ' ' + startTime.format(formatTime);
					} else {
						data['endDate'] = startDate.format(formatDays) + ' ' + startTime.format(formatTime);
					}

					break;

				case 'days':
				case 'months':
					data['endTime'] = startTime.format(formatTime);
					data['endDate'] = startDate.add(parseInt(addData[0]), addData[1]).format(formatDays) + ' ' + startTime.format(formatTime);
					break;
				case 'end':
					data['endTime'] = '23:59';
					data['endDate'] = startDate.format(formatDays) + ' ' + data['endTime'];
					break;
			}

			this.$emit('setPeriod', data);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ee111e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/SelectPeriod.vue
var SelectPeriod_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-menu',{attrs:{"left":""}},[_c('v-btn',{staticClass:"mt-3",attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("av_timer")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.periods),function(period){return _c('v-list-tile',{key:period.value},[_c('v-list-tile-title',{on:{"click":function($event){return _vm.setPeriod(period.value)}}},[_vm._v(_vm._s(period.text))])],1)}),1)],1)],1)}
var SelectPeriod_staticRenderFns = []
var SelectPeriod_esExports = { render: SelectPeriod_render, staticRenderFns: SelectPeriod_staticRenderFns }
/* harmony default export */ var Reservations_SelectPeriod = (SelectPeriod_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/SelectPeriod.vue
function SelectPeriod_injectStyle (ssrContext) {
  __webpack_require__("IQUy")
}
var SelectPeriod_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SelectPeriod___vue_template_functional__ = false
/* styles */
var SelectPeriod___vue_styles__ = SelectPeriod_injectStyle
/* scopeId */
var SelectPeriod___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SelectPeriod___vue_module_identifier__ = null
var SelectPeriod_Component = SelectPeriod_normalizeComponent(
  SelectPeriod,
  Reservations_SelectPeriod,
  SelectPeriod___vue_template_functional__,
  SelectPeriod___vue_styles__,
  SelectPeriod___vue_scopeId__,
  SelectPeriod___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_SelectPeriod = (SelectPeriod_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/NewReservationModal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var NewReservationModal = ({
	name: 'selectedReservationModal',
	components: {
		ReservationCostDetails: components_Reservations_ReservationCostDetails,
		ReservationPrices: components_Reservations_ReservationPrices,
		CustomerCard: components_subcomponents_CustomerCard,
		TempCustomer: components_subcomponents_TempCustomer,
		SelectPeriod: components_Reservations_SelectPeriod
	},
	created: function created() {
		var self = this;
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}

		window.emitter.$on('userCreated', function (data) {
			if (data.type === 'new') {
				self.tempCustomerId = '';
				self.selectedUser = data.user && data.user.length ? data.user[0] : {};
				self.selectedReservation.user_id = self.selectedUser.user_id;
				self.items[0] = self.selectedUser;
				self.select = self.selectedReservation.user_id;
				self.newUserCreated = true;
			} else {
				self.tempCustomerId = data.user;
				self.tempCustomer = data.tempCustomer;
			}
		});
	},
	data: function data() {
		var _ref;

		return _ref = {
			tabs: ['Gegevens', 'Kostenoverzicht', 'Aanvullend', 'Klantgegevens'],
			active: '',
			menu: false,
			menu2: false,
			dialog: false,
			loading: false,
			valid: false,
			saveDisabled: false,
			priceLoading: false,
			editPrices: {
				showModal: false
			},
			unitDate: {},
			unitId: 0,
			selectedReservation: {
				costData: {
					additionalItems: []
				},
				additionalItems: []
			},
			startDateSet: false,
			search: null,
			searchUsers: [],
			editUser: false
		}, defineProperty_default()(_ref, 'unitId', ''), defineProperty_default()(_ref, 'select', ''), defineProperty_default()(_ref, 'items', []), defineProperty_default()(_ref, 'basicRules', [function (v) {
			return !!v || 'Verplicht veld';
		}]), defineProperty_default()(_ref, 'utils', utils_namespaceObject), defineProperty_default()(_ref, 'fullscreen', false), defineProperty_default()(_ref, 'tempCustomerId', ''), defineProperty_default()(_ref, 'selectedUser', {}), defineProperty_default()(_ref, 'tempCustomer', {}), defineProperty_default()(_ref, 'showModal', false), defineProperty_default()(_ref, 'newUserCreated', false), defineProperty_default()(_ref, 'emptyReservation', {
			rentDescription: '',
			unitId: '',
			startDate: '',
			endDate: '',
			discount: 0,
			startTime: '00:00',
			endTime: '00:00',
			costData: {
				additionalItems: []
			},
			fuelStart: '',
			sensors: {},
			status: {},
			showPricesModal: false
		}), defineProperty_default()(_ref, 'selectedReservation', {
			startDate: '',
			endDate: '',
			startTime: '00:00',
			endTime: '00:00',
			discount: 0,
			costData: {
				additionalItems: []
			},
			fuelStart: '',
			sensors: {},
			status: {},
			showPricesModal: false,
			checkData: true
		}), _ref;
	},

	props: ['user', 'edit', 'id', 'units'],
	computed: {
		fullStartDate: function fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate: function fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		}
	},
	watch: {
		unitId: function unitId(val, oldVal) {
			if (val) {
				var selectedUnit = vue_underscore["a" /* _ */].where(this.units, { unitId: val });
				this.selectedReservation.freeMileage = selectedUnit[0].freeMileage;
				this.selectedReservation.kmPrice = selectedUnit[0].kmPrice;
				this.selectedReservation.rentDescription = this.selectedReservation.rentDescription && this.selectedReservation.rentDescription.indexOf('Verhuur') < 0 ? this.selectedReservation.rentDescription : 'Verhuur ' + selectedUnit[0].name + ' ' + selectedUnit[0].license;
				this.selectedReservation.unitId = val;
				this.getReservationCost();
			}
		},
		newUserCreated: function newUserCreated(val) {
			if (!val) {
				this.tempCustomerId = '';
				this.selectedUser = {};
				this.selectedReservation.user_id = 0;
				this.items = [];
				this.select = '';
			}
		},
		'selectedReservation.showModal': function selectedReservationShowModal(newVal) {
			if (newVal) {
				this.selectedReservation.vat = 21;
				this.selectedReservation.additionalItems = [];
				this.active = 'Gegevens';
				this.select = '';
				this.search = null;
				if (this.selectedReservation.unitId) {
					this.unitId = this.selectedReservation.unitId;
				} else {
					this.unitId = '';
				}
			}
		},
		search: function search(val) {
			val && this.querySelections(val);
		},
		select: function select(newVal) {
			if (newVal) {
				var selectedUser = vue_underscore["a" /* _ */].findWhere(this.items, { user_id: newVal });
				this.selectedUser = selectedUser;
				this.selectedReservation.username = selectedUser.username;
				this.selectedReservation.phoneno = selectedUser.phoneno;
				this.selectedReservation.city = selectedUser.city;
			}
		},

		'selectedReservation.startDate': function selectedReservationStartDate(value) {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.endDate': function selectedReservationEndDate() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.startTime': function selectedReservationStartTime() {
			if (this.checkData) {
				this.checkReservationDates();
				this.getReservationCost();
			}
		},
		'selectedReservation.endTime': function selectedReservationEndTime() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.discount': function selectedReservationDiscount() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.unitId': function selectedReservationUnitId() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.hasMaxTime': function selectedReservationHasMaxTime() {
			this.getReservationCost();
		}
	},
	methods: {
		openModal: function openModal() {
			this.items = [];
			this.search = '';
			this.select = '';
			this.active = 'Gegevens';
			this.showModal = true;
		},
		initReservation: function initReservation() {
			// if (this.$refs.form) {
			//   this.$refs.form.reset();
			// }
			var today = new Date();
			var todayMoment = moment_default()(today).format('YYYY-MM-DD');
			var startHours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
			var startTime = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
			var endTime = moment_default()(startHours + ':00', 'HH:mm').add(1, 'hours').format('HH:mm');
			this.selectedReservation = vue_underscore["a" /* _ */].clone(this.emptyReservation);
			this.selectedUser = {};
			this.tempCustomer = {};
			this.unitId = 0;
			this.selectedReservation.startDate = todayMoment;
			this.selectedReservation.startTime = startHours + ':' + startTime;
			this.selectedReservation.endDate = todayMoment;
			this.selectedReservation.endTime = endTime;
			this.selectedReservation.discount = 0;
			this.openModal();
		},
		openModalWithData: function openModalWithData(startDate, startTime, endDate, endTime, unitId, userId, currentReservation) {
			var self = this;
			this.checkData = false;

			if (currentReservation) {
				this.selectedReservation = assign_default()({}, currentReservation);
			}

			this.selectedReservation.startDate = startDate;
			this.selectedReservation.startTime = startTime;
			this.selectedReservation.endDate = endDate;
			this.selectedReservation.endTime = endTime;

			// Trigger to enable watch data
			setTimeout(function () {
				self.checkData = true;
				self.selectedReservation.unitId = unitId;
			}, 0);
			this.unitId = unitId;
			if (userId) {
				this.selectedReservation.user_id = userId;
				this.utils.getData(basePath + 'api/users/getUser/' + userId).then(function (json) {
					if (json.data) {
						self.selectedUser = json.data[0];
						self.selectedUser.Name = self.selectedUser.firstname + ' ' + self.selectedUser.lastname + ' ' + self.selectedUser.username;
						self.items.push(self.selectedUser);
						self.select = userId;
					}
				});
			}
			this.openModal();
		},
		closeModal: function closeModal() {
			this.showModal = false;
		},
		querySelections: function querySelections(v) {
			var self = this;
			this.loading = true;
			var data = {
				query: v
			};
			setData(basePath + 'api/users/searchUsers/', data).then(function (response) {
				if (response && response.data) {
					self.items = response.data;
				}
				self.loading = false;
			});
		},
		getReservationCost: function getReservationCost() {
			var self = this;
			if (this.selectedReservation.unitId) {
				this.priceLoading = true;
				var data = vue_underscore["a" /* _ */].clone(this.selectedReservation);
				var additionalItems = data.costData['additionalItems'];
				data.costData = {};
				data.hasMaxTime = this.selectedReservation.hasMaxTime;
				data.startDate = moment_default()(data.startDate + ':' + data.startTime, 'YYYY-MM-DD HH:mm').format();
				data.endDate = moment_default()(data.endDate + ':' + data.endTime, 'YYYY-MM-DD HH:mm').format();
				setData(basePath + 'api/reservations/newReservationCost/', data).then(function (response) {
					self.priceLoading = false;
					if (response && response.data) {
						self.selectedReservation.costData = response.data;
						self.selectedReservation.cost = response.data.totalDecimal.toFixed(2);
						self.selectedReservation.costData['additionalItems'] = additionalItems;
					}
					self.loading = false;
				});
			}
		},
		createReservation: function createReservation() {
			if (this.$refs.form.validate() && this.validateSelection()) {
				var self = this;
				var data = {
					startDate: moment_default()(self.selectedReservation.startDate + ':' + self.selectedReservation.startTime, 'YYYY-MM-DD HH:mm').format(),
					endDate: moment_default()(self.selectedReservation.endDate + ':' + self.selectedReservation.endTime, 'YYYY-MM-DD HH:mm').format(),
					user_id: this.select ? this.select : self.selectedReservation.user_id,
					prices: this.selectedReservation.costData.prices,
					unitId: self.selectedReservation.unitId,
					direct: false,
					kmPrice: self.selectedReservation.kmPrice,
					discount: self.selectedReservation.discount,
					freeMileage: self.selectedReservation.freeMileage,
					rentDescription: self.selectedReservation.rentDescription,
					sendConfirmation: self.selectedReservation.sendConfirmation,
					tempCustomerId: self.tempCustomerId,
					tempCustomer: self.tempCustomer,
					useTempCustomer: self.tempCustomer ? true : false,
					additionalItems: self.selectedReservation.costData.additionalItems,
					fuelStart: self.selectedReservation.fuelStart,
					kmStart: self.selectedReservation.kmStart,
					kmEnd: self.selectedReservation.kmStart,
					hasMaxTime: self.selectedReservation.hasMaxTime
				};

				self.showLoader(true);
				setData(basePath + 'api/reservations/newReservation/', data).then(function (json) {
					self.showLoader(false);
					self.updateModel('update', json['data']);
				});
				this.showModal = false;
			}
		},
		validateSelection: function validateSelection() {
			return this.select && this.select.length;
		},
		deleteReservation: function deleteReservation() {
			var self = this;
			utils_getData(basePath + 'api/reservations/deleteReservation/' + this.id).then(function (json) {
				self.updateModel('remove', this.id);
			});
			this.showModal = false;
		},
		updateModel: function updateModel(action, reservationId) {
			this.select = null;
			window.emitter.$emit('updateReservations', {
				action: action,
				id: reservationId
			});
			this.$emit('update', { id: reservationId });
		},
		searchUser: function searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		newUser: function newUser(event) {
			this.tempCustomerId = '';
			this.tempCustomer = {};
			this.$emit('newUser');
		},
		getUnitsPrices: function getUnitsPrices() {
			var self = this;
			utils_getData(basePath + 'api/rentunits/getUnitPrices/' + this.selectedReservation.unitId).then(function (json) {
				if (json && json.data) {
					self.selectedReservation.costData.prices = json.data;
				}
			});
		},
		allowedStartDates: function allowedStartDates(val) {
			var yd = new Date();
			yd.setDate(yd.getDate() - 1);
			return moment_default()(val, 'YYYY-MM-DD').isAfter(moment_default()(yd));
			//return moment(val, "YYYY-MM-DD").isBefore(moment(this.selectedReservation.endDate)) || moment(val, "YYYY-MM-DD").isSame(moment(this.selectedReservation.endDate), 'day');
		},
		allowedEndDates: function allowedEndDates(val) {
			return moment_default()(val, 'YYYY-MM-DD').isAfter(moment_default()(this.selectedReservation.startDate)) || moment_default()(val, 'YYYY-MM-DD').isSame(moment_default()(this.selectedReservation.startDate), 'day');
		},
		showLoader: function showLoader(enable) {
			window.emitter.$emit('showLoading', {
				enable: enable,
				msg: 'Gegevens ophalen'
			});
		},
		startDateChanged: function startDateChanged() {
			if (!this.startDateSet) {
				this.selectedReservation.endDate = this.selectedReservation.startDate;
				this.startDateSet = true;
			}
		},
		checkReservationDates: function checkReservationDates() {
			if (!moment_default()(this.selectedReservation.startDate + ' ' + this.selectedReservation.startTime, 'YYYY-MM-DD HH:mm').isBefore(moment_default()(this.selectedReservation.endDate + ' ' + this.selectedReservation.endTime, 'YYYY-MM-DD HH:mm'))) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Startdatum ligt na de einddatum',
					type: 'error'
				});
				this.saveDisabled = true;
			} else {
				this.saveDisabled = false;
			}
		},
		setPeriod: function setPeriod(data) {
			if (data.endTime) {
				this.selectedReservation.endTime = data.endTime;
			}
			if (data.endDate) {
				this.selectedReservation.endDate = data.endDate;
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d40f3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/NewReservationModal.vue
var NewReservationModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{staticClass:"mobileFullscreen",attrs:{"fullscreen":_vm.fullscreen,"lazy":"","max-width":"800px","transition":_vm.utils.getSettings('animation')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.showModal = false}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"compact"},[_c('v-tabs',{attrs:{"color":"blue darken-3","dark":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v("\n\t\t\t\t\t"+_vm._s(tab)+"\n\t\t\t\t\t"),(_vm.priceLoading && tab === 'Kostenoverzicht')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}}):_vm._e()],1)}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{key:'Gegevens',attrs:{"value":'Gegevens'}},[_c('v-card',{staticClass:"compact"},[_c('v-card-title',[_c('h2',[_vm._v("Nieuwe reservering")])]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","px-0":""}},[_c('v-layout',{attrs:{"wrap":"","px-0":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Omschrijving","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedReservation.rentDescription),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "rentDescription", $$v)},expression:"selectedReservation.rentDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.units,"label":"Selecteer auto","item-text":"fullDescription","item-value":"unitId","single-line":"","required":"","rules":_vm.basicRules,"menu-props":"{contentClass:'dialogDropdown','bottom':true}"},model:{value:(_vm.unitId),callback:function ($$v) {_vm.unitId=$$v},expression:"unitId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":""}},[_c('v-dialog',{ref:"menu",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","width":"290px","return-value":_vm.selectedReservation.startDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Startdatum","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fullStartDate),callback:function ($$v) {_vm.fullStartDate=$$v},expression:"fullStartDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"nl","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.selectedReservation.startDate);
															_vm.startDateChanged();}},model:{value:(_vm.selectedReservation.startDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startDate", $$v)},expression:"selectedReservation.startDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Annuleren")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time"},model:{value:(_vm.selectedReservation.startTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startTime", $$v)},expression:"selectedReservation.startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('select-period',{attrs:{"time":this.selectedReservation.startTime,"day":this.selectedReservation.startDate},on:{"setPeriod":function($event){return _vm.setPeriod($event)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":""}},[_c('v-dialog',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","width":"290px","return-value":_vm.selectedReservation.endDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Einddatum","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fullEndDate),callback:function ($$v) {_vm.fullEndDate=$$v},expression:"fullEndDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"nl","scrollable":""},on:{"change":function($event){return _vm.$refs.menu2.save(_vm.selectedReservation.endDate)}},model:{value:(_vm.selectedReservation.endDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endDate", $$v)},expression:"selectedReservation.endDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("Annuleren")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time"},model:{value:(_vm.selectedReservation.endTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endTime", $$v)},expression:"selectedReservation.endTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-checkbox',{staticClass:"maxEnd",attrs:{"label":"Max eindtijd"},model:{value:(_vm.selectedReservation.hasMaxTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "hasMaxTime", $$v)},expression:"selectedReservation.hasMaxTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Kosten","type":"text","readonly":""},model:{value:(_vm.selectedReservation.cost),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "cost", $$v)},expression:"selectedReservation.cost"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Km prijs","type":"number","min":"0","step":"0.01"},model:{value:(_vm.selectedReservation.kmPrice),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "kmPrice", $$v)},expression:"selectedReservation.kmPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":"","xs3":""}},[_c('v-text-field',{attrs:{"label":"Korting","type":"number","min":"0","step":"0.01"},model:{value:(_vm.selectedReservation.discount),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "discount", $$v)},expression:"selectedReservation.discount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[(!_vm.newUserCreated)?_c('v-autocomplete',{attrs:{"label":"Zoek gebruiker","loading":_vm.loading,"item-text":"Name","item-value":"user_id","placeholder":"Voornaam, achternaam, e-mail","no-data-text":_vm.search ? 'Geen resultaten' : '',"autocomplete":"false","chips":"","items":_vm.items,"search-input":_vm.search,"required":"","rules":_vm.basicRules},on:{"keyup":_vm.searchUser,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}}):_vm._e(),_vm._v(" "),(_vm.newUserCreated)?_c('v-text-field',{attrs:{"label":"Naam","type":"text","value":_vm.selectedUser.firstname}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(!_vm.newUserCreated)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.newUser($event)}}},[_vm._v("Nieuw\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.tempCustomer.t_name
															? '(' + _vm.tempCustomer.t_name + ')'
															: ''))]):_vm._e(),_vm._v(" "),(_vm.newUserCreated)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.newUserCreated = false}}},[_vm._v("Wijzig")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md6":""}},[(_vm.select)?_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","readonly":""},model:{value:(_vm.selectedReservation.phoneno),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "phoneno", $$v)},expression:"selectedReservation.phoneno"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[(_vm.select)?_c('v-text-field',{attrs:{"label":"Woonplaats","type":"text","readonly":""},model:{value:(_vm.selectedReservation.city),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "city", $$v)},expression:"selectedReservation.city"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"Stuur bevestiging"},model:{value:(_vm.selectedReservation.sendConfirmation),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "sendConfirmation", $$v)},expression:"selectedReservation.sendConfirmation"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("* verplichte velden")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Kostenoverzicht',attrs:{"value":'Kostenoverzicht'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Kostenoverzicht #"+_vm._s(_vm.selectedReservation.id))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.showModal)?_c('reservation-cost-details',{attrs:{"reservation":_vm.selectedReservation,"editable":true}}):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"Aanvullend",attrs:{"value":"Aanvullend"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Aanvullende gegevens")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Kmstand start","type":"number"},model:{value:(_vm.selectedReservation.kmStart),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "kmStart", $$v)},expression:"selectedReservation.kmStart"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Brandstof start","type":"number"},model:{value:(_vm.selectedReservation.fuelStart),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "fuelStart", $$v)},expression:"selectedReservation.fuelStart"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"name":"remarks","label":"Vul hier in","value":""},model:{value:(_vm.selectedReservation.remarks),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "remarks", $$v)},expression:"selectedReservation.remarks"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Klantgegevens',attrs:{"value":'Klantgegevens'}},[_c('v-container',{attrs:{"grid-list-md":"","pa-2":""}},[_c('customer-card',{attrs:{"user":_vm.selectedUser}}),_vm._v(" "),_c('temp-customer',{attrs:{"user":_vm.tempCustomer,"optional":true}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-xs-right":""}},[_c('v-btn',{attrs:{"color":"primary darken-1","disabled":_vm.saveDisabled},nativeOn:{"click":function($event){return _vm.createReservation()}}},[_vm._v("Opslaan")])],1)],1)],1)],2)],1)],1),_vm._v(" "),_c('reservation-prices',{attrs:{"reservation":_vm.selectedReservation,"edit":_vm.editPrices}})],1)}
var NewReservationModal_staticRenderFns = []
var NewReservationModal_esExports = { render: NewReservationModal_render, staticRenderFns: NewReservationModal_staticRenderFns }
/* harmony default export */ var Reservations_NewReservationModal = (NewReservationModal_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/NewReservationModal.vue
var NewReservationModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewReservationModal___vue_template_functional__ = false
/* styles */
var NewReservationModal___vue_styles__ = null
/* scopeId */
var NewReservationModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NewReservationModal___vue_module_identifier__ = null
var NewReservationModal_Component = NewReservationModal_normalizeComponent(
  NewReservationModal,
  Reservations_NewReservationModal,
  NewReservationModal___vue_template_functional__,
  NewReservationModal___vue_styles__,
  NewReservationModal___vue_scopeId__,
  NewReservationModal___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_NewReservationModal = (NewReservationModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Planner/PlannerFilter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PlannerFilter = ({
  name: 'PlannerFilter',
  data: function data() {
    return {
      date: null,
      menu: false,
      modal: false,
      min: '2016-06-15',
      max: '2018-03-20'
    };
  },
  props: ['minDate', 'maxDate'],
  watch: {
    date: function date(newVal) {
      this.$emit('gotoDate', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1170a0d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Planner/PlannerFilter.vue
var PlannerFilter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.date},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',[_vm._v("date_range")])],1),_vm._v(" "),_c('v-date-picker',{attrs:{"min":_vm.minDate,"max":_vm.maxDate,"locale":"nl","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.modal = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.date)}}},[_vm._v("OK")])],1)],1)],1)],1)}
var PlannerFilter_staticRenderFns = []
var PlannerFilter_esExports = { render: PlannerFilter_render, staticRenderFns: PlannerFilter_staticRenderFns }
/* harmony default export */ var Planner_PlannerFilter = (PlannerFilter_esExports);
// CONCATENATED MODULE: ./src/components/Planner/PlannerFilter.vue
var PlannerFilter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PlannerFilter___vue_template_functional__ = false
/* styles */
var PlannerFilter___vue_styles__ = null
/* scopeId */
var PlannerFilter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PlannerFilter___vue_module_identifier__ = null
var PlannerFilter_Component = PlannerFilter_normalizeComponent(
  PlannerFilter,
  Planner_PlannerFilter,
  PlannerFilter___vue_template_functional__,
  PlannerFilter___vue_styles__,
  PlannerFilter___vue_scopeId__,
  PlannerFilter___vue_module_identifier__
)

/* harmony default export */ var components_Planner_PlannerFilter = (PlannerFilter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Planner/Planner.vue





var _name$components$crea;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var Planner = (_name$components$crea = {
	name: 'Planner',
	components: {
		UserModal: components_Users_UserModal,
		NewReservationModal: components_Reservations_NewReservationModal,
		PlannerFilter: components_Planner_PlannerFilter,
		HistoryModal: components_History_HistoryModal
	},
	created: function created() {
		var self = this;
		this.getUnits();
		this.renderMonths();

		window.emitter.$off('newUser');
		window.emitter.$on('newUser', function () {
			self.newUser();
		});

		// window.emitter.$on('updateHistory', function() {
		//     self.getUnits();
		// });

		var self = this;
		self.elapsedToday = self.percTodayElapsed();

		this.loop = (function () {
			self.elapsedToday = self.percTodayElapsed();
		}, 60000);
	},
	destroyed: function destroyed() {
		clearInterval(this.loop);
	},

	props: ['selectedUnit'],
	data: function data() {
		return {
			units: [],
			saveUnits: [],
			months: {},
			utils: utils_namespaceObject,
			loading: false,
			filterUnit: '',
			elapsedToday: 0,
			scrolledMonth: '',
			scrolledMonthDescription: '',
			scrollIndex: 1,
			scrollTimeout: null,
			filterMinDate: '',
			filterMaxDate: '',
			showUnits: true,
			loop: null,
			reservation: {
				id: ''
			},
			editReservation: {
				showModal: false
			},
			newReservationData: {
				showModal: false,
				startDate: '',
				endDate: '',
				startTime: '00:00',
				endTime: '00:00',
				discount: 0,
				costData: {
					prices: [],
					additionalItems: []
				}
			},
			editUser: {
				showModal: false
			},
			user: {
				edit: false
			},
			unit: {
				unitId: 0
			},
			editUnit: {
				showModal: false
			},
			plannerHtml: '',
			reservationList: {}
		};
	},
	mounted: function mounted() {
		var self = this;

		this.gotoToday();
	},
	beforeDestroy: function beforeDestroy() {
		window.emitter.$off('updateReservations');
	},

	computed: {
		selectableUnits: function selectableUnits() {
			var list = [{ fullDescription: 'Toon alle', unitId: 'all' }];
			return list.concat(this.saveUnits);
		},
		rentOrHistoryId: function rentOrHistoryId() {
			console.log(this.reservation);
		}
	}
}, defineProperty_default()(_name$components$crea, 'beforeDestroy', function beforeDestroy() {
	window.emitter.$off('updateHistory');
}), defineProperty_default()(_name$components$crea, 'watch', {
	$route: function $route(to, from) {
		var self = this;
		if (to.name === 'Planner') {
			this.gotoToday();
		}
	},
	filterUnit: function filterUnit(newVal) {
		if (newVal !== 'all') {
			this.units = vue_underscore["a" /* _ */].filter(this.saveUnits, { unitId: newVal });
		} else {
			this.units = this.saveUnits;
		}
	}
}), defineProperty_default()(_name$components$crea, 'updated', function updated() {
	this.renderReservations();
}), defineProperty_default()(_name$components$crea, 'methods', {
	hasReservation: function hasReservation(key) {
		return true;
	},
	detectScroll: function detectScroll() {
		var self = this;
		var elem = this.$el;
		var daysScroller = elem.querySelector('#daysScroller');
		var monthContainer = elem.querySelector('#month');
		var todayElement = elem.querySelector('.isToday');
		var currentMonth = moment_default()().month();
		var month = currentMonth;
		self.scrolledMonth = currentMonth;
		todayElement.scrollIntoView({ block: 'center' });
		this.scrolledMonthDescription = this.utils.getMonth(this.scrolledMonth);
		monthContainer.innerHTML = self.utils.getMonth(currentMonth);
		daysScroller.addEventListener('scroll', function (e) {
			var scrollLeft = e.target.scrollLeft;

			keys_default()(self.months).forEach(function (key) {
				var monthData = self.months[key];
				if (scrollLeft >= monthData.scrollLeft && scrollLeft <= monthData.scrollRight) {
					month = parseInt(key) - 1;
				}
			});

			monthContainer.innerHTML = self.utils.getMonth(month);
		});
	},
	gotoToday: function gotoToday() {
		setTimeout(function () {
			var todayElement = document.querySelector('.isToday');
			todayElement.scrollIntoView({ inline: 'center' });
		}, 0);
	},
	getUnits: function getUnits() {
		this.loading = true;
		var myInit = {
			method: 'POST',
			mode: 'cors',
			body: stringify_default()({
				b: localStorage.getItem('b')
			}),
			cache: 'default'
		};
		var self = this;
		fetch(basePath + 'api/reservations/getPlannerData/' + (self.selectedUnit ? self.selectedUnit : ''), myInit).then(function (response) {
			var contentType = response.headers.get('content-type');
			self.loading = false;
			if (contentType && contentType.includes('application/json')) {
				return response.json();
			}
			throw new TypeError("Oops, we haven't got JSON!");
		}).then(function (json) {
			self.units = json.data;
			self.saveUnits = self.units;
			setTimeout(function () {
				//  self.renderReservations();
			}, 500);
		}).catch(function (error) {
			console.log(error);
		});
	},
	renderReservations: function renderReservations() {
		var self = this;
		var elements = document.getElementsByClassName('reservation');
		while (elements.length > 0) {
			elements[0].remove();
		}for (var i = 0; i < this.units.length; i++) {
			var unit = this.units[i];
			for (var j = 0; j < unit.rentData.length; j++) {
				var schedule = unit.rentData[j];
				for (var k = 0; k < schedule.days.length; k++) {
					var day = schedule.days[k];
					if (!this.reservationList[day['identifier']]) {
						this.reservationList[day['identifier']] = [];
					}

					this.reservationList[day['identifier']].push(day);

					var el = document.getElementById(day['identifier']);
					if (el) {
						var title = this.utils.getFullDate(schedule['startDate']) + ' t/m ' + this.utils.getFullDate(schedule['endDate']) + ' ' + schedule['firstname'] + ' ' + schedule['lastname'];
						document.getElementById(day['identifier']).insertAdjacentHTML('beforeend', '<i slot="activator" id="reservation_' + day['identifier'] + '_' + schedule['id'] + '" title="' + title + '" class="' + day.class + (schedule.closed == '1' ? ' closed' : schedule.inRent == '1' ? ' green-tp' : '') + '" reservation" data-starttext="' + day.starttext + '" data-endtext="' + day.endtext + '" data-closed="' + schedule.closed + '" data-reservationid="' + schedule.id + '" style="left: ' + day.left + '%; right: ' + day.right + '%"></i>');
						var reservationEl = document.getElementById('reservation_' + day['identifier'] + '_' + schedule['id']);
						reservationEl.onclick = function (e) {
							var reservationId = e.srcElement.dataset.reservationid;
							var closed = e.srcElement.dataset.closed;
							self.viewReservationDetails(reservationId, closed == '1');
							e.preventDefault();
							return false;
						};
					}
				}
			}
		}
	},

	renderMonths: function renderMonths() {
		var year = moment_default()().year();
		var currentMonth = moment_default()().month();
		var month = currentMonth;
		var monthsTemp = {};
		var visibleMonths = {};
		var width = window.innerWidth < 700 ? 100 : 200;
		var count = 0;
		var monthsBack = 3;
		var monthsForward = 6;
		var startMonth = currentMonth;

		for (var j = currentMonth - monthsBack; j <= startMonth + monthsForward; j++) {
			var loopMonth = j;

			if (loopMonth > 12) {
				loopMonth = j - 12;
			}
			if (loopMonth < 1) {
				loopMonth = j + 12;
			}
			if (loopMonth > currentMonth && count <= monthsBack) {
				visibleMonths[String(year - 1) + String(this.addZeroToNumber(loopMonth))] = {
					year: year - 1,
					month: loopMonth
				};
			} else if (loopMonth < currentMonth && count >= monthsBack) {
				visibleMonths[String(year + 1) + String(this.addZeroToNumber(loopMonth))] = {
					year: year + 1,
					month: loopMonth
				};
			} else {
				visibleMonths[String(year) + String(this.addZeroToNumber(loopMonth))] = {
					year: year,
					month: loopMonth
				};
			}

			count++;
		}
		var convertedMonths = values_default()(visibleMonths);
		for (var i = 0; i < convertedMonths.length; i++) {
			var visible = convertedMonths[i];
			var daysCount = moment_default()(visible['year'] + '-' + this.getConvertedMonth(visible['month']), 'YYYY-MM').daysInMonth();

			if (i === 0) {
				this.filterMinDate = visible['year'] + '-' + this.addZeroToNumber(visible['month']) + '-' + '01';
			}

			if (i === convertedMonths.length - 1) {
				this.filterMaxDate = visible['year'] + '-' + this.addZeroToNumber(visible['month']) + '-' + daysCount;
			}

			if (!monthsTemp[i]) {
				monthsTemp[i] = {
					month: visible['month'],
					year: visible['year'],
					days: daysCount,
					scrollLeft: daysCount * width * (i + 1),
					scrollRight: daysCount * width * (i + 1),
					daysWidth: daysCount * width,
					scrollPos: 0
				};
			}
		}

		this.months = monthsTemp;
	},
	addZeroToNumber: function addZeroToNumber(number) {
		if (String(number).length === 1) {
			return '0' + String(number);
		} else {
			return number;
		}
	},

	getConvertedMonth: function getConvertedMonth(month) {
		return month;
	},
	getDay: function getDay(day, month, year) {
		var dayarray = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
		var mydate = year + '-' + month + '-' + day + 'T00:00:00';
		return dayarray[moment_default()(mydate, 'YYYY-MM-DD').day()];
	},
	checkDateIsToday: function checkDateIsToday(day, month, year) {
		var mydate = year + '-' + month + '-' + day + 'T00:00:00';
		return moment_default()(mydate, 'YYYY-MM-DD').isSame(moment_default()(), 'day');
	},
	percTodayElapsed: function percTodayElapsed(start, end) {
		var now = moment_default()();
		start = start || moment_default()(now).startOf('day');
		end = end || moment_default()(now).endOf('day');
		var totalMillisInRange = end.valueOf() - start.valueOf();
		var elapsedMillis = now.valueOf() - start.valueOf();
		return Math.max(0, Math.min(100, 100 * (elapsedMillis / totalMillisInRange)));
	},

	getMonth: function getMonth(index) {
		if (index || index === 0) {
			var maandArray = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
			return maandArray[index];
		} else {
			return '';
		}
	},
	checkReservedDay: function checkReservedDay(unit, day, monthInfo) {
		var dayBlock = [];
		if (unit.rentData.length && monthInfo) {
			for (var i = 0; i < unit.rentData.length; i++) {
				var rentData = unit.rentData[i];
				var startDate = rentData.startDate;
				var endDate = rentData.endDate;
				var momentDate = moment_default()(monthInfo.year + '-' + monthInfo.month + '-' + day, 'YYYY-MM-DD');

				if (momentDate.isBetween(startDate, endDate, 'days', '[]')) {
					var isSameStart = momentDate.isSame(startDate, 'day');
					var isSameEnd = momentDate.isSame(endDate, 'day');
					var startDateFormatted = moment_default()(rentData.startDate).format('DD-MM-YYYY HH:mm');
					dayBlock.push({
						closed: rentData.closed == 1,
						rentId: rentData.id,
						active: rentData.inRent == 1,
						activeAfterRentPeriod: momentDate.isSameOrBefore(new Date()) && momentDate.isSameOrAfter(moment_default()(rentData.startDate)) && moment_default()(endDate).isSameOrBefore(momentDate) ? true : false,
						startDate: startDateFormatted,
						leftstart: isSameStart ? this.getStartLeft(startDate, momentDate) : '0',
						startText: isSameStart ? moment_default()(startDate).format('HH:mm') : '',
						endText: isSameEnd ? moment_default()(endDate).format('HH:mm') : '',
						rightstart: isSameEnd ? this.getStartRight(endDate, momentDate) : '0',
						endDate: moment_default()(rentData.endDate).format('DD-MM-YYYY HH:mm'),
						fullname: rentData.firstname + ' ' + rentData.lastname,
						startDay: isSameStart,
						endDay: isSameEnd
					});
				} else if (rentData.inRent == 1 && momentDate.isSameOrBefore(new Date()) && momentDate.isSameOrAfter(moment_default()(rentData.startDate)) && moment_default()(endDate).isBefore(momentDate)) {
					dayBlock.push({
						activeAfterRentPeriod: true,
						rentId: rentData.id,
						rightstart: this.getStartRight(new Date())
					});
				}
			}
			return dayBlock;
		}
	},
	viewReservationDetails: function viewReservationDetails(reservationId, closed) {
		if (closed) {
			this.$refs.historyModal.getHistoryData(reservationId);
		} else {
			this.$refs.reservationModal.showReservation(reservationId);
		}
	},
	scroll: function scroll(e) {
		var self = this;
		var monthWidth = 6200;
		var index = Math.floor(e.target.scrollLeft / monthWidth);
		self.scrolledMonth = index;
		self.scrolledMonthDescription = self.utils.getMonth(index);
	},
	getStartLeft: function getStartLeft(start) {
		return 100 - ((1440 - moment_default()(start, 'YYYY-MM-DD HH:mm:ss').diff(moment_default()(start, 'YYYY-MM-DD HH:mm:ss').startOf('day'), 'minutes')) / 1440).toFixed(2) * 100;
	},
	getStartRight: function getStartRight(end) {
		return ((1440 - moment_default()(end, 'YYYY-MM-DD HH:mm:ss').diff(moment_default()(end, 'YYYY-MM-DD HH:mm:ss').endOf('day'), 'minutes')) / 1440).toFixed(2) * 100 - 100;
	},
	newUnitReservation: function newUnitReservation(unit, day, month, daysInfo) {
		var startDate = moment_default()(month.year + '-' + month.month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DD');
		var endDate = moment_default()(month.year + '-' + month.month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DD');
		var startTime = '00:00';
		if (daysInfo && daysInfo.length) {
			var startTimeData = moment_default()(daysInfo[daysInfo.length - 1].endDate).format('HH:mm');
			startTime = startTimeData;
		} else {
			startTime = this.getStartTime();
		}
		var endTime = '23:59';
		this.$refs.newReservationModal.openModalWithData(startDate, startTime, endDate, endTime, unit);
	},
	getStartTime: function getStartTime() {
		var today = new Date();
		var todayMoment = moment_default()(today).format('YYYY-MM-DD');
		var startHours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
		var startTime = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
		return startHours + ':' + startTime;
	},
	newUser: function newUser() {
		this.$refs.userModal.newUser();
	},
	showUnit: function showUnit(unitId) {
		this.unit.unitId = unitId;
		this.editUnit.showModal = true;
	},
	updateUnits: function updateUnits() {
		this.getUnits();
	},
	newReservation: function newReservation(event, unitId, month, day) {
		var startTime = '';
		var endTime = '';
		var startDate = '';
		var endDate = '';
		var isToday = true;

		if (month) {
			startDate = moment_default()(month.year + '-' + month.month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DD');
			endDate = moment_default()(month.year + '-' + month.month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DD');
			isToday = this.checkDateIsToday(day, month.month, month.year);
		}

		if (event) {
			var elWidth = event.target.scrollWidth;
			var leftX = event.offsetX;
			var identifier = event.target.id;
			if (this.reservationList[identifier]) {
				for (var i = 0; i < this.reservationList[identifier].length; i++) {
					var reservation = this.reservationList[identifier][i];
					if (reservation.left === 0 && this.reservationList[identifier].length === 1 || leftX > elWidth - reservation.right / 100 * elWidth) {
						startTime = reservation.endtext;
					}

					if (reservation.left === 0 && this.reservationList[identifier].length === 1 || leftX < reservation.left / 100 * elWidth) {
						endTime = reservation.starttext;
					}
				}
			}
		}

		if (event && event.srcElement.className.indexOf('reservation') >= 0) {
			return false;
		}
		var today = new Date();
		var todayMoment = moment_default()(today).format('YYYY-MM-DD');
		var todayEndTime = '23:59';
		var startDateReservation = startDate ? startDate : todayMoment;
		var endDateReservation = endDate ? endDate : todayMoment;
		var startTimeReservation = startTime ? startTime : isToday ? this.getStartTime() : '08:00';
		var endTimeReservation = endTime ? endTime : todayEndTime;
		this.$refs.newReservationModal.openModalWithData(startDateReservation, startTimeReservation, endDateReservation, endTimeReservation, unitId);
	},
	gotoDate: function gotoDate(value) {
		if (value) {
			var filterDateData = value.split('-');
			var filterDate = parseInt(filterDateData[2]) + '' + parseInt(filterDateData[1]) + '' + parseInt(filterDateData[0]);

			this.$el.querySelector('.day_' + filterDate).scrollIntoView({ block: 'center' });
		}
	},
	toggleLabels: function toggleLabels() {
		this.$el.querySelector('#units').classList.toggle('active');
		this.$el.querySelector('.showLabelsOff').classList.toggle('hidden');
		this.$el.querySelector('.showLabelsOn').classList.toggle('hidden');
	},
	copyReservation: function copyReservation(reservation) {
		var diff = moment_default()(reservation.endDate).diff(moment_default()(reservation.startDate), 'months');
		var newEndDate = moment_default()(reservation.endDate).add(diff, 'months').format('YYYY-MM-DD');

		this.$refs.newReservationModal.openModalWithData(reservation.endDate, reservation.endTime, newEndDate, reservation.endTime, reservation.unitId, reservation.user_id, reservation);
	}
}), _name$components$crea);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bf382a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Planner/Planner.vue
var Planner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"100%"},attrs:{"fluid":"fluid","calendarOverview":""}},[_c('v-layout',{staticStyle:{"margin-bottom":"70px"},attrs:{"row":"","wrap":""}},[(_vm.loading)?_c('table-loader'):_vm._e(),_vm._v(" "),(!_vm.selectedUnit)?_c('h1',{staticClass:"hidden-sm-and-down"},[_vm._v("Planner")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.selectedUnit)?_c('div',{staticClass:"d-inline-flex"},[_c('v-select',{attrs:{"prepend-inner-icon":"directions_car","items":this.selectableUnits,"label":"Filter unit","item-text":"fullDescription","item-value":"unitId","single-line":"","menu-props":"'bottom'"},model:{value:(_vm.filterUnit),callback:function ($$v) {_vm.filterUnit=$$v},expression:"filterUnit"}}),_vm._v(" "),_c('planner-filter',{attrs:{"minDate":_vm.filterMinDate,"maxDate":_vm.filterMaxDate},on:{"gotoDate":_vm.gotoDate}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex md12 plannerContainer"},[(!_vm.selectedUnit)?_c('v-flex',{staticClass:"active",attrs:{"units":"","xl1":"","md3":"","sm3":"","xs3":"","text-xs-left":"","id":"units"}},[_c('ul',{staticClass:"pl-0"},_vm._l((_vm.units),function(item,index){return _c('li',{key:index,staticClass:"item",on:{"click":function($event){return _vm.showUnit(item.unitId)}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"header calenderUnit"},[_c('span',{staticClass:"unitDetails d-inline"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.license))])])])])])}),0)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","daysScroller":"","id":"daysScroller"}},[_c('div',{staticClass:"daysContainer"},[_c('div',{staticClass:"dates"},_vm._l((_vm.months),function(month,index){return _c('span',{key:index,staticClass:"monthSchedule"},_vm._l((month.days),function(day,index){return _c('span',{key:index,staticClass:"day header",class:[
									_vm.checkDateIsToday(index + 1, month.month, month.year)
										? 'isToday'
										: '',
									'day_' +
										(String(index + 1) +
											String(month.month) +
											String(month.year))
								],attrs:{"data-ellapsedrist":_vm.checkDateIsToday(index + 1, month.month, month.year)
										? _vm.percTodayElapsed()
										: ''}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.getDay(index + 1, month.month, month.year))+"\n\t\t\t\t\t\t\t\t"),_c('span',{staticClass:"dateTag"},[_vm._v(_vm._s(day)+" - "+_vm._s(month.month))]),_vm._v(" "),(_vm.checkDateIsToday(index + 1, month.month, month.year))?_c('span',{style:({ left: _vm.elapsedToday + '%' }),attrs:{"id":"elapsedIndicator"}}):_vm._e()])}),0)}),0),_vm._v(" "),_vm._l((_vm.units),function(unit,index){return _c('div',{key:index,staticClass:"unitTimeline"},_vm._l((_vm.months),function(month,index){return _c('span',{key:index,staticClass:"monthSchedule"},_vm._l((month.days),function(day,index){return _c('span',{key:index,staticClass:"day",attrs:{"id":unit.unitId +
										'_' +
										month.year +
										'_' +
										month.month +
										'_' +
										day},on:{"click":function($event){return _vm.newReservation($event, unit.unitId, month, day)}}})}),0)}),0)})],2)])],1)],1),_vm._v(" "),(!_vm.selectedUnit)?_c('v-btn',{attrs:{"fixed":"","dark":"","fab":"","menu-props":"bottom","right":"","color":"pink"},on:{"click":function($event){return _vm.newReservation()}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('user-modal',{ref:"userModal",attrs:{"id":_vm.user.id,"edit":_vm.editUser,"user":_vm.user,"showSelector":true}}),_vm._v(" "),_c('reservations-modal',{ref:"reservationModal",attrs:{"id":_vm.reservation.id,"edit":_vm.editReservation,"reservation":_vm.reservation,"units":_vm.units},on:{"update":_vm.getUnits,"copyReservation":function($event){return _vm.copyReservation($event)}}}),_vm._v(" "),_c('new-reservation-modal',{ref:"newReservationModal",attrs:{"id":_vm.reservation.id,"edit":_vm.newReservationData,"units":_vm.units},on:{"newUser":function($event){return _vm.newUser()},"update":_vm.getUnits}}),_vm._v(" "),_c('history-modal',{ref:"historyModal",attrs:{"units":_vm.units},on:{"update":_vm.getUnits,"copyReservation":function($event){return _vm.copyReservation($event)}}})],1)}
var Planner_staticRenderFns = []
var Planner_esExports = { render: Planner_render, staticRenderFns: Planner_staticRenderFns }
/* harmony default export */ var Planner_Planner = (Planner_esExports);
// CONCATENATED MODULE: ./src/components/Planner/Planner.vue
function Planner_injectStyle (ssrContext) {
  __webpack_require__("3Kcd")
}
var Planner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Planner___vue_template_functional__ = false
/* styles */
var Planner___vue_styles__ = Planner_injectStyle
/* scopeId */
var Planner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Planner___vue_module_identifier__ = null
var Planner_Component = Planner_normalizeComponent(
  Planner,
  Planner_Planner,
  Planner___vue_template_functional__,
  Planner___vue_styles__,
  Planner___vue_scopeId__,
  Planner___vue_module_identifier__
)

/* harmony default export */ var components_Planner_Planner = (Planner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Home = ({
  name: "Home",
  components: { UserModal: components_Users_UserModal },
  data: function data() {
    return {
      msg: "Welcome to Your Vue.js App!!..............",
      src: "",
      showModal: false
    };
  },
  created: function created() {
    var self = this;
    fetch("src/assets/9506.jpg").then(function (response) {
      return response.blob();
    }).then(function (myBlob) {
      var objectURL = URL.createObjectURL(myBlob);
      self.src = objectURL;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd21aaa0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('my-table'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',[_vm._v("Raised Light Theme")]),_vm._v(" "),_c('v-card',{attrs:{"height":"185px","flat":"","color":"white"}},[_c('v-card-text',[_c('div',[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Primary")])],1),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"error"}},[_vm._v("Error")])],1),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"light":"","disabled":""}},[_vm._v("Disabled")])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h1',[_vm._v("Raised Dark Theme")]),_vm._v(" "),_c('v-card',{attrs:{"height":"185px","flat":"","color":"secondary"}},[_c('v-card-text',[_c('div',[_c('v-btn',{attrs:{"color":"primary","dark":""}},[_vm._v("Primary")])],1),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"error","dark":""}},[_vm._v("Error")])],1),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"primary","dark":"","disabled":""}},[_vm._v("Disabled")])],1)])],1)],1)],1),_vm._v(" "),_c('user-modal')],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("wb7k")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-dd21aaa0"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-pull-refresh/dist/vue-pull-refresh.min.js
var vue_pull_refresh_min = __webpack_require__("z9mE");
var vue_pull_refresh_min_default = /*#__PURE__*/__webpack_require__.n(vue_pull_refresh_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/UsersTable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UsersTable = ({
	name: 'UsersTable',
	components: { VuePullRefresh: vue_pull_refresh_min_default.a },
	props: ['filters'],
	data: function data() {
		return {
			pullConfig: window.pullConfig,
			dialog: false,
			pagination: {
				sortBy: 'id',
				descending: true,
				page: 1,
				rowsPerPage: 25,
				totalItems: 0
			},
			selected: [],
			search: '',
			utils: utils_namespaceObject,
			headers: [{
				text: '#',
				align: 'left',
				value: 'id'
			}, { text: 'Voornaam', value: 'firstname' }, { text: 'Achternaam', value: 'lastname' }, { text: 'Bedrijfsnaam', value: 'companyname' }, { text: 'E-mail', value: 'username' }, { text: 'Tel nr', value: 'phoneno' }, { text: 'Laatste huur', value: 'lastRentDate' }, { text: 'Totaal', value: 'totalRentSum' }, { text: 'Rental check', value: 'rentalCheck_status' }, { text: 'Actief', value: 'active' }],
			items: [],
			allItems: [],
			loading: true,
			searchTerm: ''
		};
	},

	watch: {
		$route: function $route(to, from) {
			this.pagination.page = 1;
			this.showUsers();
		},

		pagination: {
			handler: function handler(newPagination) {
				this.showUsers();
			},

			deep: true
		},
		search: function search(val) {
			// Removed automatic search on keystroke - now triggered by Enter key only
		},

		filters: {}
	},
	created: function created() {
		this.showUsers();
	},
	methods: {
		showUsers: function showUsers() {
			var self = this;
			this.getUsers().then(function () {
				if (self.$route.params.type) {
					self.items = vue_underscore["a" /* _ */].filter(self.allItems, { active: '0' });
				}
			});
		},
		performSearch: function performSearch() {
			this.searchTerm = this.search;
			// Reset to first page when search changes
			this.pagination.page = 1;
			this.getUsers();
		},
		clearSearch: function clearSearch() {
			this.search = '';
			this.searchTerm = '';
			// Reset to first page
			this.pagination.page = 1;
			this.getUsers();
		},
		getUsers: function getUsers() {
			var self = this;
			self.loading = true;
			var page = this.pagination.page;
			var limit = this.pagination.rowsPerPage;
			var offset = (page - 1) * limit;

			var url = void 0;
			if (this.searchTerm && this.searchTerm.trim() !== '') {
				// Use search endpoint when searching
				url = basePath + 'api/users/search?query=' + encodeURIComponent(this.searchTerm) + '&page=' + page + '&limit=' + limit + '&offset=' + offset;
			} else {
				// Use regular endpoint for all users
				url = basePath + 'api/users/?page=' + page + '&limit=' + limit + '&offset=' + offset;
			}

			return utils_getData(url).then(function (json) {
				self.loading = false;
				self.items = json.data;
				// Update total items if provided by API
				if (json.total !== undefined) {
					self.pagination.totalItems = json.total;
				}
			});
		},
		showUser: function showUser(user) {
			user.edit = true;
			this.$emit('showUser', user);
		},
		toggleAll: function toggleAll() {
			if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
		},
		changeSort: function changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		onRefresh: function onRefresh() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				self.getUsers(false).then(function () {
					setTimeout(function () {
						resolve();
					}, 500);
				});
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7dac226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UsersTable.vue
var UsersTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex xl12 lg12 md12 mx-auto"},[_c('vue-pull-refresh',{attrs:{"on-refresh":_vm.onRefresh,"config":_vm.pullConfig}},[_c('v-card',{attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-title',{staticClass:"px-1 pt-0"},[_c('h1',{staticClass:"hidden-sm-and-down"},[_vm._v("Gebruikers")]),_vm._v(" "),_c('v-spacer',{staticClass:"hidden-sm-and-down"}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Zoeken","single-line":"","hide-details":"","prepend-inner-icon":"search","clearable":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.performSearch.apply(null, arguments)},"click:clear":_vm.clearSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"rows-per-page-items":[25, 50],"no-data-text":"...","loading":_vm.loading,"item-key":"name","total-items":_vm.pagination.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticClass:"hidden-xs-only"},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
								'column sortable text-xs-left',
								_vm.pagination.descending ? 'desc' : 'asc',
								header.value === _vm.pagination.sortBy ? 'active' : ''
							],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(header.text)+"\n\t\t\t\t\t\t\t"),_c('v-icon',[_vm._v("arrow_upward")])],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){return _vm.showUser(props.item)}}},[_c('td',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(props.item.memberNumber))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.firstname)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.lastname)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.companyname)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.username)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.phoneno)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.lastRentDate, false))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("toCurrency")(props.item.totalRentSum))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.rentalCheck_status || '-')+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-sm-and-up itemRow"},[_c('h3',[_vm._v("\n\t\t\t\t\t\t\t\t#"+_vm._s(props.item.id)+" "+_vm._s(props.item.firstname)+"\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.lastname)+"\n\t\t\t\t\t\t\t\t"),(props.item.companyname)?[_vm._v("\n\t\t\t\t\t\t\t\t\t- "+_vm._s(props.item.companyname))]:_vm._e()],2),_vm._v(" "),(props.item.totalRentSum)?[_vm._v("€ "+_vm._s(_vm._f("toCurrency")(props.item.totalRentSum))),_c('br')]:_vm._e(),_vm._v("\n\t\t\t\t\t\t\tRental check: "+_vm._s(props.item.rentalCheck_status || '-')),_c('br'),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.city)),_c('br'),_vm._v(_vm._s(props.item.phoneno)+" "),_c('br'),_vm._v(_vm._s(props.item.username)+"\n\n\t\t\t\t\t\t\t"),(props.item.active == '1')?_c('span',{staticClass:"other reservationStatus"},[_vm._v("Actief")]):_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[(props.item.active == '1')?_c('v-icon',{staticClass:"left",attrs:{"color":"green"}},[_vm._v("checked")]):_vm._e()],1)])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)],1)}
var UsersTable_staticRenderFns = []
var UsersTable_esExports = { render: UsersTable_render, staticRenderFns: UsersTable_staticRenderFns }
/* harmony default export */ var Users_UsersTable = (UsersTable_esExports);
// CONCATENATED MODULE: ./src/components/Users/UsersTable.vue
var UsersTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UsersTable___vue_template_functional__ = false
/* styles */
var UsersTable___vue_styles__ = null
/* scopeId */
var UsersTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UsersTable___vue_module_identifier__ = null
var UsersTable_Component = UsersTable_normalizeComponent(
  UsersTable,
  Users_UsersTable,
  UsersTable___vue_template_functional__,
  UsersTable___vue_styles__,
  UsersTable___vue_scopeId__,
  UsersTable___vue_module_identifier__
)

/* harmony default export */ var components_Users_UsersTable = (UsersTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Users/Users.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Users = ({
	name: 'Users',
	components: { UsersTable: components_Users_UsersTable, UserModal: components_Users_UserModal, HistoryModal: components_History_HistoryModal },
	data: function data() {
		return {
			user: {
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			historyEdit: {
				showModal: false
			},
			reservation: {},
			editReservation: {},
			units: [],
			filters: {}
		};
	},
	mounted: function mounted() {
		if (this.$route.params.userid) {
			this.showUser({ id: this.$route.params.userid });
		}
	},

	methods: {
		showUser: function showUser(user) {
			this.edit.showModal = true;
			user.edit = true;
			this.user = user;
		},
		newUser: function newUser() {
			this.user = {
				id: -1,
				edit: true,
				paid: '1',
				active: '1',
				canRent: '1',
				credit: 0
			};
			this.edit.showModal = true;
		},
		showHistory: function showHistory(reservation) {
			this.historyEdit.showModal = true;
			this.reservation = reservation;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe4f3ed8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Users.vue
var Users_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center mpa-0 pa-4",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('users-table',{ref:"usersTables",attrs:{"filters":_vm.filters},on:{"showUser":_vm.showUser}}),_vm._v(" "),_c('v-btn',{attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":"","color":"pink"},on:{"click":_vm.newUser}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('user-modal',{attrs:{"id":_vm.user.id,"edit":_vm.edit,"user":_vm.user,"showSelector":false},on:{"showHistory":_vm.showHistory,"userUpdated":function($event){return _vm.$refs.usersTables.getUsers()}}}),_vm._v(" "),_c('history-modal',{attrs:{"id":_vm.reservation.id,"edit":_vm.historyEdit,"selectedReservation":_vm.reservation}})],1)}
var Users_staticRenderFns = []
var Users_esExports = { render: Users_render, staticRenderFns: Users_staticRenderFns }
/* harmony default export */ var Users_Users = (Users_esExports);
// CONCATENATED MODULE: ./src/components/Users/Users.vue
function Users_injectStyle (ssrContext) {
  __webpack_require__("+k1v")
}
var Users_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Users___vue_template_functional__ = false
/* styles */
var Users___vue_styles__ = Users_injectStyle
/* scopeId */
var Users___vue_scopeId__ = "data-v-fe4f3ed8"
/* moduleIdentifier (server only) */
var Users___vue_module_identifier__ = null
var Users_Component = Users_normalizeComponent(
  Users,
  Users_Users,
  Users___vue_template_functional__,
  Users___vue_styles__,
  Users___vue_scopeId__,
  Users___vue_module_identifier__
)

/* harmony default export */ var components_Users_Users = (Users_Component.exports);

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/ReservationsTable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var ReservationsTable = ({
	name: 'ReservationsTable',
	components: {
		TableLoader: src_components_TableLoader,
		VuePullRefresh: vue_pull_refresh_min_default.a,
		StatusIndicator: vue_status_indicator_esm["a" /* StatusIndicator */],
		DeviceBattery: components_Units_DeviceBattery,
		UnitControl: components_Units_UnitControl
	},
	data: function data() {
		return {
			dialog: false,
			loading: false,
			utils: utils_namespaceObject,
			pagination: {
				sortBy: 'startDate',
				descending: false
			},
			selected: [],
			searchText: '',
			pullConfig: window.pullConfig,
			headers: [{
				text: '#',
				align: 'left',
				value: 'id'
			}, {
				text: 'Omschrijving',
				value: 'fullname',
				class: 'hidden-xs-only'
			}, {
				text: 'Auto',
				value: 'car',
				class: 'hidden-xs-only'
			}, {
				text: 'Naam',
				value: 'rentDescription',
				class: 'hidden-xs-only description'
			}, {
				text: 'Startdatum',
				value: 'startDate',
				class: 'hidden-xs-only'
			}, {
				text: 'Einddatum',
				value: 'endDate',
				class: 'hidden-xs-only'
			}, {
				text: 'Status',
				value: 'active',
				class: ''
			}],
			items: [],
			allItems: [],
			todayItems: [],
			fuse: fuse["fuse"],
			lastUpdated: '',
			filter: 'all',
			unitPositions: {}
		};
	},

	watch: {
		filter: function filter(newVal) {
			this.getReservations(true, false);
		},
		$route: function $route(to, from) {
			if (to.name === 'Reservations') {
				this.getReservations(true, true);
			}
		},
		searchText: function searchText(val) {
			this.searchData(val);
		}
	},
	created: function created() {
		var self = this;
		this.getReservations(true, false);
		window.emitter.$on('updateReservations', function (data) {
			if (self.$route.name === 'Reservations' || self.$route.name === 'Home') {
				self.getReservations(true, true).then(function (response) {
					if (data && data.id) {
						self.lastUpdated = data.id;
					}
				});
			}
			'';
		});

		window.emitter.$on('newEvents', function (data) {
			self.updateUnitPositions(data);
		});
	},
	beforeDestroy: function beforeDestroy() {
		window.emitter.$off('updateReservations');
		window.emitter.$off('newEvents');
	},

	methods: {
		searchData: function searchData(val) {
			var self = this;
			var searchText = val.toLowerCase();
			var searchableItems = this.filter === 'all' ? this.allItems : this.todayItems;
			var options = {
				shouldSort: true,
				findAllMatches: true,
				threshold: 0.1,
				location: 0,
				distance: 200,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: ['rentDescription', 'firstname', 'lastname', 'car', 'id', 'companyname']
			};
			if (val == '') {
				this.items = searchableItems;
			} else {
				this.$search(searchText, searchableItems, options).then(function (results) {
					self.items = results;
				});
			}
		},
		getReservations: function getReservations(showLoading, refresh) {
			var self = this;
			this.loading = showLoading;

			var promise = new promise_default.a(function (resolve, reject) {
				if (self.allItems.length && !refresh) {
					resolve();
				} else {
					utils_getData(basePath + 'api/reservations/').then(function (json) {
						self.allItems = json.data;
						resolve();

						// Run search query after refresh
						self.searchData(self.searchText);
					});
				}
			});

			promise.then(function () {
				if (self.filter === 'all') {
					self.items = self.allItems;
				} else {
					if (!self.todayItems.length) {
						self.todayItems = vue_underscore["a" /* _ */].filter(self.allItems, {
							isToday: '1'
						});
					}
					self.items = self.todayItems;
				}
				self.loading = false;
				self.$emit('dataLoaded');
			});

			return promise;
		},
		showReservation: function showReservation(reservation, e) {
			reservation.edit = true;
			//console.log(reservation)
			this.$emit('showReservation', {
				id: reservation.id
			});

			return false;
		},
		toggleAll: function toggleAll() {
			if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
		},
		changeSort: function changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		showUnit: function showUnit(unitId) {
			this.$emit('showUnit', {
				id: unitId
			});
		},
		showUser: function showUser(userId) {
			this.$emit('showUser', userId);
		},
		onRefresh: function onRefresh() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				self.getReservations(false, true).then(function () {
					setTimeout(function () {
						resolve();
					}, 100);
				});
			});
		},
		getTempCustomer: function getTempCustomer(reservation) {
			return reservation.tempCustomerName ? ' (' + reservation.tempCustomerName + ')' : '';
		},
		getTimeBetween: function getTimeBetween(startDate, timeScale) {
			var now = moment_default()(new Date());
			var duration = moment_default.a.duration(now.diff(startDate));
			if (timeScale === 'hours') {
				var hours = String(Math.abs(duration.asHours()).toFixed(2));
				if (hours) {
					var hoursData = hours.split('.');
					return hoursData[0] + 'u' + ' ' + String(parseInt(parseFloat(hoursData[1]) / 100 * 60)) + 'min';
				} else {
					return '';
				}
			} else {
				var days = Math.ceil(Math.abs(duration.asHours() / 24));
				return days <= 1 ? 'morgen' : days + ' dagen';
			}
		},
		getInfo: function getInfo(item) {
			var self = this;
			if (!item.info) {
				item.info = 'Info ophalen...';
			}
			setTimeout(function () {
				if (!item.pullInfo) return false;
				// Get cost and position
				utils_getData(basePath + 'api/reservations/reservationCost/' + item.id).then(function (response) {
					item.info = '&euro;' + response.data.cost.total + ' \t<br/> ' + response.data.mileage + ' Km';

					if (self.unitPositions[item.wialonUnitId]) {
						item.info += '<br/>Satellieten: ' + self.unitPositions[item.wialonUnitId].sc;
					}

					if (response.data.cost.status && response.data.cost.status.percentage) {
						'<br/>Batterij: ' + response.data.cost.status.percentage + '%';
					}
				});
			}, 500);
		},
		updateUnitPositions: function updateUnitPositions(updatedUnits) {
			var self = this;

			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					self.unitPositions[unit.i] = unit.d.pos;
				}
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ef11fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/ReservationsTable.vue
var ReservationsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"flex xl12 lg12 md12 mx-auto"},[_c('vue-pull-refresh',{attrs:{"on-refresh":_vm.onRefresh,"config":_vm.pullConfig}},[_c('v-card',{staticStyle:{"width":"100%"},attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-title',{staticClass:"px-1 pt-0"},[_c('v-flex',{staticClass:"hidden-sm-and-down"},[_c('h1',[_vm._v("Reserveringen")])]),_vm._v(" "),_c('v-tabs',{attrs:{"fixed-tabs":"","color":"transparent"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}},[_c('v-tab',{key:'all',attrs:{"href":'#all',"ripple":""}},[_vm._v("Alle")]),_vm._v(" "),_c('v-tab',{key:'today',attrs:{"href":'#today',"ripple":""}},[_vm._v("Vandaag")]),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"blue darken-2"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","color":"blue darken-2","label":"Zoeken","single-line":"","hide-details":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"select-all":"","pagination":_vm.pagination,"rows-per-page-items":[25, 50],"rows-per-page-text":'Resultaten per pagina',"loading":_vm.loading,"no-data-text":"...","item-key":"name"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticClass:"hidden-sm-and-down"},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
									'text-xs-left column sortable',
									_vm.pagination.descending ? 'desc' : 'asc',
									header.value === _vm.pagination.sortBy ? 'active' : ''
								],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(header.text)+"\n\t\t\t\t\t\t\t\t"),_c('v-icon',[_vm._v("arrow_upward")])],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected}},[_c('td',{staticClass:"hidden-sm-and-down text-xs-left",class:_vm.lastUpdated === props.item.id ? 'updated' : '',on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.reservationNumber)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only description",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.rentDescription
										? props.item.rentDescription
										: props.item.car)+"\n\t\t\t\t\t\t\t\t"),(props.item.amountPaid)?_c('small',{staticClass:"d-block"},[_vm._v("Betaald: € "+_vm._s(props.item.amountPaid))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",staticStyle:{"position":"relative"}},[_c('span',{staticClass:"d-inline-block",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v(_vm._s(props.item.unitDescription)+"\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v("Kenteken: "+_vm._s(props.item.license)+" Pincode:\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(props.item.fuelCardPin))])]),_vm._v(" "),(props.item.isControllable === '1')?_c('unit-control',{staticClass:"unit-control",class:props.item.active == '1' ? 'active' : 'inActive',attrs:{"unitId":props.item.unitId}}):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only clickable",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showUser(props.item.user_id)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.firstname)+" "+_vm._s(props.item.lastname)+"\n\t\t\t\t\t\t\t\t"),(props.item.companyname)?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t- "+_vm._s(props.item.companyname))]):_vm._e(),_vm._v(_vm._s(_vm.getTempCustomer(props.item))+"\n\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(props.item.phoneno))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.startDate, true))+"\n\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.utils.getDayDescription(props.item.startDate, true)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.endDate, true))+"\n\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.utils.getDayDescription(props.item.endDate, true)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",staticStyle:{"position":"relative"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)},"mouseenter":function($event){props.item.pullInfo = true;
									_vm.getInfo(props.item);},"mouseleave":function($event){props.item.pullInfo = false}}},[_c('v-tooltip',{attrs:{"bottom":""}},[(props.item.active == '1')?_c('span',{staticClass:"active reservationStatus",attrs:{"slot":"activator"},slot:"activator"},[_vm._v("ACTIEF\n\t\t\t\t\t\t\t\t\t\t"),(props.item.active == '1')?_c('status-indicator',{attrs:{"positive":!_vm.unitPositions[props.item.wialonUnitId] ||
													(_vm.unitPositions[props.item.wialonUnitId] &&
														_vm.unitPositions[props.item.wialonUnitId].sc > 0),"intermediary":_vm.unitPositions[props.item.wialonUnitId] &&
													_vm.unitPositions[props.item.wialonUnitId].sc <= 3,"negative":_vm.unitPositions[props.item.wialonUnitId] &&
													_vm.unitPositions[props.item.wialonUnitId].sc === 0,"pulse":""}}):_vm._e(),_vm._v(" "),_c('b',{class:("d-block unit_" + (props.item.wialonUnitId))})],1):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(props.item.info)}}),_vm._v(" "),(
											props.item.active != '1' &&
												_vm.utils.getDayDescription(
													props.item.startDate,
													true
												) === 'Vandaag'
										)?_c('span',{staticClass:"today reservationStatus",attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getTimeBetween(props.item.startDate, 'hours')))]):_vm._e(),_vm._v(" "),(
											props.item.active != '1' &&
												_vm.utils.getDayDescription(
													props.item.startDate,
													true
												) !== 'Vandaag'
										)?_c('span',{staticClass:"other reservationStatus",attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getTimeBetween(props.item.startDate, 'days')))]):_vm._e()])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-sm-and-up itemRow",staticStyle:{"position":"relative"}},[_c('h3',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.item.firstname)+" "+_vm._s(props.item.lastname)+"\n\t\t\t\t\t\t\t\t\t"),(props.item.companyname)?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t- "+_vm._s(props.item.companyname))]):_vm._e(),_vm._v(_vm._s(_vm.getTempCustomer(props.item))+"\n\t\t\t\t\t\t\t\t\t"),(_vm.lastUpdated === props.item.id)?_c('small',{staticStyle:{"color":"#1565c0"}},[_vm._v("(OPGESLAGEN)")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"itemContainer",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showReservation(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t#"+_vm._s(props.item.reservationNumber)+"\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.item.rentDescription)+"\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.item.car)+"\n\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.startDate, true))+" ("+_vm._s(_vm.utils.getDayDescription(props.item.startDate, true))+")\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.endDate, true))+" ("+_vm._s(_vm.utils.getDayDescription(props.item.endDate, true))+")\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\tPincode: "+_vm._s(props.item.fuelCardPin)+"\n\t\t\t\t\t\t\t\t\t"),(props.item.active == '1')?_c('span',{staticClass:"active reservationStatus"},[(props.item.active == '1')?_c('status-indicator',{staticClass:"right",staticStyle:{"transform":"translate(35%,0)"},attrs:{"positive":!_vm.unitPositions[props.item.wialonUnitId] ||
													(_vm.unitPositions[props.item.wialonUnitId] &&
														_vm.unitPositions[props.item.wialonUnitId].sc > 0),"intermediary":_vm.unitPositions[props.item.wialonUnitId] &&
													_vm.unitPositions[props.item.wialonUnitId].sc <= 3,"negative":_vm.unitPositions[props.item.wialonUnitId] &&
													_vm.unitPositions[props.item.wialonUnitId].sc === 0,"pulse":""}}):_vm._e(),_vm._v("ACTIEF\n\t\t\t\t\t\t\t\t\t\t"),_c('b',{class:("d-block unit_" + (props.item.wialonUnitId))})],1):_vm._e(),_vm._v(" "),(
											props.item.active != '1' &&
												_vm.utils.getDayDescription(
													props.item.startDate,
													true
												) === 'Vandaag'
										)?_c('span',{staticClass:"today reservationStatus"},[_vm._v(_vm._s(_vm.getTimeBetween(props.item.startDate, 'hours')))]):_vm._e(),_vm._v(" "),(
											props.item.active != '1' &&
												_vm.utils.getDayDescription(
													props.item.startDate,
													true
												) !== 'Vandaag'
										)?_c('span',{staticClass:"other reservationStatus"},[_vm._v(_vm._s(_vm.getTimeBetween(props.item.startDate, 'days')))]):_vm._e()]),_vm._v(" "),(props.item.isControllable === '1')?_c('unit-control',{staticClass:"unit-control",class:props.item.active == '1' ? 'active' : 'inActive',attrs:{"unitId":props.item.unitId}}):_vm._e()],1)])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)],1)])}
var ReservationsTable_staticRenderFns = []
var ReservationsTable_esExports = { render: ReservationsTable_render, staticRenderFns: ReservationsTable_staticRenderFns }
/* harmony default export */ var Reservations_ReservationsTable = (ReservationsTable_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/ReservationsTable.vue
function ReservationsTable_injectStyle (ssrContext) {
  __webpack_require__("mF/h")
}
var ReservationsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReservationsTable___vue_template_functional__ = false
/* styles */
var ReservationsTable___vue_styles__ = ReservationsTable_injectStyle
/* scopeId */
var ReservationsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReservationsTable___vue_module_identifier__ = null
var ReservationsTable_Component = ReservationsTable_normalizeComponent(
  ReservationsTable,
  Reservations_ReservationsTable,
  ReservationsTable___vue_template_functional__,
  ReservationsTable___vue_styles__,
  ReservationsTable___vue_scopeId__,
  ReservationsTable___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_ReservationsTable = (ReservationsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/Reservations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Reservations = ({
	name: 'Reservations',
	components: {
		UserModal: components_Users_UserModal,
		NewReservationModal: components_Reservations_NewReservationModal,
		ReservationsTable: components_Reservations_ReservationsTable,
		UnitModal: components_Units_UnitModal
	},
	data: function data() {
		return {
			user: {
				edit: false
			},
			reservation: {},
			unit: {},
			editReservation: {
				startTime: '00:00',
				endTime: '00:00',
				showModal: false
			},
			newReservationData: {
				showModal: false,
				startDate: '',
				endDate: '',
				startTime: '00:00',
				endTime: '00:00',
				discount: 0,
				costData: {
					prices: [],
					additionalItems: []
				}
			},
			src: '',
			editUser: {
				showModal: false
			},
			edit: {
				showModal: false
			},
			active: null,
			editUnit: {
				showModal: false,
				id: 0
			},
			units: [],
			userId: -1,
			showReservationModal: false,
			showUserSelector: true
		};
	},
	mounted: function mounted() {
		var self = this;
		window.emitter.$off('newUser');
		window.emitter.$on('newUser', function () {
			self.newUser();
		});

		if (this.$route.params.id) {
			this.showReservation({ id: this.$route.params.id });
		}
	},

	watch: {
		$route: function $route(to, from) {
			this.showReservation({ id: to.params.id });
		}
	},
	methods: {
		dataLoaded: function dataLoaded() {},
		getUnits: function getUnits() {
			var self = this;
			if (!self.units.length) {
				utils_getData(basePath + 'api/rentunits/getSimpleUnitList').then(function (response) {
					self.units = response.data;
				});
			}
		},
		showUser: function showUser(userId) {
			this.userId = userId;
			this.showUserSelector = false;
			this.editUser.showModal = true;
		},
		showReservation: function showReservation(reservation) {
			this.getUnits();
			this.$refs.reservationModal.showReservation(reservation.id);
			return false;
		},
		newReservation: function newReservation() {
			this.getUnits();
			this.$refs.newReservationModal.initReservation();
		},
		newUser: function newUser() {
			this.$refs.userModal.newUser();
		},
		showUnit: function showUnit(unit) {
			this.editUnit.showModal = true;
			this.editUnit.unitId = unit.id;
			this.editUnit.id = unit.id;
			unit.edit = true;
			this.newUnit = false;
		},
		copyReservation: function copyReservation(reservation) {
			var diff = moment_default()(reservation.endDate).diff(moment_default()(reservation.startDate), 'months');
			var newEndDate = moment_default()(reservation.endDate).add(diff, 'months').format('YYYY-MM-DD');
			this.$refs.newReservationModal.openModalWithData(reservation.endDate, reservation.endTime, newEndDate, reservation.endTime, reservation.unitId, reservation.user_id, reservation);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d32620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/Reservations.vue
var Reservations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mpa-0 pa-4",attrs:{"id":"reservationsContainer","fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('reservations-table',{ref:"reservationsTable",attrs:{"filter":_vm.active},on:{"showReservation":_vm.showReservation,"showUnit":_vm.showUnit,"showUser":_vm.showUser,"dataLoaded":_vm.dataLoaded}}),_vm._v(" "),_c('v-btn',{attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":"","color":"pink"},on:{"click":function($event){return _vm.newReservation()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('user-modal',{ref:"userModal",attrs:{"id":_vm.userId,"edit":_vm.editUser,"user":_vm.editUser,"showSelector":_vm.showUserSelector},on:{"userUpdated":function($event){return _vm.$refs.reservationsTable.getReservations(true, true)}}}),_vm._v(" "),_c('reservations-modal',{ref:"reservationModal",attrs:{"id":_vm.reservation.id,"edit":_vm.editReservation,"reservation":_vm.reservation,"units":_vm.units},on:{"newUser":function($event){return _vm.newUser()},"copyReservation":function($event){return _vm.copyReservation($event)}}}),_vm._v(" "),_c('new-reservation-modal',{ref:"newReservationModal",attrs:{"id":_vm.reservation.id,"edit":_vm.newReservationData,"units":_vm.units},on:{"update":function($event){return _vm.showReservation($event)},"newUser":function($event){return _vm.newUser()}}}),_vm._v(" "),_c('unit-modal',{attrs:{"id":_vm.editUnit.id,"edit":_vm.editUnit,"selectedUnit":_vm.editUnit,"new":false}})],1)}
var Reservations_staticRenderFns = []
var Reservations_esExports = { render: Reservations_render, staticRenderFns: Reservations_staticRenderFns }
/* harmony default export */ var Reservations_Reservations = (Reservations_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/Reservations.vue
function Reservations_injectStyle (ssrContext) {
  __webpack_require__("CIeh")
}
var Reservations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reservations___vue_template_functional__ = false
/* styles */
var Reservations___vue_styles__ = Reservations_injectStyle
/* scopeId */
var Reservations___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reservations___vue_module_identifier__ = null
var Reservations_Component = Reservations_normalizeComponent(
  Reservations,
  Reservations_Reservations,
  Reservations___vue_template_functional__,
  Reservations___vue_styles__,
  Reservations___vue_scopeId__,
  Reservations___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_Reservations = (Reservations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/History/HistoryFilter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HistoryFilter = ({
  name: "HistoryFilter",
  data: function data() {
    return {
      open: true,
      menu: false,
      filterDate: "",
      startDate: "",
      endDate: "",
      filterDateFormatted: "",
      startDateFormatted: "",
      endDateFormatted: "",
      menu1: false,
      menu2: false,
      menu3: false
    };
  },
  watch: {
    startDate: function startDate(newVal) {
      if (newVal) {
        this.filterDate = "";
        this.startDateFormatted = moment_default()(newVal).format("YYYY-MM-DD 00:00:00");
      } else {
        this.startDateFormatted = "";
      }
    },
    endDate: function endDate(newVal) {
      if (newVal) {
        this.filterDate = "";
        this.endDateFormatted = moment_default()(newVal).format("YYYY-MM-DD 23:59:59");
      } else {
        this.endDateFormatted = "";
      }
    },
    filterDate: function filterDate(newVal) {
      if (newVal) {
        this.startDate = "";
        this.endDate = "";
        this.filterDateFormatted = moment_default()(newVal).format("YYYY-MM-DD 23:59:59");
      } else {
        this.filterDateFormatted = "";
      }
    }
  },
  methods: {
    setFilter: function setFilter() {
      this.$emit("setFilter", {
        open: this.open,
        filterDate: this.filterDateFormatted,
        startDate: this.startDateFormatted,
        endDate: this.endDateFormatted
      });
      this.menu = false;
    },
    setAllFilter: function setAllFilter() {
      this.open = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158077b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/History/HistoryFilter.vue
var HistoryFilter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-left"},[_c('v-menu',{attrs:{"offset-x":"","close-on-content-click":false,"nudge-width":200},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","color":"indigo","flat":""},slot:"activator"},[_c('v-icon',[_vm._v("filter_list")])],1),_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-menu',{ref:"menu3",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menu3),callback:function ($$v) {_vm.menu3=$$v},expression:"menu3"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Exacte datum","clearable":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.filterDate),callback:function ($$v) {_vm.filterDate=$$v},expression:"filterDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","locale":"nl"},on:{"change":function($event){_vm.$refs.menu3.save(_vm.filterDate); _vm.setAllFilter()}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu3 = false}}},[_vm._v("Annuleren")])],1)]}}]),model:{value:(_vm.filterDate),callback:function ($$v) {_vm.filterDate=$$v},expression:"filterDate"}})],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-menu',{ref:"menu1",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Startdatum >","clearable":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","locale":"nl"},on:{"change":function($event){return _vm.$refs.menu1.save(_vm.startDate)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("Annuleren")])],1)]}}]),model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}},[_vm._v(">\n                ")])],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-menu',{ref:"menu2",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Einddatum <","clearable":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"change":function($event){return _vm.$refs.menu2.save(_vm.endDate)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("Annuleren")])],1)]}}]),model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}},[_vm._v(">\n                ")])],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{attrs:{"color":"green darken-3"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Toon alleen openstaande")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.setFilter()}}},[_vm._v("Filter")])],1)],1)],1)],1)}
var HistoryFilter_staticRenderFns = []
var HistoryFilter_esExports = { render: HistoryFilter_render, staticRenderFns: HistoryFilter_staticRenderFns }
/* harmony default export */ var History_HistoryFilter = (HistoryFilter_esExports);
// CONCATENATED MODULE: ./src/components/History/HistoryFilter.vue
var HistoryFilter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HistoryFilter___vue_template_functional__ = false
/* styles */
var HistoryFilter___vue_styles__ = null
/* scopeId */
var HistoryFilter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HistoryFilter___vue_module_identifier__ = null
var HistoryFilter_Component = HistoryFilter_normalizeComponent(
  HistoryFilter,
  History_HistoryFilter,
  HistoryFilter___vue_template_functional__,
  HistoryFilter___vue_styles__,
  HistoryFilter___vue_scopeId__,
  HistoryFilter___vue_module_identifier__
)

/* harmony default export */ var components_History_HistoryFilter = (HistoryFilter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/History/HistoryTable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var HistoryTable = ({
	name: 'HistoryTable',
	components: { HistoryFilter: components_History_HistoryFilter, VuePullRefresh: vue_pull_refresh_min_default.a, ViewInvoice: components_Reservations_ViewInvoice },
	data: function data() {
		return {
			dialog: false,
			pagination: {
				sortBy: 'endDate',
				descending: true
			},
			selected: [],
			search: '',
			pullConfig: window.pullConfig,
			utils: utils_namespaceObject,
			headers: [{
				text: '#',
				align: 'left',
				value: 'rentId'
			}, { text: 'Gebruiker', value: 'firstname' }, { text: 'Omschrijving', value: 'unitDescription' }, { text: 'Totaalbedrag', value: 'totalCosts' }, { text: 'Startdatum', value: 'startDate' }, { text: 'Einddatum', value: 'endDate' }, { text: 'Dagen open', value: 'daysOpen' }, { text: 'Betaling', value: 'paid' }],
			items: [],
			allItems: [],
			loading: true,
			filters: {
				open: true
			},
			paidOptions: getPaidOptions(),
			totalOpen: 0
		};
	},
	beforeDestroy: function beforeDestroy() {
		window.emitter.$off('updateHistory');
	},

	watch: {
		search: function search(val) {
			this.searchRequest(val);
		}
	},
	created: function created() {
		var self = this;
		this.getHistory(false);
		window.emitter.$on('updateHistory', function () {
			self.getHistory(false);
		});
	},
	methods: {
		getHistory: function getHistory(download) {
			var self = this;
			self.loading = true;
			return setData(basePath + 'api/reservations/history/' + (download ? '1' : '0'), this.filters).then(function (json) {
				self.loading = false;
				if (!download) {
					self.allItems = json.data;
					self.items = self.allItems;
					self.totalOpen = self.allItems.reduce(function (s, f) {
						return s + (f.paid === '0' ? parseFloat(f.totalCosts) - parseFloat(f.amountPaid) : 0);
					}, 0).toFixed(2);
				} else {
					window.location.href = basePath + 'api/downloader/downloadInvoicesOpen/' + json.data;
				}
			});
		},
		showHistory: function showHistory(reservation, showMail) {
			//  reservation.edit = true;
			reservation.showMail = showMail;
			this.$emit('showHistory', reservation);
		},
		toggleAll: function toggleAll() {
			if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
		},
		getPaidDescription: function getPaidDescription(id) {
			if (id) {
				var paidOptions = getPaidDescriptions();
				var selected = vue_underscore["a" /* _ */].findWhere(paidOptions, { value: id });
				return selected.text;
			} else {
				return '';
			}
		},
		changeSort: function changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		setFilter: function setFilter(data) {
			var self = this;
			this.pagination.page = 1;
			this.filters = data;
			this.getHistory(false).then(function () {
				self.searchRequest(self.search);
			});
		},
		onRefresh: function onRefresh() {
			var self = this;
			return new promise_default.a(function (resolve, reject) {
				self.getHistory(false).then(function () {
					setTimeout(function () {
						resolve();
					}, 500);
				});
			});
		},
		updatePaid: function updatePaid(item, value) {
			var paymentData = {
				rentId: item.rentId,
				paid: value
			};
			item.paid = value;
			return setData(basePath + 'api/reservations/updateHistoryPaid/', paymentData).then(function (json) {
				item.transactionId = "1";
			});
		},
		getTempCustomer: function getTempCustomer(reservation) {
			return reservation.tempCustomerName ? ' (' + reservation.tempCustomerName + ')' : '';
		},
		searchRequest: function searchRequest(val) {
			var self = this;
			var searchText = val.toLowerCase();
			var searchableItems = this.allItems;
			var options = {
				shouldSort: true,
				findAllMatches: true,
				threshold: 0.1,
				location: 0,
				distance: 200,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: ['reservationNumber', 'rentId', 'firstname', 'lastname', 'car', 'remark', 'username', 'unitDescription', 'tempCustomerName', 'companyname', 'name']
			};
			if (val == '') {
				this.items = searchableItems;
			} else {
				this.$search(searchText, searchableItems, options).then(function (results) {
					self.items = results;
				});
			}
		},
		downloadInvoice: function downloadInvoice(reservation) {
			var self = this;
			setData(basePath + 'api/reservations/getInvoice/' + reservation.rentId, {
				invoiceDate: ''
			}).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadInvoice/' + json.data + '/' + reservation.reservationNumber;
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e54c9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/History/HistoryTable.vue
var HistoryTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex xl12 lg12 md12 mx-auto"},[_c('vue-pull-refresh',{attrs:{"on-refresh":_vm.onRefresh,"config":_vm.pullConfig}},[_c('v-card',{staticStyle:{"width":"100%"},attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-title',{staticClass:"px-1 pt-0"},[_c('h1',{staticClass:"d-block text-xs-left"},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v("Historie"),_c('br')]),_vm._v(" "),_c('small',[_vm._v("Totaal openstaand: € "+_vm._s(_vm._f("toCurrency")(_vm.totalOpen)))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"d-inline-flex"},[_c('v-text-field',{staticStyle:{"min-width":"260px"},attrs:{"prepend-inner-icon":"search","label":"Zoeken","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('history-filter',{on:{"setFilter":_vm.setFilter}})],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"rows-per-page-items":[25, 50],"no-data-text":"...","item-key":"name","loading":_vm.loading},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticClass:"hidden-xs-only"},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
								'text-xs-left column sortable',
								_vm.pagination.descending ? 'desc' : 'asc',
								header.value === _vm.pagination.sortBy ? 'active' : ''
							],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(header.text)+"\n\t\t\t\t\t\t\t"),_c('v-icon',[_vm._v("arrow_upward")])],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected}},[_c('td',{staticClass:"hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.reservationNumber)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.firstname)+" "+_vm._s(props.item.lastname)+"\n\t\t\t\t\t\t\t"),(props.item.companyname)?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t- "+_vm._s(props.item.companyname))]):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getTempCustomer(props.item))+"\n\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(props.item.phoneno))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.unitDescription)+"\n\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(props.item.remark))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t€ "+_vm._s(_vm._f("toCurrency")(props.item.totalCosts))+"\n\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),(props.item.paid === '0')?_c('small',[_vm._v("€\n\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("toCurrency")((props.item.totalCosts - props.item.amountPaid)))+"\n\t\t\t\t\t\t\t\topenstaand")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.startDate, true))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showHistory(props.item, false)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedDate(props.item.endDate, true))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-sm-and-up itemRow",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showHistory(props.item, false)}}},[_c('h3',[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.firstname)+" "+_vm._s(props.item.lastname)),(props.item.companyname)?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t- "+_vm._s(props.item.companyname))]):_vm._e()]),_vm._v("\n\t\t\t\t\t\t\t#"+_vm._s(props.item.reservationNumber)+" "+_vm._s(props.item.car)),_c('br'),_vm._v("Totaalbedrag: €\n\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedAmount(props.item.totalCosts))+"\n\t\t\t\t\t\t\t"),(props.item.paid === '0')?_c('small',[_vm._v("€\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.utils.getFormattedAmount(
										props.item.totalCosts - props.item.amountPaid
									))+"\n\t\t\t\t\t\t\t\topenstaand")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.utils.getFormattedDate(props.item.startDate, true))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.utils.getDayDescription(props.item.startDate))+") "),_c('br'),_vm._v(_vm._s(_vm.utils.getFormattedDate(props.item.endDate, true))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.utils.getDayDescription(props.item.endDate))+")\n\t\t\t\t\t\t\t"),(props.item.amountPaid !== props.item.totalCosts || props.item.paid === '-1')?_c('span',{staticClass:"other reservationStatus"},[_vm._v("DAGEN OPEN: "+_vm._s(props.item.daysOpen))]):_vm._e(),_vm._v(" "),(props.item.amountPaid === props.item.totalCosts && props.item.paid !== '-1')?_c('v-icon',{staticClass:"right",staticStyle:{"transform":"translate(50%,0)"},attrs:{"slot":"activator","color":"green"},slot:"activator"},[_vm._v("checked")]):_vm._e(),_vm._v(" "),(props.item.paid == '-1')?_c('v-icon',{staticClass:"right",staticStyle:{"transform":"translate(50%,0)"},attrs:{"slot":"activator","color":"red"},slot:"activator"},[_vm._v("checked")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_c('span',{staticClass:"other reservationStatus"},[_vm._v(_vm._s(props.item.amountPaid !== props.item.totalCosts
									? props.item.daysOpen
									: ''))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[(props.item.amountPaid === props.item.totalCosts || props.item.paid === '-1')?_c('v-tooltip',{attrs:{"top":""}},[(props.item.paid !== '0' && props.item.paid !== '-1')?_c('v-icon',{staticStyle:{"transform":"translate(20%,0)"},attrs:{"slot":"activator","color":"green"},slot:"activator"},[_vm._v("checked")]):_vm._e(),_vm._v(" "),(props.item.paid == '-1')?_c('v-icon',{staticStyle:{"transform":"translate(20%,0)"},attrs:{"slot":"activator","color":"red"},slot:"activator"},[_vm._v("checked")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getPaidDescription(props.item.paid)))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"grey"},on:{"click":function($event){return _vm.showHistory(props.item, true)}}},[_c('v-icon',[_vm._v("mail")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"grey"},on:{"click":function($event){return _vm.downloadInvoice(props.item)}}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1),_vm._v(" "),(props.item.paid === '0' || (props.item.paid == '-1'))?_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("Wijzig")]),_vm._v(" "),_c('v-list',_vm._l((_vm.paidOptions),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.updatePaid(props.item, item.value)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)}),1)],1):_vm._e()],1)])]}}])},[_vm._v(" "),_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.getHistory(true)}}},[_vm._v("Download")])],1)],1),_vm._v(" "),_c('view-invoice',{ref:"viewInvoice",attrs:{"customDate":false}})],1)}
var HistoryTable_staticRenderFns = []
var HistoryTable_esExports = { render: HistoryTable_render, staticRenderFns: HistoryTable_staticRenderFns }
/* harmony default export */ var History_HistoryTable = (HistoryTable_esExports);
// CONCATENATED MODULE: ./src/components/History/HistoryTable.vue
var HistoryTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HistoryTable___vue_template_functional__ = false
/* styles */
var HistoryTable___vue_styles__ = null
/* scopeId */
var HistoryTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HistoryTable___vue_module_identifier__ = null
var HistoryTable_Component = HistoryTable_normalizeComponent(
  HistoryTable,
  History_HistoryTable,
  HistoryTable___vue_template_functional__,
  HistoryTable___vue_styles__,
  HistoryTable___vue_scopeId__,
  HistoryTable___vue_module_identifier__
)

/* harmony default export */ var components_History_HistoryTable = (HistoryTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/History/History.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var History = ({
	name: 'History',
	components: {
		HistoryTable: components_History_HistoryTable,
		HistoryModal: components_History_HistoryModal,
		HistoryFilter: components_History_HistoryFilter,
		NewReservationModal: components_Reservations_NewReservationModal
	},
	data: function data() {
		return {
			reservation: {
				costData: {
					additionalItems: []
				},
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			newReservationData: {},
			units: []
		};
	},
	created: function created() {
		window.emitter.$on('updateHistory', function () {});
	},
	mounted: function mounted() {
		if (this.$route.params.id) {
			this.$refs.historyModal.getHistoryData(this.$route.params.id, false);
		}
	},

	methods: {
		showHistory: function showHistory(reservation) {
			// Get units for selection in history modal
			this.getUnits();

			this.$refs.historyModal.getHistoryData(reservation.rentId, reservation.showMail);
		},
		getUnits: function getUnits() {
			if (!this.units.length) {
				var self = this;
				utils_getData(basePath + 'api/rentunits/getSimpleUnitList').then(function (response) {
					self.units = response.data;
				});
			}
		},
		copyReservation: function copyReservation(reservation) {
			var diff = moment_default()(reservation.endDate).diff(moment_default()(reservation.startDate), 'months');
			var newEndDate = moment_default()(reservation.endDate).add(diff, 'months').format('YYYY-MM-DD');

			this.$refs.newReservationModal.openModalWithData(reservation.endDate, reservation.endTime, newEndDate, reservation.endTime, reservation.unitId, reservation.user_id, reservation);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f74fa7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/History/History.vue
var History_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center pa-4",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('history-table',{on:{"showHistory":_vm.showHistory}})],1),_vm._v(" "),_c('history-modal',{ref:"historyModal",attrs:{"id":_vm.reservation.rentId,"edit":_vm.edit,"selectedReservation":_vm.reservation,"units":_vm.units},on:{"copyReservation":function($event){return _vm.copyReservation($event)}}}),_vm._v(" "),_c('new-reservation-modal',{ref:"newReservationModal",attrs:{"id":_vm.reservation.rentId,"edit":_vm.newReservationData,"units":_vm.units}})],1)}
var History_staticRenderFns = []
var History_esExports = { render: History_render, staticRenderFns: History_staticRenderFns }
/* harmony default export */ var History_History = (History_esExports);
// CONCATENATED MODULE: ./src/components/History/History.vue
var History_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var History___vue_template_functional__ = false
/* styles */
var History___vue_styles__ = null
/* scopeId */
var History___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var History___vue_module_identifier__ = null
var History_Component = History_normalizeComponent(
  History,
  History_History,
  History___vue_template_functional__,
  History___vue_styles__,
  History___vue_scopeId__,
  History___vue_module_identifier__
)

/* harmony default export */ var components_History_History = (History_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/UnitsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UnitsTable = ({
	name: 'UnitsTable',
	data: function data() {
		return {
			dialog: false,
			showTable: false,
			utils: utils_namespaceObject,
			pagination: {
				sortBy: 'name'
			},
			selected: [],
			search: '',
			cacheItems: {},
			items: [],
			tabs: ['getUnits', 'getWialonUnits'],
			text: ['In gebruik', 'Beschikbaar'],
			dataType: 'getUnits',
			failedImages: {},
			headers: {
				getUnits: [{ text: '#', align: 'left', value: 'id' }, { text: '', value: 'image' }, { text: 'Naam', value: 'name' }, { text: 'Kenteken', value: 'license' }, { text: 'Kleur', value: 'color' }, { text: 'Brandstof', value: 'fuel' }, { text: 'Pricecat', value: 'priceCat' }, { text: 'Totaal', value: 'totalRentSum' }, { text: 'Actief', value: 'active' }],
				getWialonUnits: [{ text: 'DeviceId', value: 'wialonUnitId' }, { text: 'Omschrijving', value: 'Description' }]
			}
		};
	},

	props: ['dataTimeStamp'],
	created: function created() {
		this.getData();
	},
	watch: {
		dataType: function dataType() {
			this.getData();
		},
		dataTimeStamp: function dataTimeStamp() {
			this.getData();
		}
	},
	methods: {
		getData: function getData() {
			var self = this;
			this.showTable = false;
			var extraParameters = self.dataType === 'getUnits' ? '0' : '';
			utils_getData(basePath + 'api/rentunits/' + self.dataType + '/' + extraParameters).then(function (json) {
				self.showTable = true;
				switch (self.dataType) {
					case 'getUnits':
						self.items = json.data;
						break;

					case 'getWialonUnits':
						var usedUnits = vue_underscore["a" /* _ */].pluck(json.usedUnits, 'wialonUnitId');
						self.items = vue_underscore["a" /* _ */].reject(json.wialonUnits, function (unit) {
							return usedUnits.indexOf(String(unit.i)) > -1;
						});
						break;
				}
			});
		},
		showUnit: function showUnit(unit) {
			var selectedUnit = {};
			if (unit.i) {
				selectedUnit = {
					name: '',
					wialonUnitId: String(unit.d.id),
					sensors: unit.d.sens,
					license: '',
					new: true
				};
			} else {
				selectedUnit = unit;
			}
			selectedUnit.edit = true;
			this.$emit('showUnit', selectedUnit);
		},
		toggleAll: function toggleAll() {
			if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
		},
		changeSort: function changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		setPlaceholder: function setPlaceholder(unitId) {
			this.$set(this.failedImages, unitId, true);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aaa0a33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/UnitsTable.vue
var UnitsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"flex xl12 lg12 md12 mx-auto"},[_c('v-card',{staticStyle:{"width":"100%"},attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-title',{staticClass:"px-1 pt-0"},[_c('v-flex',{attrs:{"x12":""}},[_c('h1',{staticClass:"hidden-sm-and-down"},[_vm._v("Units")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tabs',{attrs:{"fixed-tabs":"","color":"transparent"},model:{value:(_vm.dataType),callback:function ($$v) {_vm.dataType=$$v},expression:"dataType"}},[_vm._l((_vm.tabs),function(tab,index){return _c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v(_vm._s(_vm.text[index]))])}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"blue"}})],2),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","label":"Zoeken","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers[_vm.dataType],"items":_vm.items,"search":_vm.search,"pagination":_vm.pagination,"rows-per-page-items":[25, 50],"loading":!_vm.showTable,"no-data-text":"","item-key":"id"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticClass:"hidden-sm-and-down"},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
								'column sortable text-xs-left',
								_vm.pagination.descending ? 'desc' : 'asc',
								header.value === _vm.pagination.sortBy ? 'active' : ''
							],attrs:{"ß":""},on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(header.text)+"\n\t\t\t\t\t\t")],1)}),0)]}},{key:"items",fn:function(props){return [(_vm.dataType == 'getUnits')?_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){return _vm.showUnit(props.item)}}},[_c('td',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(props.item.unitId))]),_vm._v(" "),_c('td',{staticClass:"hidden-xs-only"},[(!_vm.failedImages[props.item.unitId])?_c('img',{staticStyle:{"max-width":"48px"},attrs:{"src":_vm.utils.getUnitImage(props.item.unitId)},on:{"error":function($event){return _vm.setPlaceholder(props.item.unitId)}}}):_c('v-icon',{staticStyle:{"font-size":"48px"}},[_vm._v("directions_car")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only",on:{"click":function($event){return _vm.showUnit(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.license)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.color)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v(_vm._s(props.item.fuel))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.priceCat)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right hidden-xs-only"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.totalRentSum)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right hidden-xs-only"},[(props.item.active == '1')?_c('v-icon',{staticClass:"right",staticStyle:{"transform":"translate(50%,0)"},attrs:{"color":"green"}},[_vm._v("checked")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-sm-and-up itemRow"},[_c('b',[_vm._v(_vm._s(props.item.name)+" "+_vm._s(props.item.unitId)+"\n\t\t\t\t\t\t\t\t"+_vm._s(props.item.license))]),_c('br'),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.color)+" "+_vm._s(props.item.fuel)+" "),_c('br'),_vm._v("Prijs\n\t\t\t\t\t\t\tcategorie: "+_vm._s(props.item.priceCat)+" "),_c('br'),_vm._v(_vm._s(props.item.totalRentSum)+"\n\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\tPincode: "+_vm._s(props.item.fuelCardPin)+"\n\t\t\t\t\t\t\t"),_vm._v(" "),(props.item.active == '1')?_c('v-icon',{staticClass:"right",staticStyle:{"transform":"translate(50%,0)"},attrs:{"color":"green"}},[_vm._v("checked")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.dataType == 'getWialonUnits' && _vm.showTable)?_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){return _vm.showUnit(props.item)}}},[_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.showUnit(props.item)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.i)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.d.nm))])]):_vm._e()]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)])}
var UnitsTable_staticRenderFns = []
var UnitsTable_esExports = { render: UnitsTable_render, staticRenderFns: UnitsTable_staticRenderFns }
/* harmony default export */ var Units_UnitsTable = (UnitsTable_esExports);
// CONCATENATED MODULE: ./src/components/Units/UnitsTable.vue
var UnitsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnitsTable___vue_template_functional__ = false
/* styles */
var UnitsTable___vue_styles__ = null
/* scopeId */
var UnitsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnitsTable___vue_module_identifier__ = null
var UnitsTable_Component = UnitsTable_normalizeComponent(
  UnitsTable,
  Units_UnitsTable,
  UnitsTable___vue_template_functional__,
  UnitsTable___vue_styles__,
  UnitsTable___vue_scopeId__,
  UnitsTable___vue_module_identifier__
)

/* harmony default export */ var components_Units_UnitsTable = (UnitsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Units/Units.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Units = ({
	name: 'Units',
	components: { UnitsTable: components_Units_UnitsTable, UnitModal: components_Units_UnitModal },
	data: function data() {
		return {
			unit: {
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			tabs: ['Used', 'Unused'],
			active: 'Used',
			text: ['In gebruik', 'Beschikbaar'],
			dataType: 'getUnits',
			dataTimeStamp: 0,
			availableDataTypes: {
				Used: 'getUnits',
				Unused: 'getWialonUnits'
			}
		};
	},
	created: function created() {},

	watch: {
		active: function active(val) {
			this.dataType = this.availableDataTypes[val];
		}
	},
	methods: {
		showUnit: function showUnit(unit) {
			var editUnit = assign_default()({}, unit);
			this.$refs.unitModal.image = '';
			this.$refs.unitModal.unitData = editUnit;
			this.$refs.unitModal.showModal = true;
		},
		createUnit: function createUnit() {
			var unit = {
				new: true,
				edit: true,
				parkingLat: '0',
				parkingLng: '0',
				fuelCardPin: '0',
				standplaats: '-'
			};

			this.$refs.unitModal.image = '';
			this.$refs.unitModal.unitData = unit;
			this.$refs.unitModal.showModal = true;
		},
		updateUnits: function updateUnits() {
			this.dataTimeStamp = new Date();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71667370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Units/Units.vue
var Units_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-btn',{attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":"","color":"pink"},on:{"click":function($event){return _vm.createUnit()}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('units-table',{attrs:{"dataType":_vm.dataType,"dataTimeStamp":_vm.dataTimeStamp},on:{"showUnit":_vm.showUnit}},[_vm._v(">")])],1),_vm._v(" "),_c('unit-modal',{ref:"unitModal",attrs:{"id":_vm.unit.unitId,"edit":_vm.edit},on:{"updateUnits":function($event){return _vm.updateUnits()}}})],1)}
var Units_staticRenderFns = []
var Units_esExports = { render: Units_render, staticRenderFns: Units_staticRenderFns }
/* harmony default export */ var Units_Units = (Units_esExports);
// CONCATENATED MODULE: ./src/components/Units/Units.vue
var Units_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Units___vue_template_functional__ = false
/* styles */
var Units___vue_styles__ = null
/* scopeId */
var Units___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Units___vue_module_identifier__ = null
var Units_Component = Units_normalizeComponent(
  Units,
  Units_Units,
  Units___vue_template_functional__,
  Units___vue_styles__,
  Units___vue_scopeId__,
  Units___vue_module_identifier__
)

/* harmony default export */ var components_Units_Units = (Units_Component.exports);

// EXTERNAL MODULE: ./node_modules/apexcharts/dist/apexcharts.min.js
var apexcharts_min = __webpack_require__("IieV");
var apexcharts_min_default = /*#__PURE__*/__webpack_require__.n(apexcharts_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dashboard/Dashboard.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Show loader
/* harmony default export */ var Dashboard = ({
	name: 'Dashboard',
	data: function data() {
		var _ref;

		return _ref = {
			utils: utils_namespaceObject,
			total_revenue: '',
			total_km: '',
			monthly_vat: '',
			revenueMonth: '',
			charts: {},
			zoom1: false,
			zoom2: false,
			zooms: [false],
			themeLight: true,
			currentYear: 2019,
			selectedYear: 2019,
			statsFilter: {
				revenue: '',
				km: '',
				vat: ''
			}
		}, defineProperty_default()(_ref, 'charts', {}), defineProperty_default()(_ref, 'barColor', '#66BB6A'), defineProperty_default()(_ref, 'lineColor', '#0277BD'), _ref;
	},
	created: function created() {
		var self = this;
		if (localStorage.getItem('theme')) {
			self.themeLight = localStorage.getItem('theme') === 'light';
		}
		setTimeout(function () {
			self.getStats(false);
		}, 300);
		var currentDate = new Date();
		this.currentYear = currentDate.getFullYear();
		this.selectedYear = currentDate.getFullYear();
	},
	computed: {
		years: function years() {
			var today = new Date();
			return [today.getFullYear(), today.getFullYear() - 1, today.getFullYear() - 2];
		}
	},
	methods: {
		selectYear: function selectYear(year) {
			this.selectedYear = year;
			this.getStats(true);
		},
		setStatsFilter: function setStatsFilter(value, key) {
			if (value === 0) {
				this.statsFilter[key] = '';
			} else {
				this.statsFilter[key] = value;
			}

			// Get stats
			this.getStats(true);
		},

		getStats: function getStats(update) {
			var self = this;
			setData(basePath + 'api/dashboard/getRevenue/' + this.selectedYear, this.statsFilter).then(function (response) {
				if (response) {
					var revenue = vue_underscore["a" /* _ */].pluck(response.unitsRevenue, 'totalRevenue');
					var distance = vue_underscore["a" /* _ */].pluck(response.unitsDistance, 'totalDistance');
					var unitsRevenueFullLabels = vue_underscore["a" /* _ */].pluck(response.unitsRevenue, 'fullname');
					var unitsRevenue = vue_underscore["a" /* _ */].pluck(response.unitsRevenue, 'name');
					var unitsDistance = vue_underscore["a" /* _ */].pluck(response.unitsDistance, 'name');
					var unitsDistanceFullLabels = vue_underscore["a" /* _ */].pluck(response.unitsDistance, 'fullname');
					self.total_revenue = parseFloat(response.all.revenue).toFixed(2);
					self.total_km = parseFloat(response.all.km).toFixed(2);
					self.monthly_vat = response.all.vat;
					self.initCharts('chart', revenue, unitsRevenueFullLabels, 'Omzet', update, '#01579B');
					self.initCharts('chart_distance', distance, unitsDistanceFullLabels, 'Afstand', update, '#1B5E20');
					self.initLineChart('chart_week', response.weekDistribution, ['Ma', 'Di', 'Woe', 'Do', 'Vr', 'Za', 'Zo'], 'Aantal keer verhuurd', 'Dagen', self.lineColor);

					var monthsValues = vue_underscore["a" /* _ */].values(response.dayDistribution);
					var months = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'];
					var monthLabels = [];
					keys_default()(response.dayDistribution).forEach(function (key) {
						monthLabels.push(months[parseInt(key) - 1]);
					});

					self.initLineChart('chart_days', monthsValues, monthLabels, 'Aantal keer verhuurd', 'Verhuurdagen', '#D84315');
				}
			});
		},
		initCharts: function initCharts(element, data, labels, title, update, barColor) {
			var parsedData = [];
			for (var i = 0; i < data.length; i++) {
				parsedData.push(parseFloat(data[i]));
			}

			if (!update) {
				var options = {
					chart: {
						type: 'bar',
						height: 400
					},
					colors: [barColor],
					series: [{
						name: title,
						data: parsedData
					}],
					xaxis: {
						categories: labels,
						labels: {
							rotate: 90,
							formatter: function formatter(i) {
								var label = i.split(' ');
								return label[1];
							}
						}
					},
					dataLabels: {
						enabled: false
					},
					tooltip: {
						theme: this.themeLight ? 'light' : 'dark',
						x: {
							show: true,
							formatter: function formatter(i) {
								return i;
							}
						}
					}
				};
				this.charts[title] = new apexcharts_min_default.a(document.querySelector('#' + element), options);
				this.charts[title].render();
			} else {
				this.charts[title].updateSeries([{
					data: parsedData
				}]);
			}
		},
		initLineChart: function initLineChart(element, data, labels, title, indicatorText, lineColor) {
			var parsedData = [];
			for (var i = 0; i < data.length; i++) {
				parsedData.push(parseFloat(data[i]));
			}

			var options = {
				chart: {
					height: 380,
					type: 'area',
					zoom: {
						enabled: false
					}
				},
				colors: [lineColor],
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'smooth'
				},
				series: [{
					name: indicatorText,
					data: parsedData
				}],
				title: {
					text: title,
					align: 'left'
				},
				grid: {
					row: {
						colors: ['#EEE', 'transparent'], // takes an array which will be repeated on columns
						opacity: 0.15
					}
				},
				xaxis: {
					categories: labels,
					labels: {
						textAnchor: 'start'
					}
				}
			};

			var chart = new apexcharts_min_default.a(document.querySelector('#' + element), options);

			chart.render();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0216f30e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h1',{staticClass:"hidden-sm-and-down"},[_vm._v("Dashboard")]),_vm._v(" "),_c('v-spacer',{staticClass:"hidden-sm-and-down"}),_vm._v(" "),_c('v-select',{attrs:{"prepend-inner-icon":"date_range","items":_vm.years,"label":"Jaartal"},on:{"change":function($event){return _vm.selectYear($event)}},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","xl6":"","chartContainer":"","px-1":"","py-2":""}},[_c('h2',[_vm._v("Totale omzet "+_vm._s(_vm.selectedYear))]),_vm._v("\n\t\t\t€ "+_vm._s(_vm._f("toCurrency")(_vm.total_revenue))+"\n\t\t\t"),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","light":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((['Hele jaar'].concat(
							_vm.utils.getMonths(this.currentYear === this.selectedYear)
						)),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.setStatsFilter(i, 'revenue')}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1),_vm._v(" "),_c('v-card',{staticClass:"wide",class:_vm.zoom1 ? 'expanded' : '',attrs:{"color":""}},[_c('div',{attrs:{"id":"chart"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","xl6":"","chartContainer":"","py-2":""}},[_c('h2',[_vm._v("Totale afstand "+_vm._s(_vm.selectedYear))]),_vm._v("\n\t\t\t"+_vm._s(_vm.total_km)+" Km\n\t\t\t"),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","light":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((['Hele jaar'].concat(
							_vm.utils.getMonths(this.currentYear === this.selectedYear)
						)),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.setStatsFilter(i, 'km')}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1),_vm._v(" "),_c('v-card',{staticClass:"wide",class:_vm.zoom2 ? 'expanded' : '',attrs:{"color":""}},[_c('div',{attrs:{"id":"chart_distance"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","xl6":"","chartContainer":"","px-1":"","py-2":"","mt-3":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Weekverdeling")]),_vm._v(" "),_c('v-card',{staticClass:"pt-2"},[_c('div',{attrs:{"id":"chart_week"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","xl6":"","chartContainer":"","px-0":"","py-2":"","mt-3":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Jaarverdeling")]),_vm._v(" "),_c('v-card',{staticClass:"pt-2"},[_c('div',{attrs:{"id":"chart_days"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","xl6":"","chartContainer":"","py-2":"","mt-3":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("BTW bedrag")]),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","light":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((['Hele jaar'].concat(
							_vm.utils.getMonths(this.currentYear === this.selectedYear)
						)),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.setStatsFilter(i, 'vat')}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t€ "+_vm._s(_vm._f("toCurrency")(_vm.monthly_vat))+"\n\t\t")],1)],1)],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var Dashboard_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/Dashboard/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("Jbl/")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  Dashboard_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var components_Dashboard_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Prices/PriceTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PriceTable = ({
	name: 'PriceTable',
	data: function data() {
		return {
			dialog: false,
			showTable: false,
			utils: utils_namespaceObject,
			pagination: {
				sortBy: 'name'
			},
			items: [],
			selected: [],
			search: '',
			cacheItems: {},
			selectedPrice: null,
			priceItems: [{ text: 'State 1' }],
			headers: [{ text: '#', value: 'id', class: '' }, { text: 'Aantal', value: 'hours', class: '' }, { text: 'Tijdomschrijving', value: 'PriceText', class: '' }, { text: 'Tijdseenheid', value: 'timeUnit', class: '' }, { text: 'Bedrag', value: 'price', class: '' }, { text: 'Categorie', value: 'priceCat', class: '' }, { text: 'Omschrijving', value: 'priceDescription', class: '' }, { text: 'Km vrij', value: 'kmFree', class: '' }, { text: '', value: '', class: '' }],
			timeOptions: [{
				value: 'hour',
				text: 'uur'
			}, {
				value: 'day',
				text: 'dag'
			}, {
				value: 'week',
				text: 'week'
			}, {
				value: 'month',
				text: 'maand'
			}]
		};
	},

	computed: {
		filteredItems: function filteredItems() {
			var self = this;
			return vue_underscore["a" /* _ */].filter(this.items, { priceCat: String(self.selectedPrice) });
		},
		priceFilterOptions: function priceFilterOptions() {
			var self = this;
			var priceCategories = [];
			var distinctCategories = vue_underscore["a" /* _ */].unique(vue_underscore["a" /* _ */].pluck(this.items, 'priceCat'));

			for (var i = 0; i < distinctCategories.length; i++) {
				var category = vue_underscore["a" /* _ */].findWhere(vue_underscore["a" /* _ */].sortBy(this.items, 'id'), {
					priceCat: distinctCategories[i]
				});

				if (!this.selectedPrice) {
					this.selectedPrice = category.priceCat;
				}

				priceCategories.push({
					priceCat: category.priceCat,
					text: category.priceCat + ' - ' + category.groupDescription
				});
			}
			return priceCategories;
		}
	},
	props: ['dataType', 'dataTimeStamp'],
	mounted: function mounted() {
		this.getData();
	},
	watch: {
		selectedPrice: function selectedPrice(newValue) {
			this.$emit('showUnits', { priceCat: newValue });
		},
		dataTimeStamp: function dataTimeStamp() {
			this.getData();
		}
	},
	methods: {
		getData: function getData() {
			var self = this;
			this.showTable = false;

			utils_getData(basePath + 'api/rentunits/getPrices/').then(function (json) {
				if (json && json.data) {
					self.showTable = true;
					self.items = json.data;
					self.$emit('showUnits', {
						priceCat: self.selectedPrice ? self.selectedPrice : self.items[0].priceCat
					});
				}
			});
		},
		showPrice: function showPrice(unit) {
			unit.edit = true;
			this.$emit('showUnit', unit);
		},
		toggleAll: function toggleAll() {
			if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
		},
		changeSort: function changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		updatePrice: function updatePrice(item) {
			setData(basePath + 'api/rentunits/updatePrices', item).then(function (json) {
				if (json.data) {
					item.id = json.data;
					window.emitter.$emit('showToastMessage', {
						msg: 'Prijs opgeslagen'
					});
				}
			});
		},
		deletePrice: function deletePrice(item) {
			var self = this;
			setData(basePath + 'api/rentunits/deletePrice', item).then(function (json) {
				if (json && json.data === true) {
					self.getData();
					if (json.data) {
						window.emitter.$emit('showToastMessage', {
							msg: 'Prijs verwijderd'
						});
					}
				}
			});
		},
		addEmptyNew: function addEmptyNew(priceCat) {
			this.items.push({
				hours: '999',
				kmFree: '0',
				price: '0.00',
				timeUnit: '',
				priceCat: this.selectedPrice,
				priceDescription: '-',
				priceText: 'Omschrijving'
			});
		},
		updateTimeUnit: function updateTimeUnit(item, value) {
			item.timeUnit = value;
			this.updatePrice(item);
		},
		getTimeUnitDescription: function getTimeUnitDescription(timeUnit) {
			var data = vue_underscore["a" /* _ */].where(this.timeOptions, { value: timeUnit });
			if (data && data.length) {
				return data[0]['text'];
			} else {
				return '';
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f31f4c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/PriceTable.vue
var PriceTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100%"},attrs:{"color":"transparent","elevation":"0"}},[_c('v-card-title',{staticClass:"px-1 pt-0"},[_c('h1',[_vm._v("Prijzen")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.priceFilterOptions,"label":"Categorie","item-text":"text","item-value":"priceCat","single-line":"","menu-props":"bottom"},model:{value:(_vm.selectedPrice),callback:function ($$v) {_vm.selectedPrice=$$v},expression:"selectedPrice"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filteredItems,"search":_vm.search,"hide-actions":"","rows-per-page-items":[25, 50],"loading":!_vm.showTable,"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
						'column sortable',
						_vm.pagination.descending ? 'desc' : 'asc',
						header.value === _vm.pagination.sortBy ? 'active' : ''
					],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n\t\t\t\t\t"+_vm._s(header.text)+"\n\t\t\t\t")],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"text-xs-left",on:{"click":function($event){return _vm.showPrice(props.item)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.item.id)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.item.hours)+"\n\t\t\t\t\t\t"),_c('v-text-field',{attrs:{"slot":"input","type":"number","min":"0","step":"0.01","label":"Edit","single-line":""},on:{"change":function($event){return _vm.updatePrice(props.item)}},slot:"input",model:{value:(props.item.hours),callback:function ($$v) {_vm.$set(props.item, "hours", $$v)},expression:"props.item.hours"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.item.priceText)+"\n\t\t\t\t\t\t"),_c('v-text-field',{attrs:{"slot":"input","type":"text","label":"Edit","single-line":""},on:{"change":function($event){return _vm.updatePrice(props.item)}},slot:"input",model:{value:(props.item.priceText),callback:function ($$v) {_vm.$set(props.item, "priceText", $$v)},expression:"props.item.priceText"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v(_vm._s(_vm.getTimeUnitDescription(props.item.timeUnit)))]),_vm._v(" "),_c('v-list',_vm._l((_vm.timeOptions),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.updateTimeUnit(props.item, item.value)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)}),1)],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("toCurrency")(props.item.price))+"\n\t\t\t\t\t\t"),_c('v-text-field',{attrs:{"slot":"input","type":"number","min":"0","step":"0.01","label":"Edit","single-line":""},on:{"change":function($event){return _vm.updatePrice(props.item)}},slot:"input",model:{value:(props.item.price),callback:function ($$v) {_vm.$set(props.item, "price", $$v)},expression:"props.item.price"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.priceCat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.item.priceDescription)+"\n\t\t\t\t\t\t"),_c('v-text-field',{attrs:{"slot":"input","type":"text","label":"Edit","single-line":""},on:{"change":function($event){return _vm.updatePrice(props.item)}},slot:"input",model:{value:(props.item.priceDescription),callback:function ($$v) {_vm.$set(props.item, "priceDescription", $$v)},expression:"props.item.priceDescription"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-edit-dialog',{attrs:{"lazy":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.item.kmFree)+"\n\t\t\t\t\t\t"),_c('v-text-field',{attrs:{"slot":"input","type":"number","min":"0","step":"1","label":"Edit","single-line":""},on:{"change":function($event){return _vm.updatePrice(props.item)}},slot:"input",model:{value:(props.item.kmFree),callback:function ($$v) {_vm.$set(props.item, "kmFree", $$v)},expression:"props.item.kmFree"}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","icon":"","color":"pink"},on:{"click":function($event){return _vm.deletePrice(props.item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.addEmptyNew()}}},[_vm._v("Voeg toe")])],1)],1)}
var PriceTable_staticRenderFns = []
var PriceTable_esExports = { render: PriceTable_render, staticRenderFns: PriceTable_staticRenderFns }
/* harmony default export */ var Prices_PriceTable = (PriceTable_esExports);
// CONCATENATED MODULE: ./src/components/Prices/PriceTable.vue
var PriceTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PriceTable___vue_template_functional__ = false
/* styles */
var PriceTable___vue_styles__ = null
/* scopeId */
var PriceTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PriceTable___vue_module_identifier__ = null
var PriceTable_Component = PriceTable_normalizeComponent(
  PriceTable,
  Prices_PriceTable,
  PriceTable___vue_template_functional__,
  PriceTable___vue_styles__,
  PriceTable___vue_scopeId__,
  PriceTable___vue_module_identifier__
)

/* harmony default export */ var components_Prices_PriceTable = (PriceTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Prices/NewPriceGroup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var NewPriceGroup = ({
  name: "NewPriceGroup",
  data: function data() {
    return {
      utils: utils_namespaceObject,
      showModal: false,
      newPrice: {
        groupDescription: '',
        priceDescription: '',
        timeUnit: 1,
        price: 1,
        kmFree: 0,
        hours: 1
      }
    };
  },

  computed: {},
  mounted: function mounted() {},

  methods: {
    savePriceGroup: function savePriceGroup() {
      var self = this;
      this.utils.setData(basePath + "api/prices/newPriceGroup/", this.newPrice).then(function (response) {
        self.showModal = false;
        self.$emit("update", { priceCat: response.id });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7473c2ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/NewPriceGroup.vue
var NewPriceGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{staticClass:"mobileFullscreen",attrs:{"lazy":"","max-width":"800px","transition":_vm.utils.getSettings('animation')},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"compact"},[_c('v-card-title',{staticClass:"headline blue darken-3 white--text",attrs:{"primary-title":""}},[_vm._v("\n        Nieuwe prijsgroep\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"label":"Omschrijving"},model:{value:(_vm.newPrice.groupDescription),callback:function ($$v) {_vm.$set(_vm.newPrice, "groupDescription", $$v)},expression:"newPrice.groupDescription"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){_vm.showModal = false}}},[_vm._v("Sluiten")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.savePriceGroup()}}},[_vm._v("\n          Opslaan\n        ")])],1)],1)],1)],1)}
var NewPriceGroup_staticRenderFns = []
var NewPriceGroup_esExports = { render: NewPriceGroup_render, staticRenderFns: NewPriceGroup_staticRenderFns }
/* harmony default export */ var Prices_NewPriceGroup = (NewPriceGroup_esExports);
// CONCATENATED MODULE: ./src/components/Prices/NewPriceGroup.vue
function NewPriceGroup_injectStyle (ssrContext) {
  __webpack_require__("nkFh")
}
var NewPriceGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewPriceGroup___vue_template_functional__ = false
/* styles */
var NewPriceGroup___vue_styles__ = NewPriceGroup_injectStyle
/* scopeId */
var NewPriceGroup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NewPriceGroup___vue_module_identifier__ = null
var NewPriceGroup_Component = NewPriceGroup_normalizeComponent(
  NewPriceGroup,
  Prices_NewPriceGroup,
  NewPriceGroup___vue_template_functional__,
  NewPriceGroup___vue_styles__,
  NewPriceGroup___vue_scopeId__,
  NewPriceGroup___vue_module_identifier__
)

/* harmony default export */ var components_Prices_NewPriceGroup = (NewPriceGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Prices/Prices.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Prices = ({
	name: 'Prices',
	components: { PriceTable: components_Prices_PriceTable, UnitModal: components_Units_UnitModal, NewPriceGroup: components_Prices_NewPriceGroup },
	data: function data() {
		return {
			utils: utils_namespaceObject,
			unitsInPriceCat: [],
			unit: {},
			newUnit: {},
			edit: {
				showModal: false
			}
		};
	},
	created: function created() {},

	watch: {},
	methods: {
		getUnitsByPriceCat: function getUnitsByPriceCat(data) {
			var self = this;
			self.unitsInPriceCat = [];
			utils_getData(basePath + 'api/rentunits/getUnitsByPriceCat/' + data.priceCat).then(function (json) {
				if (json && json.data) {
					self.unitsInPriceCat = json.data;
				} else {
					self.unitsInPriceCat = [];
				}
			});
		},
		updateUnits: function updateUnits() {},
		selectUnit: function selectUnit(unit) {
			var editUnit = assign_default()({}, unit);
			this.$refs.unitModal.showModal = true;
			this.$refs.unitModal.unitData = editUnit;
			this.$refs.unitModal.selectedUnit = editUnit;
			this.$refs.unitModal.getUnit();
			this.$refs.unitModal.getUnitSensorData();
		},
		newPrice: function newPrice() {},
		priceCreated: function priceCreated(data) {
			this.$refs.priceTable.selectedPrice = String(data.priceCat);
			this.$refs.priceTable.getData();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d5d155a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/Prices.vue
var Prices_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"fluid":"fluid"}},[_c('price-table',{ref:"priceTable",on:{"showUnits":_vm.getUnitsByPriceCat}}),_vm._v(" "),_c('v-card',{staticStyle:{"width":"100%"},attrs:{"color":"transparent","elevation-0":""}},[_c('v-list',_vm._l((_vm.unitsInPriceCat),function(item){return _c('v-list-tile',{key:item.unitId,attrs:{"avatar":""},on:{"click":function($event){return _vm.selectUnit(item)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name)+" "+_vm._s(item.license))])],1)],1)}),1)],1),_vm._v(" "),_c('unit-modal',{ref:"unitModal",attrs:{"id":_vm.unit.unitId,"edit":_vm.edit,"selectedUnit":_vm.unit,"new":_vm.newUnit},on:{"updateUnits":function($event){return _vm.updateUnits()}}}),_vm._v(" "),_c('v-btn',{attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":"","color":"pink"},on:{"click":function($event){_vm.$refs.newPriceModal.showModal = true}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('new-price-group',{ref:"newPriceModal",on:{"update":function($event){return _vm.priceCreated($event)}}})],1)}
var Prices_staticRenderFns = []
var Prices_esExports = { render: Prices_render, staticRenderFns: Prices_staticRenderFns }
/* harmony default export */ var Prices_Prices = (Prices_esExports);
// CONCATENATED MODULE: ./src/components/Prices/Prices.vue
var Prices_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Prices___vue_template_functional__ = false
/* styles */
var Prices___vue_styles__ = null
/* scopeId */
var Prices___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Prices___vue_module_identifier__ = null
var Prices_Component = Prices_normalizeComponent(
  Prices,
  Prices_Prices,
  Prices___vue_template_functional__,
  Prices___vue_styles__,
  Prices___vue_scopeId__,
  Prices___vue_module_identifier__
)

/* harmony default export */ var components_Prices_Prices = (Prices_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Settings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Settings = ({
	name: 'Settings',
	components: {},
	data: function data() {
		var _this = this;

		return {
			utils: utils_namespaceObject,
			defaultAnimation: 'scale-transition',
			settings: {
				animation: ''
			},
			image: '',
			companyData: {},
			valid: false,
			notifications: false,
			appVersion: '',
			basicRules: [function (v) {
				return !!v || 'Verplicht veld';
			}],
			emailRules: [function (v) {
				return !!v || 'E-mailadres is verplicht';
			}, function (v) {
				return _this.utils.checkEmailAddress(v) || 'Ongeldig email-adres';
			}]
		};
	},
	created: function created() {
		this.appVersion = package_0["version"];
		this.getSettings();
	},

	computed: {
		animation: {
			get: function get() {
				return this.settings.animation !== 'none';
			},
			set: function set(value) {
				this.settings.animation = value ? this.defaultAnimation : 'none';
			}
		},
		basePath: function (_basePath) {
			function basePath() {
				return _basePath.apply(this, arguments);
			}

			basePath.toString = function () {
				return _basePath.toString();
			};

			return basePath;
		}(function () {
			return basePath.replace('index.php/', '');
		})
	},
	watch: {
		'settings.animation': function settingsAnimation() {
			this.utils.saveSettings(this.settings);
		},
		notifications: function notifications(value) {
			if (value) {
				OneSignal.registerForPushNotifications({
					modalPrompt: true
				});
			}
		}
	},
	methods: {
		setImage: function setImage(e) {
			var self = this;
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;

			var file = files[0];
			var image = new Image();
			var reader = new FileReader();
			var vm = this;

			reader.onload = function (e) {
				self.image = e.target.result;
			};

			reader.readAsDataURL(file);
		},
		getSettings: function getSettings() {
			var self = this;
			utils_getData(basePath + 'api/dealers/getSettings/').then(function (json) {
				if (json.data) {
					self.companyData = json.data;
				}
			});
		},
		saveSettings: function saveSettings() {
			if (this.image) {
				this.companyData.image = this.image;
			}

			if (this.$refs.settingsForm.validate()) {
				setData(basePath + 'api/dealers/updateSettings/', this.companyData).then(function (json) {
					window.emitter.$emit('showToastMessage', {
						msg: 'Instellingen opgeslagen'
					});
				});
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b25a9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
var Settings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":"fluid"}},[_c('v-form',{ref:"settingsForm",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{staticStyle:{"max-width":"1000px"},attrs:{"wrap":"","px-0":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',[_vm._v("Appinstellingen")]),_vm._v(" "),_c('v-switch',{attrs:{"label":"Animaties"},model:{value:(_vm.animation),callback:function ($$v) {_vm.animation=$$v},expression:"animation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticClass:"mb-2"},[_vm._v("Bedrijfsgegevens")]),_vm._v(" "),_c('small',[_vm._v("Logo")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(!_vm.image)?_c('img',{staticClass:"d-block",staticStyle:{"max-width":"200px"},attrs:{"src":_vm.basePath + _vm.companyData.logo}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{staticClass:"d-block",staticStyle:{"max-width":"200px"},attrs:{"src":_vm.image}}):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('input',{staticClass:"mb-2",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.setImage}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"description","required":"","rules":_vm.basicRules,"label":"Bedrijfsnaam (kort)"},model:{value:(_vm.companyData.name),callback:function ($$v) {_vm.$set(_vm.companyData, "name", $$v)},expression:"companyData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"name":"description","required":"","rules":_vm.basicRules,"label":"Bedrijfsnaam"},model:{value:(_vm.companyData.description),callback:function ($$v) {_vm.$set(_vm.companyData, "description", $$v)},expression:"companyData.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm8":"","md10":""}},[_c('v-text-field',{attrs:{"label":"Straatnaam","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.street),callback:function ($$v) {_vm.$set(_vm.companyData, "street", $$v)},expression:"companyData.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Huisnummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.houseno),callback:function ($$v) {_vm.$set(_vm.companyData, "houseno", $$v)},expression:"companyData.houseno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Plaats","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.city),callback:function ($$v) {_vm.$set(_vm.companyData, "city", $$v)},expression:"companyData.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Postcode","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.zip),callback:function ($$v) {_vm.$set(_vm.companyData, "zip", $$v)},expression:"companyData.zip"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Land","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.country),callback:function ($$v) {_vm.$set(_vm.companyData, "country", $$v)},expression:"companyData.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.phoneno),callback:function ($$v) {_vm.$set(_vm.companyData, "phoneno", $$v)},expression:"companyData.phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"E-mailadres","type":"text","required":"","rules":_vm.emailRules},model:{value:(_vm.companyData.email),callback:function ($$v) {_vm.$set(_vm.companyData, "email", $$v)},expression:"companyData.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Website","type":"text"},model:{value:(_vm.companyData.website),callback:function ($$v) {_vm.$set(_vm.companyData, "website", $$v)},expression:"companyData.website"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"KvK","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.kvk),callback:function ($$v) {_vm.$set(_vm.companyData, "kvk", $$v)},expression:"companyData.kvk"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Btwnummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.vatno),callback:function ($$v) {_vm.$set(_vm.companyData, "vatno", $$v)},expression:"companyData.vatno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Bankreknummer","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.companyData.bankno),callback:function ($$v) {_vm.$set(_vm.companyData, "bankno", $$v)},expression:"companyData.bankno"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveSettings()}}},[_vm._v("Opslaan")])],1)],1),_vm._v(" "),_c('small',[_vm._v("Versie: "+_vm._s(_vm.appVersion))])],1)}
var Settings_staticRenderFns = []
var Settings_esExports = { render: Settings_render, staticRenderFns: Settings_staticRenderFns }
/* harmony default export */ var components_Settings = (Settings_esExports);
// CONCATENATED MODULE: ./src/components/Settings.vue
var Settings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Settings___vue_template_functional__ = false
/* styles */
var Settings___vue_styles__ = null
/* scopeId */
var Settings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Settings___vue_module_identifier__ = null
var Settings_Component = Settings_normalizeComponent(
  Settings,
  components_Settings,
  Settings___vue_template_functional__,
  Settings___vue_styles__,
  Settings___vue_scopeId__,
  Settings___vue_module_identifier__
)

/* harmony default export */ var src_components_Settings = (Settings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TestDrives/UnitTrackCard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UnitTrackCard = ({
  name: "UnitTrackCard",
  components: { UnitControl: components_Units_UnitControl },
  props: ["item"],
  data: function data() {
    return {
      showMap: false
    };
  },

  computed: {
    mapsUrl: function mapsUrl() {
      var self = this;
      var pos = self.item.pos.y + "," + self.item.pos.x;
      var color = self.item.color ? self.item.color.toLowerCase() : "red";
      var key = "AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w";
      var url = "//maps.googleapis.com/maps/api/staticmap?center=" + pos + "&zoom=8&size=400x400&markers=color:" + color + "%7C" + pos + "&key=" + key;
      return url;
    },
    marker: function marker() {
      return {
        position: {
          lat: this.item.pos.y,
          lng: this.item.pos.x
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdc22ef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestDrives/UnitTrackCard.vue
var UnitTrackCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{class:("elevation-" + (hover ? 12 : 2))},[_c('v-img',{attrs:{"src":_vm.mapsUrl,"height":"200px"},on:{"click":function($event){_vm.showMap = true}}},[(_vm.showMap)?_c('gmap-map',{staticStyle:{"width":"100%","height":"200px"},attrs:{"center":{lat:_vm.item.pos.y, lng:_vm.item.pos.x},"zoom":7,"options":{'gestureHandling':'greedy'},"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"position":_vm.marker.position,"clickable":true}})],1):_vm._e()],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.item.fullDescription))]),_vm._v(" "),_vm._t("subheader"),_vm._v(" "),(_vm.item.sensors)?_c('unit-control',{staticClass:"mt-1",attrs:{"sensors":_vm.item.sensors}}):_vm._e()],2)]),_vm._v(" "),_c('v-card-actions',[_vm._t("default")],2)],1)}}],null,true)})}
var UnitTrackCard_staticRenderFns = []
var UnitTrackCard_esExports = { render: UnitTrackCard_render, staticRenderFns: UnitTrackCard_staticRenderFns }
/* harmony default export */ var TestDrives_UnitTrackCard = (UnitTrackCard_esExports);
// CONCATENATED MODULE: ./src/components/TestDrives/UnitTrackCard.vue
var UnitTrackCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnitTrackCard___vue_template_functional__ = false
/* styles */
var UnitTrackCard___vue_styles__ = null
/* scopeId */
var UnitTrackCard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnitTrackCard___vue_module_identifier__ = null
var UnitTrackCard_Component = UnitTrackCard_normalizeComponent(
  UnitTrackCard,
  TestDrives_UnitTrackCard,
  UnitTrackCard___vue_template_functional__,
  UnitTrackCard___vue_styles__,
  UnitTrackCard___vue_scopeId__,
  UnitTrackCard___vue_module_identifier__
)

/* harmony default export */ var components_TestDrives_UnitTrackCard = (UnitTrackCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TestDrives/ActiveTestDrives.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ActiveTestDrives = ({
	name: 'ActiveTestDrives',
	components: { UnitTrackCard: components_TestDrives_UnitTrackCard, StatusIndicator: vue_status_indicator_esm["a" /* StatusIndicator */] },
	data: function data() {
		return {
			dialog: false,
			rowsPerPageItems: [4, 8, 12],
			loop: null,
			pagination: {
				rowsPerPage: 4
			},
			items: [{
				s: '',
				pos: {},
				location: 1
			}],
			description: '',
			utils: utils_namespaceObject
		};
	},

	props: ['active'],
	mounted: function mounted() {
		var self = this;
		this.getUnits();

		window.emitter.$on('newEvents', function (data) {
			if (self.$route.name.indexOf('TestDrive') >= 0) {
				self.getPositions(data);
			}
		});
	},
	beforeDestroy: function beforeDestroy() {
		console.log('clear interval');
		window.emitter.$off('newEvents');
	},

	watch: {},
	computed: {
		activeUnits: function activeUnits() {
			return this.items.filter(function (item) {
				return item.active == '1';
			});
		},
		inActiveUnits: function inActiveUnits() {
			return this.items.filter(function (item) {
				return item.active == '0';
			});
		}
	},
	methods: {
		getUnits: function getUnits() {
			var self = this;
			utils_getData(basePath + 'api/TestDrives/testDriveUnits').then(function (json) {
				if (json && json.data) {
					self.items = json.data;
					self.getLocations();
				}
			});
		},
		getLocations: function getLocations() {
			var coords = '';
			for (var i = 0; i < this.items.length; i++) {
				var item = this.items[i];

				coords = [{
					lat: item.pos.y,
					lon: item.pos.x
				}];

				this.getUnitLocation(item, coords);
			}
		},
		getPositions: function getPositions(updatedUnits) {
			var self = this;

			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					var currentUnit = vue_underscore["a" /* _ */].findWhere(this.items, {
						wialonUnitId: String(unit.i)
					});
					if (currentUnit) {
						currentUnit.pos = unit.d.pos;
						var coords = [];
						coords.push({
							lat: currentUnit.pos.y,
							lon: currentUnit.pos.x
						});

						this.getUnitLocation(currentUnit, coords);
					}
				}
			}
		},
		getUnitLocation: function getUnitLocation(item, coords) {
			var self = this;
			setData(basePath + 'api/rentunits/getUnitLocation/' + item.unitId, {
				coords: coords
			}).then(function (json) {
				if (json && json.data && json.data.length) {
					var location = json.data[0].replace(/,/g, ' ');
					self.$set(item, 'location', location);
				}
				if (json && json.sensors && json.sensors) {
					self.$set(item, 'sensors', json.sensors);
				}
			});
		},
		editTestDrive: function editTestDrive(item) {
			this.dialog = true;
		},
		updateTestDrive: function updateTestDrive(item) {
			var self = this;
			var timeStamp = moment_default()().unix();

			var data = {
				unitId: item.unitId,
				description: item.testDriveDescription,
				timeStamp: item.timeStamp
			};

			setData(basePath + 'api/reservations/updateTestDrive/', data).then(function (json) {
				if (json && json.data) {}
			});
		},
		startTestDrive: function startTestDrive(item) {
			var self = this;
			var timeStamp = moment_default()().unix();

			var data = {
				unitId: item.unitId,
				timeStamp: timeStamp,
				description: item.startDescription
			};

			setData(basePath + 'api/reservations/startTestDrive/', data).then(function (json) {
				if (json && json.data) {
					item.active = true;
					item.testDriveDescription = item.startDescription;
					item.timeStamp = timeStamp;
					item.startDate = new Date();
				}
			});
		},
		stopTestDrive: function stopTestDrive(item) {
			var self = this;
			var data = {
				id: item.id,
				unitId: item.unitId,
				timeStamp: item.timeStamp,
				description: item.testDriveDescription
			};

			setData(basePath + 'api/reservations/stopTestDrive/', data).then(function (json) {
				if (json && json.data) {
					item.active = false;
					item.startDescription = '';
				}
			});
		},
		getMapsUrl: function getMapsUrl(item) {
			var pos = item.pos.y + ',' + item.pos.x;
			var color = item.color ? item.color.toLowerCase() : 'red';
			var key = 'AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w';
			var url = '//maps.googleapis.com/maps/api/staticmap?center=' + pos + '&zoom=14&size=400x400&markers=color:' + color + '%7C' + pos + '&key=' + key;
			return url;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1f8f23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestDrives/ActiveTestDrives.vue
var ActiveTestDrives_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","pa-0":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","px-0":"","py-2":"","elevation-0":""}},[_c('div',{staticClass:"flex"},[_c('h3',[_vm._v("Actief")]),_vm._v(" "),_c('v-data-iterator',{attrs:{"content-tag":"v-layout","row":"","wrap":"","hide-actions":true,"items":_vm.activeUnits,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"no-data-text":"Geen proefritten"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":"","d-flex":""}},[_c('unit-track-card',{attrs:{"item":props.item}},[_c('div',{staticClass:"subHeader",attrs:{"slot":"subheader"},slot:"subheader"},[(props.item.active == '1')?_c('status-indicator',{staticClass:"right",staticStyle:{"transform":"translate(35%,0)"},attrs:{"positive":"","pulse":""}}):_vm._e(),_vm._v(_vm._s(props.item.pos.s)+" km/u\n\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),(!props.item.location)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(_vm._s(props.item.location)+"\n\t\t\t\t\t\t")],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Omschrijving","type":"text"},on:{"change":function($event){return _vm.updateTestDrive(props.item)}},model:{value:(props.item.testDriveDescription),callback:function ($$v) {_vm.$set(props.item, "testDriveDescription", $$v)},expression:"props.item.testDriveDescription"}})],1),_vm._v(" "),(props.item.active == '0')?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.startTestDrive(props.item)}}},[_vm._v("Start")]):_vm._e(),_vm._v(" "),(props.item.active == '1')?_c('v-btn',{attrs:{"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.stopTestDrive(props.item)}}},[_vm._v("Stop")]):_vm._e()],1)],1)}}])})],1),_vm._v(" "),_c('div',{staticClass:"flex px-0 py-4"},[_c('h3',[_vm._v("Inactief")]),_vm._v(" "),_c('v-data-iterator',{attrs:{"content-tag":"v-layout","row":"","wrap":"","hide-actions":true,"items":_vm.inActiveUnits,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"no-data-text":"Alle units zijn in gebruik"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":"","d-flex":""}},[_c('unit-track-card',{attrs:{"item":props.item}},[_c('div',{attrs:{"slot":"subheader"},slot:"subheader"},[(props.item.active == '1')?_c('status-indicator',{staticClass:"right",staticStyle:{"transform":"translate(35%,0)"},attrs:{"positive":"","pulse":""}}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.pos.s)+" km/u\n\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),(!props.item.location)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.item.location)+"\n\t\t\t\t\t\t")],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Omschrijving","type":"text"},model:{value:(props.item.startDescription),callback:function ($$v) {_vm.$set(props.item, "startDescription", $$v)},expression:"props.item.startDescription"}})],1),_vm._v(" "),(props.item.active == '0')?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.startTestDrive(props.item)}}},[_vm._v("Start")]):_vm._e(),_vm._v(" "),(props.item.active == '1')?_c('v-btn',{attrs:{"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.stopTestDrive(props.item)}}},[_vm._v("Stop")]):_vm._e()],1)],1)}}])})],1)])],1)}
var ActiveTestDrives_staticRenderFns = []
var ActiveTestDrives_esExports = { render: ActiveTestDrives_render, staticRenderFns: ActiveTestDrives_staticRenderFns }
/* harmony default export */ var TestDrives_ActiveTestDrives = (ActiveTestDrives_esExports);
// CONCATENATED MODULE: ./src/components/TestDrives/ActiveTestDrives.vue
function ActiveTestDrives_injectStyle (ssrContext) {
  __webpack_require__("8W9K")
}
var ActiveTestDrives_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ActiveTestDrives___vue_template_functional__ = false
/* styles */
var ActiveTestDrives___vue_styles__ = ActiveTestDrives_injectStyle
/* scopeId */
var ActiveTestDrives___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ActiveTestDrives___vue_module_identifier__ = null
var ActiveTestDrives_Component = ActiveTestDrives_normalizeComponent(
  ActiveTestDrives,
  TestDrives_ActiveTestDrives,
  ActiveTestDrives___vue_template_functional__,
  ActiveTestDrives___vue_styles__,
  ActiveTestDrives___vue_scopeId__,
  ActiveTestDrives___vue_module_identifier__
)

/* harmony default export */ var components_TestDrives_ActiveTestDrives = (ActiveTestDrives_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TestDrives/TestDrivesHistoryTable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var TestDrivesHistoryTable = ({
  name: "TestDrivesHistoryTable",
  components: { VuePullRefresh: vue_pull_refresh_min_default.a },
  props: ["ts"],
  data: function data() {
    return {
      pullConfig: window.pullConfig,
      dialog: false,
      pagination: {
        sortBy: "id",
        descending: true
      },
      selected: [],
      search: "",
      headers: [{
        text: "#",
        align: "left",
        value: "id"
      }, { text: "Unit", value: "unitDescription" }, { text: "Omschrijving", value: "testdriveDescription" }, { text: "Starttijd", value: "startDate" }, { text: "Eindtijd", value: "endDate" }],
      items: [],
      allItems: []
    };
  },

  watch: {
    ts: function ts(newVal) {
      if (newVal) {
        this.getHistory();
      }
    },
    search: function search(val) {
      var self = this;
      var searchText = val.toLowerCase();
      var searchableItems = this.allItems;
      var options = {
        keys: ["unitDescription", "testDriveDescription", "startDate", "endDate"]
      };
      if (val == "") {
        this.items = searchableItems;
      } else {
        this.$search(searchText, searchableItems, options).then(function (results) {
          self.items = results;
        });
      }
    }
  },
  created: function created() {},
  methods: {
    getHistory: function getHistory() {
      var self = this;
      return utils_getData(basePath + "api/TestDrives/testDriveHistory/").then(function (json) {
        if (json && json.data) {
          self.allItems = json.data;
          self.items = self.allItems;
        }
      });
    },
    showUser: function showUser(user) {
      user.edit = true;
      this.$emit("showUser", user);
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    onRefresh: function onRefresh() {
      var self = this;
      return new promise_default.a(function (resolve, reject) {
        self.getHistory(false).then(function () {
          setTimeout(function () {
            resolve();
          }, 500);
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cd0514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestDrives/TestDrivesHistoryTable.vue
var TestDrivesHistoryTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex xl12 lg12 md12 mx-auto"},[_c('vue-pull-refresh',{attrs:{"on-refresh":_vm.onRefresh,"config":_vm.pullConfig}},[_c('v-card',{attrs:{"color":"transparent"}},[_c('v-card-title',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","text-xs-left":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","text-xs-right":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Zoeken","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"rows-per-page-items":[25,50],"item-key":"name"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticClass:"hidden-xs-only"},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable text-xs-left', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_vm._v("\n              "+_vm._s(header.text)+"\n              "),_c('v-icon',[_vm._v("arrow_upward")])],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v(_vm._s(props.item.unitDescription))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v(_vm._s(props.item.testDriveDescription))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v(_vm._s(props.item.startDate))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-xs-only"},[_vm._v(_vm._s(props.item.endDate))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left hidden-sm-and-up itemRow"},[_c('h3',[_vm._v("#"+_vm._s(props.item.id)+" "+_vm._s(props.item.unitDescription))]),_vm._v("\n              "+_vm._s(props.item.testDriveDescription)+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(props.item.startDate)+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(props.item.endDate)+"\n            ")])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)}
var TestDrivesHistoryTable_staticRenderFns = []
var TestDrivesHistoryTable_esExports = { render: TestDrivesHistoryTable_render, staticRenderFns: TestDrivesHistoryTable_staticRenderFns }
/* harmony default export */ var TestDrives_TestDrivesHistoryTable = (TestDrivesHistoryTable_esExports);
// CONCATENATED MODULE: ./src/components/TestDrives/TestDrivesHistoryTable.vue
var TestDrivesHistoryTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TestDrivesHistoryTable___vue_template_functional__ = false
/* styles */
var TestDrivesHistoryTable___vue_styles__ = null
/* scopeId */
var TestDrivesHistoryTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TestDrivesHistoryTable___vue_module_identifier__ = null
var TestDrivesHistoryTable_Component = TestDrivesHistoryTable_normalizeComponent(
  TestDrivesHistoryTable,
  TestDrives_TestDrivesHistoryTable,
  TestDrivesHistoryTable___vue_template_functional__,
  TestDrivesHistoryTable___vue_styles__,
  TestDrivesHistoryTable___vue_scopeId__,
  TestDrivesHistoryTable___vue_module_identifier__
)

/* harmony default export */ var components_TestDrives_TestDrivesHistoryTable = (TestDrivesHistoryTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TestDrives/TestDrive.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var TestDrive = ({
	name: 'TestDrive',
	components: {
		UnitTrackCard: components_TestDrives_UnitTrackCard,
		StatusIndicator: vue_status_indicator_esm["a" /* StatusIndicator */],
		ActiveTestDrives: components_TestDrives_ActiveTestDrives,
		TestDrivesHistoryTable: components_TestDrives_TestDrivesHistoryTable
	},
	data: function data() {
		return {
			active: 'Actief',
			dialog: false,
			rowsPerPageItems: [4, 8, 12],
			pagination: {
				rowsPerPage: 4
			},
			items: [{
				s: '',
				pos: {},
				location: 1
			}],
			description: '',
			utils: utils_namespaceObject,
			ts: 0
		};
	},

	watch: {
		active: function active(newVal) {
			if (newVal === 'Historie') {
				this.ts = this.utils.getTimestamp();
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1503bf46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestDrives/TestDrive.vue
var TestDrive_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('h1',{staticClass:"hidden-sm-and-down"},[_vm._v("Tracker")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","elevation-0":""}},[_c('v-tabs',{attrs:{"centered":"","fixed-tabs":"","color":"transparent"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:'Actief',attrs:{"href":'#Actief',"ripple":""}},[_vm._v("Units")]),_vm._v(" "),_c('v-tab',{key:'Historie',attrs:{"href":'#Historie',"ripple":""}},[_vm._v("Historie")]),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"blue darken-2"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{key:'Actief',attrs:{"value":'Actief'}},[_c('active-test-drives',{attrs:{"active":_vm.active === 'Actief'}})],1),_vm._v(" "),_c('v-tab-item',{key:'Historie',attrs:{"value":'Historie'}},[_c('test-drives-history-table',{attrs:{"ts":_vm.ts}})],1)],1)],1)],1)],1)}
var TestDrive_staticRenderFns = []
var TestDrive_esExports = { render: TestDrive_render, staticRenderFns: TestDrive_staticRenderFns }
/* harmony default export */ var TestDrives_TestDrive = (TestDrive_esExports);
// CONCATENATED MODULE: ./src/components/TestDrives/TestDrive.vue
var TestDrive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TestDrive___vue_template_functional__ = false
/* styles */
var TestDrive___vue_styles__ = null
/* scopeId */
var TestDrive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TestDrive___vue_module_identifier__ = null
var TestDrive_Component = TestDrive_normalizeComponent(
  TestDrive,
  TestDrives_TestDrive,
  TestDrive___vue_template_functional__,
  TestDrive___vue_styles__,
  TestDrive___vue_scopeId__,
  TestDrive___vue_module_identifier__
)

/* harmony default export */ var components_TestDrives_TestDrive = (TestDrive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Messages.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Messages = ({
  name: "messages",
  props: [],
  mounted: function mounted() {
    this.getMessages();
  },
  data: function data() {
    return {
      headers: [{
        text: "Onderwerp",
        align: "left",
        sortable: false,
        value: "subject"
      }, { text: "Datum", value: "sentDateTime" }],
      items: []
    };
  },

  methods: {
    getMessages: function getMessages() {
      var self = this;
      utils_getData(basePath + "api/messages/getMessages").then(function (response) {
        self.items = response.data;
      });
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b9518b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
var Messages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center mpa-0",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.subject))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.sentDateTime))])]}}])})],1)],1)}
var Messages_staticRenderFns = []
var Messages_esExports = { render: Messages_render, staticRenderFns: Messages_staticRenderFns }
/* harmony default export */ var components_Messages = (Messages_esExports);
// CONCATENATED MODULE: ./src/components/Messages.vue
function Messages_injectStyle (ssrContext) {
  __webpack_require__("5OsU")
}
var Messages_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Messages___vue_template_functional__ = false
/* styles */
var Messages___vue_styles__ = Messages_injectStyle
/* scopeId */
var Messages___vue_scopeId__ = "data-v-26b9518b"
/* moduleIdentifier (server only) */
var Messages___vue_module_identifier__ = null
var Messages_Component = Messages_normalizeComponent(
  Messages,
  components_Messages,
  Messages___vue_template_functional__,
  Messages___vue_styles__,
  Messages___vue_scopeId__,
  Messages___vue_module_identifier__
)

/* harmony default export */ var src_components_Messages = (Messages_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js

















vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Login_base',
		component: src_components_Login
	}, {
		path: '/login/:action?',
		name: 'Login',
		component: src_components_Login
	}, {
		path: '/logout',
		name: 'Logout',
		redirect: {
			name: 'Login',
			params: {
				action: '-'
			}
		}
	}, {
		path: '/reservations',
		name: 'Home',
		component: components_Reservations_Reservations
	}, {
		path: '/dashboard',
		name: 'Dashboard',
		component: components_Dashboard_Dashboard
	}, {
		path: '/update',
		name: 'Update',
		component: src_components_Settings
	}, {
		path: '/reservations/',
		name: 'Reservations',
		component: components_Reservations_Reservations
	}, {
		path: '/reservations/:id',
		name: 'Reservations_details',
		component: components_Reservations_Reservations
	}, {
		path: '/planner',
		name: 'Planner',
		component: components_Planner_Planner
	}, {
		path: '/users',
		name: 'Users',
		component: components_Users_Users
	}, {
		path: '/users/:userid',
		name: 'showUser',
		component: components_Users_Users
	}, {
		path: '/history',
		name: 'History',
		component: components_History_History
	}, {
		path: '/history/:id',
		name: 'History_details',
		component: components_History_History
	}, {
		path: '/units',
		name: 'Units',
		component: components_Units_Units
	}, {
		path: '/prices',
		name: 'Prices',
		component: components_Prices_Prices
	}, {
		path: '/additionalItems',
		name: 'AdditionalItems',
		component: components_Reservations_AdditionalItems
	}, {
		path: '/settings',
		name: 'Settings',
		component: src_components_Settings
	}, {
		path: '/testdrive',
		name: 'TestDrive',
		component: components_TestDrives_TestDrive
	}, {
		path: '/messages',
		name: 'Messages',
		component: src_components_Messages
	}]
}));
// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__("sA6N");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/vue-wysiwyg/dist/vueWysiwyg.js
var vueWysiwyg = __webpack_require__("V2hT");
var vueWysiwyg_default = /*#__PURE__*/__webpack_require__.n(vueWysiwyg);

// EXTERNAL MODULE: ./node_modules/vue-fuse/index.js
var vue_fuse = __webpack_require__("XTKK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/subcomponents/FuelSlider.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FuelSlider = ({
  name: "FuelSlider",
  components: {},
  data: function data() {
    return {
      fuelOptions: [0, 100]
    };
  },

  props: ["fuelLevel"],
  computed: {
    selectedFuelLevel: {
      get: function get() {
        return this.fuelLevel;
      },
      set: function set(value) {
        this.$emit("setFuelLevel", value);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f31ac81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponents/FuelSlider.vue
var FuelSlider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"shrink":"","xs6":""}},[_c('v-text-field',{staticClass:"mt-0",attrs:{"type":"number","label":"Br.stof start","step":"10","min":"0","max":"100"},model:{value:(_vm.selectedFuelLevel[0]),callback:function ($$v) {_vm.$set(_vm.selectedFuelLevel, 0, $$v)},expression:"selectedFuelLevel[0]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"shrink":"","xs6":""}},[_c('v-text-field',{staticClass:"mt-0",attrs:{"type":"number","label":"Br.stof eind","step":"10","min":"0","max":"100"},model:{value:(_vm.selectedFuelLevel[1]),callback:function ($$v) {_vm.$set(_vm.selectedFuelLevel, 1, $$v)},expression:"selectedFuelLevel[1]"}})],1)],1)],1)}
var FuelSlider_staticRenderFns = []
var FuelSlider_esExports = { render: FuelSlider_render, staticRenderFns: FuelSlider_staticRenderFns }
/* harmony default export */ var subcomponents_FuelSlider = (FuelSlider_esExports);
// CONCATENATED MODULE: ./src/components/subcomponents/FuelSlider.vue
var FuelSlider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FuelSlider___vue_template_functional__ = false
/* styles */
var FuelSlider___vue_styles__ = null
/* scopeId */
var FuelSlider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FuelSlider___vue_module_identifier__ = null
var FuelSlider_Component = FuelSlider_normalizeComponent(
  FuelSlider,
  subcomponents_FuelSlider,
  FuelSlider___vue_template_functional__,
  FuelSlider___vue_styles__,
  FuelSlider___vue_scopeId__,
  FuelSlider___vue_module_identifier__
)

/* harmony default export */ var components_subcomponents_FuelSlider = (FuelSlider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reservations/ReservationsModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var ReservationsModal = ({
	name: 'ReservationsModal',
	components: {
		ReservationCostDetails: components_Reservations_ReservationCostDetails,
		UnitControl: components_Units_UnitControl,
		CustomerCard: components_subcomponents_CustomerCard,
		TempCustomer: components_subcomponents_TempCustomer,
		FuelSlider: components_subcomponents_FuelSlider,
		SelectPeriod: components_Reservations_SelectPeriod,
		ViewInvoice: components_Reservations_ViewInvoice
	},
	created: function created() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
	},
	mounted: function mounted() {
		var self = this;
		this.allUnits = this.units;

		setTimeout(function () {
			self.active = 'Gegevens';
		}, 0);

		this.userType = localStorage.getItem('t');
	},
	data: function data() {
		return {
			tabs: ['Gegevens', 'Kostenoverzicht', 'Aanvullend', 'Kaart', 'Klantgegevens', 'Opties', 'Unitplanner'],
			active: null,
			valid: false,
			onlyAvailableUnits: false,
			unitId: '',
			unitList: [],
			allUnits: [],
			showMessage: false,
			msg: '',
			menu: false,
			menu2: false,
			dialog: false,
			showForm: false,
			loading: false,
			priceLoading: false,
			userLoading: false,
			sendInvoice: true,
			saveDisabled: false,
			confirm: {
				end: false,
				delete: false
			},
			unitDate: {},
			selectedReservation: {
				startTime: '00:01',
				endTime: '23:59',
				fuelLevel: [],
				costData: {
					additionalItems: []
				},
				sensors: {},
				status: {},
				showPricesModal: false
			},
			emptyReservation: {
				startTime: '00:01',
				endTime: '23:59',
				costData: {
					additionalItems: []
				},
				fuelLevel: [],
				sensors: {},
				status: {},
				showPricesModal: false
			},
			basicRules: [function (v) {
				return !!v || 'Verplicht veld';
			}],
			search: null,
			searchUsers: [],
			editUser: false,
			select: '',
			showMap: false,
			startTimeFocus: false,
			endTimeFocus: false,
			items: [],
			markers: [],
			utils: utils_namespaceObject,
			showModal: false,
			id: 0,
			updateTime: '',
			zoomLevel: 7,
			fullscreen: false,
			useTempForInvoice: false,
			prepaidAmount: 0,
			manualPaidAmount: 0,
			mapsUrl: '',
			userType: 'default'
		};
	},

	props: ['user', 'edit', 'units'],
	computed: {
		fullName: function fullName() {
			return this.selectedReservation.firstname ? this.selectedReservation.firstname + ' ' + this.selectedReservation.lastname + ' (' + this.selectedReservation.username + ')' : '';
		},
		fullStartDate: function fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate: function fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		},
		kmDifference: function kmDifference() {
			return parseInt(this.selectedReservation.kmEnd) - parseInt(this.selectedReservation.kmStart);
		},
		selectUnits: function selectUnits() {
			if (!this.unitList.length) {
				return this.units;
			} else {
				return this.unitList;
			}
		},
		prepaidLink: function prepaidLink() {
			return encodeURI('whatsapp://send?text=U kunt een aanbetaling doen via deze link: ' + basePath.replace('manager/index.php/', '') + 'account/prePayment/' + this.selectedReservation.id);
		}
	},
	watch: {
		onlyAvailableUnits: function onlyAvailableUnits(checked) {
			if (checked) {
				this.getAvailableUnits();
			} else {
				this.unitList = this.allUnits;
			}
		},

		showModal: function showModal(value) {
			if (!value) {
				this.showMap = false;
			}
			//this.setModalScroll(!value);
		},
		'selectedReservation.startTime': function selectedReservationStartTime() {
			if (this.startTimeFocus && moment_default()(this.selectedReservation.startDate, 'YYYY-MM-DD').isSame(moment_default()(this.selectedReservation.endDate), 'day')) {
				var format = 'hh:mm';
				var startTime = moment_default()(this.selectedReservation.startTime, format);
				var endTime = moment_default()(this.selectedReservation.endTime, format);
				if (startTime.isAfter(endTime)) {
					//  this.selectedReservation.startTime = endTime.add(-1, 'hours').format("HH:mm");
				}
			}
		},
		'selectedReservation.endTime': function selectedReservationEndTime() {
			if (this.endTimeFocus && moment_default()(this.selectedReservation.startDate, 'YYYY-MM-DD').isSame(moment_default()(this.selectedReservation.endDate), 'day')) {
				var format = 'hh:mm';
				var startTime = moment_default()(this.selectedReservation.startTime, format);
				var endTime = moment_default()(this.selectedReservation.endTime, format);
				if (endTime.isBefore(startTime)) {
					// this.selectedReservation.endTime = startTime.add(1, 'hours').format("HH:mm");
				}
			}
		},

		unitId: function unitId(val, oldVal) {
			if (val && oldVal) {
				var selectedUnit = vue_underscore["a" /* _ */].where(this.selectUnits, { unitId: val });
				if (selectedUnit && selectedUnit.length) {
					this.selectedReservation.freeMileage = selectedUnit[0].freeMileage;
					this.selectedReservation.rentDescription = this.selectedReservation.rentDescription && this.selectedReservation.rentDescription.indexOf('Verhuur') < 0 ? this.selectedReservation.rentDescription : 'Verhuur ' + selectedUnit[0].name + ' ' + selectedUnit[0].license;
					this.selectedReservation.unitId = val;
					this.selectedReservation.costData.prices = [];
				}
			}
		},
		search: function search(val) {
			val && this.querySelections(val);
		},
		select: function select(newVal) {
			var selectedUser = vue_underscore["a" /* _ */].findWhere(this.items, { user_id: newVal });
			this.selectedReservation.username = selectedUser.username;
			this.selectedReservation.phoneno = selectedUser.phoneno;
			this.selectedReservation.city = selectedUser.city;
			this.selectedReservation.license = selectedUser.license;
			this.selectedReservation.firstname = selectedUser.firstname;
			this.selectedReservation.lastname = selectedUser.lastname;
			this.selectedReservation.birthdate = selectedUser.birthdate;
			this.selectedReservation.street = selectedUser.street;
			this.selectedReservation.streetno = selectedUser.streetno;
			this.selectedReservation.zip = selectedUser.zip;
		},
		active: function active(val) {
			if (val !== 'Kaart') {
				this.showMap = false;
			}
		}
	},
	methods: {
		// Update reservations cost when changing dates
		checkWhenModified: function checkWhenModified() {
			this.checkReservationDates();
			this.getUpdateReservationCost();
		},
		showReservation: function showReservation(id, toFirstTab) {
			var self = this;
			this.id = id;
			this.showModal = true;

			setTimeout(function () {
				self.getReservationData(id, true);
			}, 100);
		},

		// Get the reservation data
		getReservationData: function getReservationData(id, toFirstTab) {
			if (this.showModal) {
				var self = this;
				if (toFirstTab) {
					this.active = 'Gegevens';
				}
				self.loading = true;
				self.showForm = false;
				self.updateTime = '';
				// Get data
				utils_getData(basePath + 'api/reservations/reservationDetails/' + id).then(function (json) {
					self.selectedReservation = json.data;
					self.showForm = true;
					var selectedUnit = vue_underscore["a" /* _ */].where(self.selectUnits, {
						unitId: self.selectedReservation.unitId
					});
					self.unitId = self.selectedReservation.unitId;
					self.selectedReservation.rentDescription = self.selectedReservation.rentDescription ? self.selectedReservation.rentDescription : 'Verhuur ' + selectedUnit[0].name + ' ' + selectedUnit[0].license;
					self.selectedReservation.sensors = {};
					self.selectedReservation.setCustomDistance = self.selectedReservation.setCustomDistance === '1';
					var startDate = moment_default()(self.selectedReservation.startDate).format('YYYY-MM-DD');
					var endDate = moment_default()(self.selectedReservation.endDate).format('YYYY-MM-DD');
					if (moment_default()(startDate).isValid() && moment_default()(endDate).isValid()) {
						self.selectedReservation.startTime = moment_default()(self.selectedReservation.startDate).format('HH:mm');
						self.selectedReservation.startDate = startDate;
						self.selectedReservation.endTime = moment_default()(self.selectedReservation.endDate).format('HH:mm');
						self.selectedReservation.endDate = endDate;
					} else {
						self.selectedReservation.startTime = '00:00';
						self.selectedReservation.startDate = moment_default()(new Date()).format('YYYY-MM-DD');
						self.selectedReservation.endTime = '18:00';
						self.selectedReservation.endDate = moment_default()(new Date()).format('YYYY-MM-DD');
					}

					if (!self.selectedReservation.tempCustomer) {
						self.selectedReservation.tempCustomer = {};
					}
					self.selectedReservation.hasMaxTime = parseInt(self.selectedReservation.hasMaxTime) === 0 ? false : true;
					self.loading = true;
					self.getReservationCost(id);
				});
			}
		},
		getReservationCost: function getReservationCost(id) {
			var self = this;
			self.priceLoading = true;
			// Get cost and position
			utils_getData(basePath + 'api/reservations/reservationCost/' + id).then(function (response) {
				self.priceLoading = false;
				if (response && response.data) {
					if (response.data.unitData && response.data.unitData.length) {
						self.selectedReservation.lat = response.data.unitData[0].pos.y;
						self.selectedReservation.lng = response.data.unitData[0].pos.x;
						self.selectedReservation.mileage = response.data.mileage;
						self.selectedReservation.status = response.data.unitData[0].status;
						if (response.data.mileage < 10) {
							self.zoomLevel = 14;
						} else {
							self.zoomLevel = 7;
						}
					}

					self.selectedReservation.cost = response.data.cost.total;
					self.selectedReservation.costData = response.data.cost;
					self.selectedReservation.sensors = response.data.sensors;
					self.selectedReservation.showPricesModal = false;
					self.selectedReservation.wialonUnitId = response.data.unitData[0].wialonUnitId;

					if (self.selectedReservation.wialonUnitId === '0') {
						self.selectedReservation.setCustomDistance = true;
					}

					self.selectedReservation.totalWithoutDiscount = self.selectedReservation.costData.totalDecimal - self.selectedReservation.costData.discount;
					self.selectedReservation.totalWithoutMileageCost = self.selectedReservation.totalWithoutDiscount - self.selectedReservation.costData.mileage * self.selectedReservation.kmPrice;

					self.markers[0] = {
						position: {
							lat: self.selectedReservation.lat,
							lng: self.selectedReservation.lng
						}
					};

					// Set maps
					self.setMapsUrl();

					// Prepaid amount
					if (!self.selectedReservation.costData.totalDecimal) {
						self.prepaidAmount = 0;
					}
					self.prepaidAmount = (self.selectedReservation.costData.totalDecimal - self.selectedReservation.amountPaid).toFixed(2);
				}
			});
		},

		// Show precalculated cost when changing values
		getUpdateReservationCost: function getUpdateReservationCost() {
			var self = this;
			if (this.selectedReservation.unitId) {
				this.priceLoading = true;
				var data = vue_underscore["a" /* _ */].clone(this.selectedReservation);
				data.costData = {};
				data.startDate = moment_default()(data.startDate + ':' + data.startTime, 'YYYY-MM-DD HH:mm').format();
				data.endDate = moment_default()(data.endDate + ':' + data.endTime, 'YYYY-MM-DD HH:mm').format();
				setData(basePath + 'api/reservations/newReservationCost/', data).then(function (response) {
					self.priceLoading = false;
					if (response && response.data) {
						self.selectedReservation.costData = response.data;
						self.selectedReservation.cost = response.data.total;
					}
					self.loading = false;
				});
			}
		},
		closeModal: function closeModal() {
			var self = this;
			this.showModal = false;

			setTimeout(function () {
				self.showForm = false;
			}, 300);
		},
		querySelections: function querySelections(v) {
			var self = this;
			this.userLoading = true;
			var data = {
				query: v
			};
			setData(basePath + 'api/users/searchUsers/', data).then(function (response) {
				if (response && response.data) {
					self.items = response.data;
					self.searchUsersData = response.data;
				}
				self.userLoading = false;
			});
		},
		updateReservation: function updateReservation() {
			var self = this;
			// self.showLoader(true);
			if (this.$refs.reservationForm.validate()) {
				var data = {
					startDate: moment_default()(self.selectedReservation.startDate + ':' + self.selectedReservation.startTime, 'YYYY-MM-DD HH:mm').format(),
					endDate: moment_default()(self.selectedReservation.endDate + ':' + self.selectedReservation.endTime, 'YYYY-MM-DD HH:mm').format(),
					user_id: this.select ? this.select : self.selectedReservation.user_id,
					unitId: self.selectedReservation.unitId,
					kmPrice: self.selectedReservation.kmPrice,
					discount: self.selectedReservation.discount,
					freeMileage: self.selectedReservation.freeMileage,
					rentDescription: self.selectedReservation.rentDescription,
					prices: self.selectedReservation.costData.prices,
					vat: self.selectedReservation.vat,
					remarks: self.selectedReservation.remarks,
					additionalItems: self.selectedReservation.costData.additionalItems,
					tempCustomer: self.selectedReservation.tempCustomer,
					tempCustomerId: self.selectedReservation.tempCustomerId,
					useTempCustomer: self.selectedReservation.tempCustomer.useTempCustomer ? self.selectedReservation.tempCustomer.useTempCustomer : false,
					useTempForInvoice: self.selectedReservation.useTempForInvoice,
					setCustomDistance: self.selectedReservation.setCustomDistance,
					kmStart: self.selectedReservation.kmStart,
					kmEnd: self.selectedReservation.kmEnd,
					hasMaxTime: self.selectedReservation.hasMaxTime,
					fuelStart: self.selectedReservation.fuelLevel && self.selectedReservation.fuelLevel.length ? self.selectedReservation.fuelLevel[0] : 0,
					fuelEnd: self.selectedReservation.fuelLevel && self.selectedReservation.fuelLevel.length ? self.selectedReservation.fuelLevel[1] : 0,
					customDistance: self.selectedReservation.setCustomDistance ? self.selectedReservation.costData.mileage : 0
				};

				self.loading = true;

				setData(basePath + 'api/reservations/updateReservationDetails/' + this.id, data).then(function (json) {
					self.updateTime = new Date().toLocaleString();
					self.loading = false;
					self.showLoader(false);

					if (self.selectedReservation.tempCustomer.useTempCustomer === false) {
						self.selectedReservation.tempCustomer = {};
					} else {
						self.selectedReservation.tempCustomerId = json.tempCustomerId;
					}

					window.emitter.$emit('showToastMessage', {
						msg: 'Reservering opgeslagen'
					});
					setTimeout(function () {
						self.updateModel('update', self.id);
						self.getReservationCost(self.id);
					}, 100);
				});
			}
		},
		deleteReservation: function deleteReservation() {
			var self = this;
			self.loading = true;
			utils_getData(basePath + 'api/reservations/deleteReservation/' + this.id).then(function (json) {
				self.showModal = false;
				self.updateModel('update', self.id);
				window.emitter.$emit('showToastMessage', {
					msg: 'Reservering verwijderd'
				});
				self.loading = false;
				self.selectedReservation = self.emptyReservation;
			});
			this.confirm.delete = false;
		},
		endReservation: function endReservation() {
			var self = this;
			self.loading = true;
			self.showLoader(true);

			var data = {
				sendInvoice: self.sendInvoice
			};

			setData(basePath + 'api/reservations/endReservation/' + this.id, data).then(function (json) {
				if (json.data.result == '1') {
					window.emitter.$emit('showToastMessage', {
						msg: 'Reservering beëindigd'
					});
					self.updateModel('remove', self.id);
					self.loading = false;
					self.showLoader(false);
					self.showModal = false;
				} else {
					window.emitter.$emit('showToastMessage', {
						msg: 'Error',
						type: 'error'
					});
				}
			});
			this.confirm.end = false;
		},
		updateModel: function updateModel(action, reservationId) {
			window.emitter.$emit('updateReservations', {
				action: action,
				id: reservationId
			});
			this.$emit('update');
		},
		searchUser: function searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		newUser: function newUser() {
			this.$emit('newUser');
		},
		showPreInvoice: function showPreInvoice() {
			var self = this;
			utils_getData(basePath + 'api/reservations/getPreInvoice/' + this.selectedReservation.id).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadInvoice/' + json.data + '/' + self.selectedReservation.id;
			});
		},
		sendPreInvoice: function sendPreInvoice() {
			var self = this;
			this.priceLoading = true;
			utils_getData(basePath + 'api/reservations/sendPreInvoice/' + this.selectedReservation.id).then(function (json) {
				self.priceLoading = false;
				if (json && json.data) {
					window.emitter.$emit('showToastMessage', {
						msg: 'Factuur verzonden.'
					});
				}
			});
		},
		checkReservationDates: function checkReservationDates() {
			if (!moment_default()(this.selectedReservation.startDate + ' ' + this.selectedReservation.startTime, 'YYYY-MM-DD HH:mm').isBefore(moment_default()(this.selectedReservation.endDate + ' ' + this.selectedReservation.endTime, 'YYYY-MM-DD HH:mm'))) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Startdatum ligt na de einddatum',
					type: 'error'
				});
				this.saveDisabled = true;
			} else {
				this.saveDisabled = false;
			}
		},
		allowedStartDates: function allowedStartDates(val) {
			return moment_default()(val, 'YYYY-MM-DD').isBefore(moment_default()(this.selectedReservation.endDate)) || moment_default()(val, 'YYYY-MM-DD').isSame(moment_default()(this.selectedReservation.endDate), 'day');
		},
		allowedEndDates: function allowedEndDates(val) {
			return moment_default()(val, 'YYYY-MM-DD').isAfter(moment_default()(this.selectedReservation.startDate)) || moment_default()(val, 'YYYY-MM-DD').isSame(moment_default()(this.selectedReservation.startDate), 'day');
		},
		getAvailableUnits: function getAvailableUnits() {
			var self = this;
			setData(basePath + 'api/rentunits/getUnitsBySchedule/', this.selectedReservation).then(function (json) {
				if (json && json.data) {
					self.unitList = json.data;
				}
			});
		},
		showLoader: function showLoader(enable) {
			window.emitter.$emit('showLoading', {
				enable: enable,
				msg: 'Gegevens ophalen'
			});
		},
		setModalScroll: function setModalScroll(enable) {
			var el = document.getElementById('reservationsContainer');
			if (el) {
				if (!enable) {
					el.classList.add('inActiveScroll');
				} else {
					el.classList.remove('inActiveScroll');
				}
			}
		},
		updateFuelLevel: function updateFuelLevel(value) {
			this.selectedReservation.fuelLevel = value;
		},
		sendConfirmation: function sendConfirmation() {
			var self = this;
			utils_getData(basePath + 'api/reservations/sendConfirmation/' + this.selectedReservation.id).then(function (json) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Bevestiging verzonden.'
				});
			});
		},
		showAgreement: function showAgreement() {
			var self = this;
			utils_getData(basePath + 'api/users/getAgreement/' + this.selectedReservation.user_id + '/' + this.selectedReservation.id).then(function (json) {
				window.location.href = basePath + 'api/downloader/downloadAgreement/' + json.data + '/' + self.selectedReservation.id;
			});
		},
		gotoPrepaidShare: function gotoPrepaidShare() {
			var self = this;
			var data = {
				amount: this.prepaidAmount,
				rentId: this.selectedReservation.id
			};
			setData(basePath + 'api/users/setPrepaidAmount/', data).then(function (response) {
				window.location.href = self.prepaidLink + '/' + response.data;
			});
		},
		savePaidAmount: function savePaidAmount() {
			var self = this;
			var data = {
				amount: this.manualPaidAmount,
				rentId: this.selectedReservation.id
			};
			setData(basePath + 'api/users/setPaidAmount/', data).then(function (response) {
				self.manualPaidAmount = 0;
				window.emitter.$emit('showToastMessage', {
					msg: 'Betaling opgeslagen'
				});
				self.getReservationData(self.id, false);
			});
		},
		checkAmount: function checkAmount(data) {
			if (parseInt(data) < 2) {
				this.prepaidAmount = 2;
			}
		},
		setPeriod: function setPeriod(data) {
			if (data.endTime) {
				this.selectedReservation.endTime = data.endTime;
			}
			if (data.endDate) {
				this.selectedReservation.endDate = data.endDate;
			}
		},
		copyReservation: function copyReservation() {
			this.$emit('copyReservation', this.selectedReservation);
			this.showModal = false;
		},
		setMapsUrl: function setMapsUrl() {
			var self = this;
			if (self.selectedReservation.lat) {
				var pos = self.selectedReservation.lat + ',' + self.selectedReservation.lng;
				var color = 'red';
				var key = 'AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w';
				var url = '//maps.googleapis.com/maps/api/staticmap?center=' + pos + '&zoom=6&size=400x400&markers=color:' + color + '%7C' + pos + '&key=' + key;
				self.mapsUrl = url;
			} else {
				self.mapsUrl = '';
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328c8e04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservations/ReservationsModal.vue
var ReservationsModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{staticClass:"mobileFullscreen",attrs:{"fullscreen":_vm.fullscreen,"lazy":"","max-width":"900px","transition":_vm.utils.getSettings('animation')},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.showModal = false}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"compact"},[_c('v-form',{ref:"reservationForm",class:!_vm.showForm ? 'loading' : '',attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-tabs',{attrs:{"color":"blue darken-3","dark":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab,attrs:{"href":'#' + tab,"ripple":""}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(tab)+"\n\t\t\t\t\t\t"),(_vm.priceLoading && tab === 'Kostenoverzicht')?_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"white"}}):_vm._e()],1)}),_vm._v(" "),_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tabs-items',{attrs:{"touchless":_vm.showMap === true || _vm.active === 'Unitplanner'}},[_c('v-tab-item',{key:'Gegevens',attrs:{"value":'Gegevens'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tGegevens #"+_vm._s(_vm.selectedReservation.reservationNumber)+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),(_vm.updateTime)?_c('small',[_vm._v(" [Opgeslagen op: "+_vm._s(_vm.updateTime)+"]")]):_vm._e()]),_vm._v(" "),_c('v-card-text',{attrs:{"id":"scroller touchOverflow"}},[_c('v-container',{attrs:{"grid-list-md":"","px-0":""}},[_c('v-layout',{attrs:{"wrap":"","px-0":""}},[_c('v-flex',{staticClass:"pt-0",attrs:{"md7":"","xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Omschrijving","type":"text","required":"","rules":_vm.basicRules},model:{value:(_vm.selectedReservation.rentDescription),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "rentDescription", $$v)},expression:"selectedReservation.rentDescription"}})],1),_vm._v(" "),(_vm.selectedReservation.isControllable === '1')?_c('v-flex',{attrs:{"md5":"","xs12":""}},[_c('unit-control',{attrs:{"showRefresh":!_vm.priceLoading,"unitId":_vm.selectedReservation.unitId,"sensors":_vm.selectedReservation.sensors,"status":_vm.selectedReservation.status},on:{"refreshSensors":function($event){return _vm.getReservationCost(_vm.selectedReservation.id)}}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md7":"","xs12":""}},[_c('v-select',{staticClass:"dialogDropdown",attrs:{"items":_vm.selectUnits,"label":"Selecteer auto","item-text":"fullDescription","item-value":"unitId","single-line":"","menu-props":"{'contentClass':'dialogDropdown','bottom':true}"},model:{value:(_vm.unitId),callback:function ($$v) {_vm.unitId=$$v},expression:"unitId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md5":"","xs12":""}},[_c('v-checkbox',{attrs:{"label":"Alleen beschikbare"},model:{value:(_vm.onlyAvailableUnits),callback:function ($$v) {_vm.onlyAvailableUnits=$$v},expression:"onlyAvailableUnits"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":""}},[_c('v-dialog',{ref:"menu",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","width":"290px","return-value":_vm.selectedReservation.startDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "startDate", $event)}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('div',{staticClass:"blue darken-2 dark pl-3 pt-2"},[_c('h3',[_vm._v("Startdatum")])]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Startdatum","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fullStartDate),callback:function ($$v) {_vm.fullStartDate=$$v},expression:"fullStartDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"nl","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.selectedReservation.startDate);
															_vm.checkWhenModified();}},model:{value:(_vm.selectedReservation.startDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startDate", $$v)},expression:"selectedReservation.startDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Annuleren")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time","suffix":""},on:{"focus":function($event){_vm.startTimeFocus = true},"blur":function($event){_vm.startTimeFocus = false},"change":function($event){return _vm.checkWhenModified()}},model:{value:(_vm.selectedReservation.startTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "startTime", $$v)},expression:"selectedReservation.startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm5":""}},[_c('v-dialog',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","width":"290px","return-value":_vm.selectedReservation.endDate},on:{"update:returnValue":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.selectedReservation, "endDate", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('div',{staticClass:"blue darken-2 dark pl-3 pt-2"},[_c('h3',[_vm._v("Einddatum")])]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Einddatum","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fullEndDate),callback:function ($$v) {_vm.fullEndDate=$$v},expression:"fullEndDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"nl","scrollable":""},on:{"change":function($event){_vm.$refs.menu2.save(_vm.selectedReservation.endDate);
															_vm.checkWhenModified();}},model:{value:(_vm.selectedReservation.endDate),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endDate", $$v)},expression:"selectedReservation.endDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu2 = false}}},[_vm._v("Annuleren")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tijd","type":"time","suffix":""},on:{"focus":function($event){_vm.endTimeFocus = true},"blur":function($event){_vm.endTimeFocus = false},"change":function($event){return _vm.checkWhenModified()}},model:{value:(_vm.selectedReservation.endTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "endTime", $$v)},expression:"selectedReservation.endTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-checkbox',{staticClass:"maxEnd",attrs:{"label":"Max eindtijd"},on:{"change":function($event){return _vm.checkWhenModified()}},model:{value:(_vm.selectedReservation.hasMaxTime),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "hasMaxTime", $$v)},expression:"selectedReservation.hasMaxTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Kosten","type":"text","readonly":""},model:{value:(_vm.selectedReservation.cost),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "cost", $$v)},expression:"selectedReservation.cost"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Afgelegde afstand","type":"text","readonly":""},model:{value:(_vm.selectedReservation.mileage),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "mileage", $$v)},expression:"selectedReservation.mileage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Pincode tankpas","type":"text","readonly":""},model:{value:(_vm.selectedReservation.fuelCardPin),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "fuelCardPin", $$v)},expression:"selectedReservation.fuelCardPin"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Km prijs","type":"number","min":"0","step":"0.01"},on:{"change":function($event){return _vm.checkWhenModified()}},model:{value:(_vm.selectedReservation.kmPrice),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "kmPrice", $$v)},expression:"selectedReservation.kmPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Korting","type":"number","min":"0","step":"0.01"},on:{"change":function($event){return _vm.checkWhenModified()}},model:{value:(_vm.selectedReservation.discount),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "discount", $$v)},expression:"selectedReservation.discount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Km vrij","type":"number","readonly":""},model:{value:(_vm.selectedReservation.costData.totalKmFree),callback:function ($$v) {_vm.$set(_vm.selectedReservation.costData, "totalKmFree", $$v)},expression:"selectedReservation.costData.totalKmFree"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md10":""}},[_c('v-text-field',{attrs:{"label":"Gebruiker","readonly":""},model:{value:(_vm.fullName),callback:function ($$v) {_vm.fullName=$$v},expression:"fullName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.editUser = !_vm.editUser}}},[_vm._v("Wijzig")])],1),_vm._v(" "),(_vm.editUser)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"autofocus":"","label":"Zoek gebruiker","autocomplete":"false","loading":_vm.userLoading,"item-text":"Name","item-value":"user_id","placeholder":"Voornaam, achternaam, e-mail","no-data-text":_vm.search ? 'Geen resultaten' : '',"chips":"","items":_vm.items,"search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Telefoonummer","type":"text","readonly":""},model:{value:(_vm.selectedReservation.phoneno),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "phoneno", $$v)},expression:"selectedReservation.phoneno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Woonplaats","type":"text","readonly":""},model:{value:(_vm.selectedReservation.city),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "city", $$v)},expression:"selectedReservation.city"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("* verplichte velden")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Kostenoverzicht',attrs:{"value":'Kostenoverzicht'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Kostenoverzicht #"+_vm._s(_vm.selectedReservation.reservationNumber))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","px-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.selectedReservation.id)?_c('reservation-cost-details',{attrs:{"reservation":_vm.selectedReservation,"editable":true}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[(!_vm.priceLoading)?_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.$refs.viewInvoice.showDialog(
															_vm.selectedReservation,
															'view',
															true
														)}}},[_c('v-icon',[_vm._v("picture_as_pdf")]),_vm._v("Toon proforma\n\t\t\t\t\t\t\t\t\t\t\t\t")],1):_vm._e(),_vm._v(" "),(_vm.priceLoading)?_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"black"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[(!_vm.priceLoading)?_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.$refs.viewInvoice.showDialog(
															_vm.selectedReservation,
															'send',
															true
														)}}},[_c('v-icon',[_vm._v("mail")]),_vm._v("Mail proforma\n\t\t\t\t\t\t\t\t\t\t\t\t")],1):_vm._e(),_vm._v(" "),(_vm.priceLoading)?_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"black"}}):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Aanvullend',attrs:{"value":'Aanvullend'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Aanvullende gegevens")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-0":""}},[_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('fuel-slider',{attrs:{"fuelLevel":_vm.selectedReservation.fuelLevel},on:{"setFuelLevel":function($event){return _vm.updateFuelLevel($event)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Kmstand start","type":"number"},model:{value:(_vm.selectedReservation.kmStart),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "kmStart", $$v)},expression:"selectedReservation.kmStart"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Kmstand eind","type":"number"},model:{value:(_vm.selectedReservation.kmEnd),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "kmEnd", $$v)},expression:"selectedReservation.kmEnd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Km gereden","type":"number","readonly":""},model:{value:(_vm.kmDifference),callback:function ($$v) {_vm.kmDifference=$$v},expression:"kmDifference"}})],1),_vm._v(" "),_c('v-textarea',{attrs:{"name":"remarks","label":"Opmerkingen. Vul hier in","value":""},model:{value:(_vm.selectedReservation.remarks),callback:function ($$v) {_vm.$set(_vm.selectedReservation, "remarks", $$v)},expression:"selectedReservation.remarks"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Kaart',attrs:{"value":'Kaart'}},[_c('v-card',{staticStyle:{"min-height":"45vh"}},[_c('v-card-title',{on:{"click":function($event){_vm.showMap = false}}},[_c('h2',[_vm._v("Locatie")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.mapsUrl)?_c('v-img',{attrs:{"src":_vm.mapsUrl,"height":"100%"},on:{"click":function($event){_vm.showMap = true}}},[(
														_vm.showMap &&
															_vm.selectedReservation.wialonUnitId !== '0'
													)?_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{
														lat: _vm.selectedReservation.lat,
														lng: _vm.selectedReservation.lng
													},"zoom":_vm.zoomLevel,"options":{ gestureHandling: 'greedy' },"map-type-id":"terrain"}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true},on:{"click":function($event){_vm.center = m.position}}})}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.selectedReservation.wialonUnitId === '0')?_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNiet beschikbaar\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Klantgegevens',attrs:{"value":'Klantgegevens'}},[_c('v-card',[_c('v-card-text',{staticClass:"py-0"},[_c('customer-card',{attrs:{"user":_vm.selectedReservation}}),_vm._v(" "),(_vm.selectedReservation.tempCustomer)?_c('temp-customer',{attrs:{"optional":true,"user":_vm.selectedReservation.tempCustomer,"useTempForInvoice":_vm.selectedReservation.useTempForInvoice,"showInvoiceOption":true},on:{"setUseTempForInvoice":function($event){_vm.selectedReservation.useTempForInvoice = $event}}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Opties',attrs:{"value":'Opties'}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Opties")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","px-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":function($event){_vm.confirm['delete'] = true}}},[_vm._v("Verwijderen")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.sendConfirmation()}}},[_vm._v("Stuur bevestiging")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.showAgreement()}}},[_vm._v("Download overeenkomst")])],1),_vm._v(" "),(_vm.userType === 'with-site')?_c('v-flex',{staticClass:"ml-4",attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Bedrag","type":"number","min":"2"},on:{"change":function($event){return _vm.checkAmount($event)}},model:{value:(_vm.prepaidAmount),callback:function ($$v) {_vm.prepaidAmount=$$v},expression:"prepaidAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.userType === 'with-site')?_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{on:{"click":function($event){return _vm.gotoPrepaidShare()}}},[_vm._v("Deel betaallink")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"ml-4",attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Handmatige betaling toevoegen","type":"number"},model:{value:(_vm.manualPaidAmount),callback:function ($$v) {_vm.manualPaidAmount=$$v},expression:"manualPaidAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{on:{"click":function($event){return _vm.savePaidAmount()}}},[_vm._v("Opslaan")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{on:{"click":function($event){return _vm.copyReservation()}}},[_vm._v("Kopieer naar nieuwe reservering")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'Unitplanner',attrs:{"value":'Unitplanner'}},[_c('v-card',{staticStyle:{"min-height":"45vh"}},[_c('v-card-title',[_c('h2',[_vm._v("Unitplanner")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","pa-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.active === 'Unitplanner')?_c('planner',{attrs:{"selectedUnit":_vm.selectedReservation.unitId}}):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","md7":""}},[_c('v-btn',{attrs:{"color":"darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","md5":"","text-xs-right":""}},[_c('v-btn',{staticStyle:{"float":"left"},attrs:{"color":"black","dark":""},on:{"click":function($event){_vm.confirm['end'] = true}}},[_vm._v("Beëindigen")]),_vm._v(" "),(_vm.selectedReservation.closed === '0')?_c('v-btn',{attrs:{"color":"primary darken-1","disabled":!_vm.selectedReservation.costData.prices || _vm.saveDisabled},nativeOn:{"click":function($event){return _vm.updateReservation()}}},[_vm._v("Opslaan")]):_vm._e()],1)],1)],1)],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.confirm['delete'] || _vm.confirm['end']),callback:function ($$v) {_vm.$set(_vm.confirm['delete'] || _vm.confirm, 'end', $$v)},expression:"confirm['delete'] || confirm['end']"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Weet u het zeker?")]),_vm._v(" "),(_vm.confirm['delete'])?_c('v-card-text',[_vm._v("Klik op bevestigen om de reservering te verwijderen.")]):_vm._e(),_vm._v(" "),(_vm.confirm['end'])?_c('v-card-text',[_c('v-checkbox',{attrs:{"label":"Stuur factuur mee"},model:{value:(_vm.sendInvoice),callback:function ($$v) {_vm.sendInvoice=$$v},expression:"sendInvoice"}}),_vm._v("Klik op bevestigen om de reservering te beëindigen.\n\t\t\t")],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.confirm['delete'] = false;
						_vm.confirm['end'] = false;}}},[_vm._v("Annuleren")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.confirm['delete'] ? _vm.deleteReservation() : _vm.endReservation()}}},[_vm._v("Bevestigen")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":true,"timeout":2000},model:{value:(_vm.showMessage),callback:function ($$v) {_vm.showMessage=$$v},expression:"showMessage"}},[_vm._v("\n\t\t"+_vm._s(_vm.msg)+"\n\t\t"),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showMessage = false}}},[_vm._v("Sluiten")])],1),_vm._v(" "),_c('view-invoice',{ref:"viewInvoice",attrs:{"customDate":true}})],1)}
var ReservationsModal_staticRenderFns = []
var ReservationsModal_esExports = { render: ReservationsModal_render, staticRenderFns: ReservationsModal_staticRenderFns }
/* harmony default export */ var Reservations_ReservationsModal = (ReservationsModal_esExports);
// CONCATENATED MODULE: ./src/components/Reservations/ReservationsModal.vue
var ReservationsModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReservationsModal___vue_template_functional__ = false
/* styles */
var ReservationsModal___vue_styles__ = null
/* scopeId */
var ReservationsModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReservationsModal___vue_module_identifier__ = null
var ReservationsModal_Component = ReservationsModal_normalizeComponent(
  ReservationsModal,
  Reservations_ReservationsModal,
  ReservationsModal___vue_template_functional__,
  ReservationsModal___vue_styles__,
  ReservationsModal___vue_scopeId__,
  ReservationsModal___vue_module_identifier__
)

/* harmony default export */ var components_Reservations_ReservationsModal = (ReservationsModal_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













vue_esm["default"].component('reservations-modal', components_Reservations_ReservationsModal);

vue_esm["default"].component('planner', components_Planner_Planner);



__webpack_require__("O5me");
__webpack_require__("7zck");
__webpack_require__("20kk");

window.emitter = new vue_esm["default"]();
vue_esm["default"].config.productionTip = false;
vue_esm["default"].component("table-loader", src_components_TableLoader);
vue_esm["default"].use(vuetify_default.a);
vue_esm["default"].use(vue_fuse["a" /* default */]);
vue_esm["default"].use(vue_underscore["b" /* default */]);
vue_esm["default"].use(utils_namespaceObject);
vue_esm["default"].use(vueWysiwyg_default.a, {
	hideModules: {
		table: true
	}
});

// todo verplaatsen
vue_esm["default"].filter('toCurrency', function (value) {
	if (!value) {
		return '';
	} else {
		return getFormattedAmount(value);
	}
});

vue_esm["default"].use(main, {
	load: {
		key: "AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w",
		libraries: "places",
		language: "nl"
	}
});

window.pullConfig = {
	errorLabel: "Error",
	startLabel: "Bijwerken..",
	readyLabel: "Laat los om bij te werken..",
	loadingLabel: "Gegevens op halen.."
};

/* eslint-disable no-new */
new vue_esm["default"]({
	el: "#app",
	router: router,
	template: "<App/>",
	components: {
		App: src_App,
		UserModal: components_Users_UserModal
	}
});

function getHiddenProp() {
	var prefixes = ["webkit", "moz", "ms", "o"];

	// if 'hidden' is natively supported just return it
	if ("hidden" in document) return "hidden";

	// otherwise loop over all the known prefixes until we find one
	for (var i = 0; i < prefixes.length; i++) {
		if (prefixes[i] + "Hidden" in document) return prefixes[i] + "Hidden";
	}

	// otherwise it's not supported
	return null;
}

window.addEventListener("load", function visChange() {
	sessionStorage.initialPlay = false;

	var visProp = getHiddenProp();
	if (visProp) {
		var evtName = visProp.replace(/[H|h]idden/, "") + "visibilitychange";
		document.addEventListener(evtName, reloadData);
	}

	// Reload data when tab was hidden
	function reloadData() {
		if (document[visProp]) {
			window.emitter.$emit("hidden");
			console.log('hidden');
		} else if (window.emitter) {
			// update reservations
			console.log('update');
			window.emitter.$emit("windowVisible");
			window.emitter.$emit("updateReservations");
			window.emitter.$emit("checkVersion");
		}
	}

	// Thunderpush
	//Thunder.connect("192.168.2.7:8000", "publickey", ["secret"], {log: false});
	//Thunder.listen(function(data) {  window.emitter.$emit('showPushNotification',{msg:data.msg, id: data.id});});
});

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O5me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "POKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-resize-sensor/src/resize-sensor.vue
//
//
//
//
//
//



/* harmony default export */ var resize_sensor = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-resize-sensor/src/resize-sensor.vue
function injectStyle (ssrContext) {
  __webpack_require__("8Y90")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resize_sensor,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_resize_sensor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UaRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V558":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aAJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kRMa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mF/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nkFh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "noQt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sUTh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uii8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wK/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-fuse/src/VueFuse.vue




/* harmony default export */ var VueFuse = ({
  name: 'VueFuse',
  data: function data() {
    return {
      fuse: null,
      value: '',
      result: []
    };
  },

  props: {
    placeholder: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    eventName: {
      type: String,
      default: 'fuseResultsUpdated'
    },
    inputChangeEventName: {
      type: String,
      default: 'fuseInputChanged'
    },
    defaultAll: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    includeScore: {
      type: Boolean,
      default: false
    },
    includeMatches: {
      type: Boolean,
      default: false
    },
    tokenize: {
      type: Boolean,
      default: false
    },
    matchAllTokens: {
      type: Boolean,
      default: false
    },
    findAllMatches: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    shouldSort: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.6
    },
    location: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 100
    },
    maxPatternLength: {
      type: Number,
      default: 32
    },
    minMatchCharLength: {
      type: Number,
      default: 1
    },
    keys: {
      type: Array
    }
  },
  computed: {
    options: function options() {
      var options = {
        caseSensitive: this.caseSensitive,
        includeScore: this.includeScore,
        includeMatches: this.includeMatches,
        tokenize: this.tokenize,
        matchAllTokens: this.matchAllTokens,
        findAllMatches: this.findAllMatches,
        shouldSort: this.shouldSort,
        threshold: this.threshold,
        location: this.location,
        distance: this.distance,
        maxPatternLength: this.maxPatternLength,
        minMatchCharLength: this.minMatchCharLength,
        keys: this.keys
      };
      if (this.id !== '') {
        options.id = this.id;
      }
      return options;
    }
  },
  watch: {
    list: function list() {
      this.fuse.list = this.list;
      this.fuseSearch();
    },
    search: function search() {
      this.value = this.search;
    },
    value: function value() {
      this.$parent.$emit(this.inputChangeEventName, this.value);
      this.fuseSearch();
    },
    result: function result() {
      this.$parent.$emit(this.eventName, this.result);
    }
  },
  methods: {
    initFuse: function initFuse() {
      this.fuse = new fuse_default.a(this.list, this.options);
      if (this.defaultAll) {
        this.result = this.list;
      }
      if (this.search) {
        this.value = this.search;
      }
    },
    fuseSearch: function fuseSearch() {
      if (this.value.trim() === '') {
        if (this.defaultAll) {
          this.result = this.list;
        } else {
          this.result = [];
        }
      } else this.result = this.fuse.search(this.value.trim());
    }
  },
  ready: function ready() {
    this.initFuse();
  },
  mounted: function mounted() {
    this.initFuse();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-630a6cb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-fuse/src/VueFuse.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_VueFuse = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-fuse/src/VueFuse.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  VueFuse,
  src_VueFuse,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_fuse_src_VueFuse = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wb7k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xxT8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6f1100a23fd62161e989.js